import React, { Fragment, useContext } from 'react'
import { isEqual } from 'lodash'
import { Buffer } from 'buffer'

// contexts
import TxStateContext, { sendtx_status } from '../TxStateContext.js'
import GlobalErrorContext from '../GlobalErrorContext.js'
import RunContext from '../RunContext.js'
import RuncraftContext from '../RuncraftContext.js'
// components
import { confirmPopup } from '../../components/confirmPopup.js'
// helpers
import { get_cached_BSVEUR_price } from "../../helpers/bsveur"
import OraclesUtils from "../../RunCraft/OraclesUtils.js"
import CustomBlockchain from "../../shared/CustomBlockchain.js"
import { resetSharedWhatsOnChainConnector, waitForSharedWhatsOnChainConnector } from "../../shared/WhatsOnChainConnector.js"
import { prepopulated_cache } from "../../resources/caches/prepopulated_cache.js"
import RunFileStore, { get_store_WalletHistoryCache } from '../../RunFileStore.js'
import WalletHistoryCache, { DevBrowserCacheIdb } from "../../WalletHistoryCache"
import BsvHistoryCache from "../../BsvHistoryCache"
import {
	deepcopy, timestamp_to_ms, getLogArray, unprefix_address, getLog, isElectron,
	get_all_files_paths_from_cache, devMode_fake_walletBackups,
	filterSerializable,
} from "../../helpers/helpers"
import { BSVTooSmallSendAmountError, NotEnoughBSVError } from '../../Errors/errors_bsv.js'
import NoFetchBlockchain from '../../shared/NoFetchBlockchain.js'

import { get_tx_history } from "./get_history"
import { toFixedDown } from '../../helpers/convert_bsv_tokens.js'
import { processOneTxData } from "../../pages/Slide_History/processOneBsvTxData.js"
import Constants, { TOKKENR_NODE_HOST_URL, appConfig } from '../../config.js'


/*
RUN creator said:
"Regarding the purse, if you set run.purse.jigFilter = false, the purse will happily spend jigs now!
(It's prob not going to be a documented feature, but people might discover it from the source code,
which is coming along towards a release this year)""
*/

//
// ------------------------  MANUAL VARS --------------------------
//

const TURNOFF_CHECK_CONTRACT_REVOKED = false  // leave at false, set at true only for debug if needed

// should we clear the disk cache on execution ? BEWARE ONLY USE TRUE IN DEVELOPMENT
export const CLEAR_FILESTORE = false

const NB_SPLITS = 2

let trustmode = 'state'  // "cache" was deprecated for "state"

var defaultrunnetwork = "main" 	// main or test

// var defaultrunapi = "run" 	// deprecated since run_0.6.42
var defaultrunapi = "whatsonchain"

var API_KEY = "" // TODO we need to deprecate that 

// const app_field = "b1b605103e"  // first 10 chars of sha256("delphe") to idendify our run txs
const app_field = "runcraft.io"

var simulatelongloadingtime = 0 		// in ms, simulates time to load & sync the wallet, ex:5000
export var test_runnotresponding = false	// simulates if run times out
var test_tokenoriginjig_notresponding = false	// test tokenoriginjig not loading
var test_multlistfails = false	// simulates get_multlist returning null
var test_needtoconverttokens = false	// will show screen of converting tokens to a new contract

var offset_ownerprivkey = 6		// to wipe out previous owner wallets DO NOT DO THIS ONCE IN PRODUCTION it will wipe out all the users' addresses
// WALLET_VERSION is stored alongside the encrypted mnemonic so future key-derivation
// changes can be migrated explicitly instead of silently breaking all existing wallets.
// It must always equal offset_ownerprivkey at the time the wallet was created.
const WALLET_VERSION = offset_ownerprivkey

// --- encrypted wallet blob storage keys & TTLs ---
// The mnemonic is encrypted with the user's password (same AES scheme as generateBackupFile)
// and stored as a blob. Raw privkeys are NEVER persisted to sessionStorage/localStorage.
// - SESSION_WALLET_KEY (sessionStorage): keeps the user logged in across refresh, cleared on tab close.
// - REMEMBERED_WALLET_KEY (localStorage): opt-in "remember on this device", persists across browser restart.
const SESSION_WALLET_KEY = 'tokkenr_session_wallet'
const REMEMBERED_WALLET_KEY = 'tokkenr_remembered_wallet'
const SESSION_WALLET_TTL_MS = 60 * 60 * 1000       // 1 hour (same as previous userContextState TTL)
const REMEMBERED_WALLET_TTL_MS = 30 * 24 * 60 * 60 * 1000  // 30 days

const TIMESTAMP_NBMINS_MARGIN = 140		// X minutes of margin, how much to tolerate for the user-specified timestamp before taking the block timestamp instead
// BEWARE YOU CANNOT SET TIMESTAMP_NBMINS_MARGIN BELOW 120 UNTIL WE ARE SURE THAT THE LONGEST BLOCKS that include ALL mempool txs DO NOT OCCUR MORE OFTEN, 140 is about right as of 14.10.2020
// block 656705 and 656704 => 656705 included tx that were sent in 656703 => 124 mins before

const minutes_ms = 60 * 1000
// const RUN_TIMEOUT_MS = 20*minutes_ms		// note: inventory sync can take quite a lot of time, 20 mins seems good
const RUN_TIMEOUT_MS = 10 * minutes_ms		// note: inventory sync can take quite a lot of time, 10 mins seems good

// variables for delay to sync run
export var tryduring_ms = RUN_TIMEOUT_MS 	// in ms, wait 10 seconds max to load
export var retryevery_ms = 700 			// in ms, retry every 100 ms

/* minimum delay between 2 *real* inventory_sync() network syncs.
	this fixes a "sync storm" bug where a single send-tx flow (sendtx_Token/mint_tokens/burn_tokens)
	could trigger 3+ full inventory reloads back-to-back (each one re-fetching ~30 jigs and firing
	hundreds of spends() API calls), because get_utxos_for_nbtokens() -> get_all_tokenJigs() ->
	inventory_sync() gets called multiple times in a row within the same flow.
	if a sync just completed within this window and nobody flagged a need for a fresher one
	since, we skip hitting the network again (see inventory_sync() below). */
const INVENTORY_SYNC_MIN_INTERVAL_MS = 1500

const MAX_NB_UPDATE_RUN_FAILS = 3
var NB_UPDATE_RUN_FAILS = 0	// leave at 0

// should we automatically sync inner jigs ? should be true unless you have infinite loops on sync
const SYNC_INNER = true  	// BEWARE IF SET TO FALSE IT WILL CREATE StateError: [jig RevokerContract] not found in the transaction txid: ...

// add those if trustall is set to false, use txids without "_o1"
const trusted_refs = [
	// for delphe tokenorigin ?
	"f0fe0589947d9455fa25cefcbe42e661db6ca3e3fe84c60ac0571f39b8c174eb",
	"27b82db15bcac821e27f2769fcca88eff7a423f3a7ff03a9dab35fcd9a514a60",
	"385ebd22491817fa6907e2ef155068ef1101b76200c6d5d651466f3628b6a1aa",
	"5cd48162617640673a36560cc89c146fae769eaa51acae57e567eb4191cedcf0",
	"a8f0da261aec74c1c79a63cbae8f8c3f20ccee5792c535b21d957a297ecb3074",
	"bb5535208321614d8e0121e2651c63271b8400929013dfea2dbf55047689113e",
	"d71f658aedc4b78ccf0de30bbd162a2ec3625fb3d10a03086101bd32a61e66f8",

	// only for test on tokenorigin=a7e7bacc955e34b44e18a907d3...
	"4ae9914329ad8f4ac55a6c4dc7d0ab6d26f15ab556f98dffefae899e80078f06",

	// swapbot
	"08c7be63435752e16ec3d5800eacfaf423fb97bd3de74c6775f36d505884f0e5",
]

// bsv to retrieve from: delphe faiblir pelage excitant négation vortex absurde caviar guerrier replier théorie abroger affiche

// ---- HARDCODED SMARTCONTRACT ORIGIN ----------
//
// --- TESTNET ---
//
var default_tokenorigin_testnet = "c64d18e1cb501980f7a30aa3b6aee24d6725297c22e2f11a4346cf509e5c61ea_o1"

//
// --- MAINNET ---
//
var default_token_origin_mainnet = "f597770adc303efe702fcc1497b87703d166adc9d2a5a4cd8e92c571b2324201_o1"
// latest known location of the above origin, loads in 4.3 secs instead of 9 with the origin
// TODO on top of this hardcoded location we should cache the latest known in the wallet cache
var latest_token_location_mainnet = "99d7d6adcc85d60d8ea0036618bb35fbb93c1c2148ddfed7ba9bb1d95423611b_o1"


//  --------- AUTOLOGIN (practical in browser dev mode with auto-reload) --------
//
//	beware: if a wallet is loaded (new wallet created or something else)
//	then it will take priority over these values
//	these values are for when there is no other wallet loaded => for dev only	

// MAINNET

// test with clients swapbot0
var default_privatekey_owner = "" // "12xRS4tNHSQJqUTfXZ2Zts8iBA2xPi4qMa"
var default_privatekey_purse = ""

var default_tokenorigin = default_token_origin_mainnet
//run.0.5 v2 TESTNET
if (defaultrunnetwork === "test") {

	default_privatekey_owner = ""
	default_privatekey_purse = "" // bsv:n3h9L34NemdTJANHh6mWioFW1H81Do3G9d

	default_tokenorigin = default_tokenorigin_testnet
}

//
// --------------- end of: manual vars --------------------
//






// default to 3 retries, with a 500ms retry delay + only retry on network errors
var fetch = require('node-fetch')
// commenting because it seems better to handle the retries at each individual level
// fetch = require('fetch-retry')(fetch, {
// 	retries: 5,
// 	retryDelay: 500,
// })

export const trustall = (trustmode === '*')
// const IS_IN_PRODUCTION = (process.env.NODE_ENV === "production")
const IS_IN_PRODUCTION = !Constants.IS_WEB_BUILD
const log = (...args) => { console.log("UserContext.js:", ...args) }
log("IS_IN_PRODUCTION = " + IS_IN_PRODUCTION)

if (IS_IN_PRODUCTION) {
	// let's make sure users never access the default dev wallet
	default_privatekey_owner = null
	default_privatekey_purse = null
}

// load RUN through webpack externals
const Run = require("runlib")
const retry = require("async-retry")
window.Run = Run

// make sure you load 'bsv' from externals or it could be incompatible with Run
const bsv = require('bsv')

const Mnemonic = require('bsv-mnemonic')
// var code = new Mnemonic(window.Mnemonic.Words.FRENCH);
window.Mnemonic = Mnemonic

const CryptoJS = require("crypto-js")
import { encryptMnemonic, decryptMnemonic, isArgon2Blob } from "../../helpers/wallet_crypto"
import { checkPasswordStrength } from "../../helpers/password_strength"
const RunTools = window.RunTools

// BEWARE NEVER EVER LOG USERCONTEXT (or run) BECAUSE IT CONTAINS PRIVATE KEYS !
export const UserContext = React.createContext("")

/* beware this.state.truc after setState() is not updated ! because setState() is async
	cf https://reactjs.org/docs/react-component.html#setstate */


/**
* this is needed to pass the higher contexts as props
* to the UserContextProvider (which becomes "_inner")
*/
export const UserContextProvider = (props) => {
	const globalErrorContext = useContext(GlobalErrorContext)
	const runContext = useContext(RunContext)
	const runcraftContext = useContext(RuncraftContext)
	const txStateContext = useContext(TxStateContext)

	return (
		<UserContextProviderInner
			globalErrorContext={globalErrorContext}
			runContext={runContext}
			runcraftContext={runcraftContext}
			txStateContext={txStateContext}
			{...props}
		/>
	)
}

/* this is to standardize with a SSOT all allowed coins & their characteristics
for now we are handling the list manually, we will see later how to make it dynamic
TODO we should use these everywhere & then in each Slide retrieve those from userContext with get_selected_coin_props()
*/
const backgroundColor = appConfig.theme.backgroundColorLighter1
export const ALLOWED_COINS = {
	[default_token_origin_mainnet]: {
		tokenid: default_token_origin_mainnet,
		name_short: "delphe",  // lowercase slug for display (must be all lowercase, no casing)
		name: "Delphe",  // this should be a longer version of the name with casing
		// name_plural: "Delphes",  // with casing, for plural version (if you want one, otherwise put the same as name)
		ticker: "DPH",  // usually in full high case
		color: "#bb031d",  // should be an hex value (or at least css-compatible)
		logo: Constants.IMAGES.delphe_logo,
		logo_banner: Constants.IMAGES.delphe_logo_banner,
		class_origin: default_token_origin_mainnet,
		// background_css: "linear-gradient(334.78deg, #5d3333 0%, #3d3d3d 68.54%)",
		background_css: "linear-gradient(334.78deg, #5d3333 0%, " + backgroundColor + " 68.54%)",
	},
	bsv: {
		tokenid: 'bsv',
		name_short: "bsv",
		name: "Bitcoin SV",
		// name_plural: "BSV",
		ticker: "BSV",
		color: "#e8b21f",
		logo: Constants.IMAGES.bsv_logo,
		logo_banner: Constants.IMAGES.bsv_logo,
		class_origin: null, // not applicable
		// background_css: "linear-gradient(334.78deg, #726939 0%, #3d3d3d 68.54%)",
		background_css: "linear-gradient(334.78deg, #726939 0%, " + backgroundColor + " 68.54%)"
	},
}
// for safety we enforce that .name_short must absolutely be lowercased
if (Object.values(ALLOWED_COINS).some(e => e.name_short.toLowerCase() != e.name_short)) {
	throw new Error("in ALLOWED_COINS .name_short must absolutely be lowercased !")
}
export const ALLOWED_COINS_KEYS = Object.keys(ALLOWED_COINS)
console.log("ALLOWED_COINS_KEYS=", ALLOWED_COINS_KEYS)


/**
 * returns the default/"loading" values for all wallet-specific financial & history state fields.
 * used both for the initial state (constructor) and whenever we switch to a different wallet
 * (update_from_mnemonic_noreload, create_new_wallet) so stale data from a previous wallet never
 * lingers on screen until the new wallet's reload_wallet() finishes re-fetching everything.
 */
function get_default_walletdata_state() {
	return {
		nbjigs: null,
		nbcodes: null,

		balance_bsv: null,
		tokens_balance: {},	 // object of 1 token-type => 1 token balance

		ownerIsAdmin: null,
		tokensupply: null,

		tokens_txdata: null,

		multlist_list: null,
		multlist_timestamps: null,
		total_mult: null,

		blacklist2d: null,
		revokerJig: null,

		tokenoriginjig_decimals: null,

		revokedetected: false,  // true if a need to revoke detected, turns false once the process is over
		revokedetected_error: null,
	}
}


class UserContextProviderInner extends React.PureComponent {

	/* BEWARE USE throwContextError() and throwRunError()
	  -- not throw() for errors OR YOU WILL GET INFINITE LOADING ! */

	constructor(props) {
		super(props);

		this.globalErrorContext = props.globalErrorContext
		this.runContext = props.runContext
		this.runcraftContext = props.runcraftContext
		this.txStateContext = props.txStateContext

		this.get_tx_history = get_tx_history.bind(this)

		this.classname = "UserContext: "

		this.errormess = ""
		this.loaders = []
		this.loaders_res = []
		this.isloading = true // only for the global loading button, do a forceUpdate() when updating it since it's not in state

		// DO NOT USE THIS because it may be null => use await get_tokenoriginjig() instead
		this.tokenoriginjig = null

		// --- locks/state for inventory_sync(), see its doc comment for details ---
		this.is_inventory_syncing = false
		this.need_inventory_sync = false
		this.inventory_sync_promise = null
		this.last_inventory_sync_end_time = 0

		// --- locks/state for get_tokenoriginjig(), see its doc comment for details ---
		this.is_getting_tokenoriginjig = false
		this.get_tokenoriginjig_promise = null

		this.history_size = null // for get_history_loading_progress()
		this.history_nbloaded = null

		this.reloadCount = 0 // if you need to know if the context asked for a reload, compare cached value to current one using .get_reload_count()


		// ------------------ BINDINGS -------------------------
		//

		this.resetGlobalError = this.resetGlobalError.bind(this)

		//this.load_wallet 					= this.load_wallet.bind(this)
		this.reload_wallet = this.reload_wallet.bind(this)
		this.create_new_wallet = this.create_new_wallet.bind(this)
		this.generate_new_wallet = this.generate_new_wallet.bind(this)
		this.set_pending_wallet = this.set_pending_wallet.bind(this)
		this.clear_pending_wallet = this.clear_pending_wallet.bind(this)
		this.commit_wallet = this.commit_wallet.bind(this)
		this.get_mnemonic_or_devmode = this.get_mnemonic_or_devmode.bind(this)
		this.throwContextError = this.throwContextError.bind(this)
		//  this.get_run 						= this.get_run.bind(this)
		//  this.get_Runcraft 				    = this.get_Runcraft.bind(this)
		this.get_total_mult = this.get_total_mult.bind(this)
		this.get_token_balance = this.get_token_balance.bind(this)
		this.reload_all_contracts = this.reload_all_contracts.bind(this)
		this.publish_mult = this.publish_mult.bind(this)
		this.get_multlistjig_synced = this.get_multlistjig_synced.bind(this)
		this.get_multlist = this.get_multlist.bind(this)
		this.get_tokenoriginjig = this.get_tokenoriginjig.bind(this)
		this.get_revokerjig = this.get_revokerjig.bind(this)
		this.get_multlist_dates = this.get_multlist_dates.bind(this)
		this.syncWallet_nForceRerender = this.syncWallet_nForceRerender.bind(this)
		this.setStateSafe = this.setStateSafe.bind(this)
		this.update_wallet_name = this.update_wallet_name.bind(this)
		this.change_network_noreload = this.change_network_noreload.bind(this)
		this.generateBackupFile = this.generateBackupFile.bind(this)
		//this.update_fullkey_noreload 	= this.update_fullkey_noreload.bind(this)
		this.split_fullkey = this.split_fullkey.bind(this)
		this.change_network_andreload = this.change_network_andreload.bind(this)
		this.get_multlist_timestamps = this.get_multlist_timestamps.bind(this)
		// this.get_tx_history = this.get_tx_history.bind(this)
		this.update_bsv_price = this.update_bsv_price.bind(this)
		this.get_utxos_for_nbtokens = this.get_utxos_for_nbtokens.bind(this)
		this.blacklist_address = this.blacklist_address.bind(this)
		this.update_contract_origin_and_reload = this.update_contract_origin_and_reload.bind(this)
		this.forceReRender = this.forceReRender.bind(this)
		this.revokerContract_freeze = this.revokerContract_freeze.bind(this)
		this.revokerContract_backup = this.revokerContract_backup.bind(this)
		this.revokerContract_revoke = this.revokerContract_revoke.bind(this)
		this.ownerIsAdmin = this.ownerIsAdmin.bind(this)
		this.reset_wallet = this.reset_wallet.bind(this)
		this.update_from_mnemonic_noreload = this.update_from_mnemonic_noreload.bind(this)
		this.init_run_and_caches_from_privkeys = this.init_run_and_caches_from_privkeys.bind(this)
		this.setWalletPassword = this.setWalletPassword.bind(this)
		this.save_session_encrypted_wallet = this.save_session_encrypted_wallet.bind(this)
		this.unlock_wallet_from_password = this.unlock_wallet_from_password.bind(this)
		this.verifyWalletPassword = this.verifyWalletPassword.bind(this)
		this.change_wallet_password = this.change_wallet_password.bind(this)
		this.dismiss_weak_password_warning = this.dismiss_weak_password_warning.bind(this)
		this.clear_session_encrypted_wallet = this.clear_session_encrypted_wallet.bind(this)
		this.clear_remembered_encrypted_wallet = this.clear_remembered_encrypted_wallet.bind(this)
		this.has_remembered_wallet = this.has_remembered_wallet.bind(this)
		this.get_pending_unlock_info = this.get_pending_unlock_info.bind(this)
		this.get_newpassword_previous = this.get_newpassword_previous.bind(this)
		this.update_newpassword_previous = this.update_newpassword_previous.bind(this)
		this.getTokenSupply = this.getTokenSupply.bind(this) // don't debounce
		this.get_final_timestamp_and_blockheight = this.get_final_timestamp_and_blockheight.bind(this)
		this.get_timestamp_from_blockheight = this.get_timestamp_from_blockheight.bind(this)
		this.get_latest_height_from_blockchain = this.get_latest_height_from_blockchain.bind(this)
		this.get_blacklist2d = this.get_blacklist2d.bind(this)
		this.clearCache = this.clearCache.bind(this)
		this.burn_tokens = this.burn_tokens.bind(this)
		this.burn_tokens_all = this.burn_tokens_all.bind(this)
		this.get_reload_count = this.get_reload_count.bind(this)

		//functions for loading & debouncing
		this.launch_function_with_loaders = this.launch_function_with_loaders.bind(this) // do not debounce this function !
		this._startloading = this._startloading.bind(this) // do not debounce this function !
		this._stoploading = this._stoploading.bind(this) // do not debounce this function !
		this.get_loader_res = this.get_loader_res.bind(this) // do not debounce this function !

		this.get_history_loading_progress = this.get_history_loading_progress.bind(this) // do not debounce, not async!
		this.check_revokestate_and_convertifneeded = this.check_revokestate_and_convertifneeded.bind(this) // do not debounce this function !
		this._load_reloaded_tokenorigin = this._load_reloaded_tokenorigin.bind(this) // private, don't put in state

		this.sendtx_BSV = this.sendtx_BSV.bind(this)
		this.sendtx_Token = this.sendtx_Token.bind(this)

		this.send_revokerContract = this.send_revokerContract.bind(this)
		this.update_balance_bsv = this.update_balance_bsv.bind(this)
		this.inventory_sync = this.inventory_sync.bind(this)
		this.get_run_cache = this.get_run_cache.bind(this)
		this.update_disable_all_sync = this.update_disable_all_sync.bind(this)

		this.update_selected_coin = this.update_selected_coin.bind(this)
		this.get_selected_coin_props = this.get_selected_coin_props.bind(this)
		this.get_coin_props = this.get_coin_props.bind(this)

		this.reset_cache_history_bsv = this.reset_cache_history_bsv.bind(this)
		this.reload_bsv = this.reload_bsv.bind(this)
		this.reload_token = this.reload_token.bind(this)

		//  this.update_contract_generic = this.update_contract_generic.bind(this)
		//
		// ------------------ END OF BINDINGS -------------------------


		// ------------------ DEBOUNCING -------------------------
		//
		// we transform each function by one that is debounced by wrapping it with loaders

		const old_get_tokenoriginjig = this.get_tokenoriginjig
		this.get_tokenoriginjig = (...args) =>
			this.launch_function_with_loaders(old_get_tokenoriginjig, "get_tokenoriginjig", ...args)

		const old_reload_all_contracts = this.reload_all_contracts
		this.reload_all_contracts = (...args) =>
			this.launch_function_with_loaders(old_reload_all_contracts, "reload_all_contracts", ...args)

		const old_get_token_balance = this.get_token_balance
		this.get_token_balance = (...args) =>
			this.launch_function_with_loaders(old_get_token_balance, "get_token_balance", ...args)

		const old_get_total_mult = this.get_total_mult
		this.get_total_mult = (...args) =>
			this.launch_function_with_loaders(old_get_total_mult, "get_total_mult", ...args)

		const old_get_multlistjig = this.get_multlistjig_synced
		this.get_multlistjig_synced = (...args) =>
			this.launch_function_with_loaders(old_get_multlistjig, "get_multlistjig", ...args)

		const old_get_revokerjig = this.get_revokerjig
		this.get_revokerjig = (...args) =>
			this.launch_function_with_loaders(old_get_revokerjig, "get_revokerjig", ...args)

		const old_publish_mult = this.publish_mult
		this.publish_mult = (...args) =>
			this.launch_function_with_loaders(old_publish_mult, "publish_mult", ...args)

		const old_get_multlist = this.get_multlist
		this.get_multlist = (...args) =>
			this.launch_function_with_loaders(old_get_multlist, "get_multlist", ...args)

		const old_get_multlist_timestamps = this.get_multlist_timestamps
		this.get_multlist_timestamps = (...args) =>
			this.launch_function_with_loaders(old_get_multlist_timestamps, "get_multlist_timestamps", ...args)

		const old_get_multlist_dates = this.get_multlist_dates
		this.get_multlist_dates = (...args) =>
			this.launch_function_with_loaders(old_get_multlist_dates, "get_multlist_dates", ...args)

		const old_create_new_wallet = this.create_new_wallet
		this.create_new_wallet = (...args) =>
			this.launch_function_with_loaders(old_create_new_wallet, "create_new_wallet", ...args)

		/* const old_load_wallet = this.load_wallet
		this.load_wallet = (...args) => this.launch_function_with_loaders(old_load_wallet, "load_wallet", ...args) */

		const old_update_bsv_price = this.update_bsv_price
		this.update_bsv_price = (...args) =>
			this.launch_function_with_loaders(old_update_bsv_price, "update_bsv_price", ...args)

		const old_change_network_andreload = this.change_network_andreload
		this.change_network_andreload = (...args) =>
			this.launch_function_with_loaders(old_change_network_andreload, "change_network_andreload", ...args)

		const old_syncWallet_nForceRerender = this.syncWallet_nForceRerender
		this.syncWallet_nForceRerender = (...args) =>
			this.launch_function_with_loaders(old_syncWallet_nForceRerender, "syncWallet_nForceRerender", ...args)

		const old_get_tx_history = this.get_tx_history
		this.get_tx_history = (...args) =>
			this.launch_function_with_loaders(old_get_tx_history, "get_tx_history", ...args)

		const old_get_utxos_for_nbtokens = this.get_utxos_for_nbtokens
		this.get_utxos_for_nbtokens = (...args) =>
			this.launch_function_with_loaders(old_get_utxos_for_nbtokens, "get_utxos_for_nbtokens", ...args)

		const old_blacklist_address = this.blacklist_address
		this.blacklist_address = (...args) =>
			this.launch_function_with_loaders(old_blacklist_address, "blacklist_address", ...args)

		const old_reload_wallet = this.reload_wallet
		this.reload_wallet = (...args) =>
			this.launch_function_with_loaders(old_reload_wallet, "reload_wallet", ...args)

		const old_get_blacklist2d = this.get_blacklist2d
		this.get_blacklist2d = (...args) =>
			this.launch_function_with_loaders(old_get_blacklist2d, "get_blacklist2d", ...args)

		const old_clearCache = this.clearCache
		this.clearCache = (...args) =>
			this.launch_function_with_loaders(old_clearCache, "clearCache", ...args)

		const old_burn_tokens_all = this.burn_tokens_all
		this.burn_tokens_all = (...args) =>
			this.launch_function_with_loaders(old_burn_tokens_all, "burn_tokens_all", ...args)

		const old_burn_tokens = this.burn_tokens
		this.burn_tokens = (...args) =>
			this.launch_function_with_loaders(old_burn_tokens, "burn_tokens", ...args)

		const old_reload_bsv = this.reload_bsv
		this.reload_bsv = (...args) =>
			this.launch_function_with_loaders(old_reload_bsv, "reload_bsv", ...args)

		const old_reload_token = this.reload_token
		this.reload_token = (...args) =>
			this.launch_function_with_loaders(old_reload_token, "reload_token", ...args)

		// ------------------ end of: debouncing -------------------------
		//

		/* reminder: only put in state values used for rendering or dataflow
			BEWARE SETSTATE() WILL ALWAYS TRIGGER A RE-RENDER
			SO ONLY CALL IT AFTER VERIFYING STATE IS DIFFERENT THAN THE GOAL
		*/

		// we need to declare the state AFTER the debouncing otherwise the functions in the state will not be the debounced versions!
		this.state = {
			// default values
			privkey_owner: default_privatekey_owner,  // for dev mode
			privkey_purse: default_privatekey_purse,  // for dev mode
			network: defaultrunnetwork,
			runapi: defaultrunapi,
			tokenorigin: default_tokenorigin,
			SYNC_INNER: SYNC_INNER,
			walletname: "",
			bsvprice: null,  // bsveur
			mnemonic: "",
			globalError: null,

			// weak-password warning: set after unlock/load if the password
			// scores <= 1 (Weak). Cleared on change_wallet_password or manual
			// dismiss. Persists across refresh (in sessionStorage via
			// userContextState allowlist) until changed.
			weak_password_warning: null,

			// wallet-specific financial & history data, shared with update_from_mnemonic_noreload() / create_new_wallet()
			...get_default_walletdata_state(),

			address_owner: "",
			address_purse: "",
			// balance_delphe: null,

			create_new_wallet_ready: true,  // tells if the stack of "create_new_wallet" is at 0

			inventory_synced_atLeastOnce: false,  // for swapbotContext initial loading

			disable_all_sync: false,  // only for the worst cases if all the nodes/APIs stop answering & we still need to broadcast some transactions

			selected_coin: default_token_origin_mainnet,  // currently selected coin for all slides

			/* reminders:
				- if you use an array in state, use array.concat() to push to it,
					cf https://www.robinwieruch.de/react-state-array-add-update-remove
=				- if you use an object in state, use this.setState({myobj: {...this.state.myobj, xyz:"new val"}})
			*/

			// functions to update the context
			// get_run: 							this.get_run,
			// get_Runcraft: 					    this.get_Runcraft,
			//load_wallet: 						this.load_wallet, // use reload_wallet instead
			get_mnemonic_or_devmode: this.get_mnemonic_or_devmode,
			get_multlist: this.get_multlist,
			publish_mult: this.publish_mult,
			get_multlistjig: this.get_multlistjig_synced,
			get_revokerjig: this.get_revokerjig,
			update_wallet_name: this.update_wallet_name,
			get_tokenoriginjig: this.get_tokenoriginjig,

			reload_wallet: this.reload_wallet,
			create_new_wallet: this.create_new_wallet,

			change_network_andreload: this.change_network_andreload,
			reload_all_contracts: this.reload_all_contracts,
			get_total_mult: this.get_total_mult,
			get_token_balance: this.get_token_balance,
			get_multlist_dates: this.get_multlist_dates,
			syncWallet_nForceRerender: this.syncWallet_nForceRerender,
			change_network_noreload: this.change_network_noreload,
			generateBackupFile: this.generateBackupFile,
			get_newpassword_previous: this.get_newpassword_previous,
			update_newpassword_previous: this.update_newpassword_previous,
			get_multlist_timestamps: this.get_multlist_timestamps,
			get_tx_history: this.get_tx_history,
			get_utxos_for_nbtokens: this.get_utxos_for_nbtokens,
			blacklist_address: this.blacklist_address,
			update_contract_origin_and_reload: this.update_contract_origin_and_reload,  // don't debounce this one because we need the last return not the first
			revokerContract_freeze: this.revokerContract_freeze,
			revokerContract_backup: this.revokerContract_backup,
			revokerContract_revoke: this.revokerContract_revoke,
			reset_wallet: this.reset_wallet,
			update_from_mnemonic_noreload: this.update_from_mnemonic_noreload,
			getTokenSupply: this.getTokenSupply,
			get_blacklist2d: this.get_blacklist2d,
			get_history_loading_progress: this.get_history_loading_progress,
			clearCache: this.clearCache,
			burn_tokens_all: this.burn_tokens_all,
			burn_tokens: this.burn_tokens,
			get_reload_count: this.get_reload_count,
			resetGlobalError: this.resetGlobalError,
			sendtx_BSV: this.sendtx_BSV,
			sendtx_Token: this.sendtx_Token,
			mint_tokens: this.mint_tokens,
			create_contract: this.create_contract,
			update_contract_generic: this.update_contract_generic,
			send_revokerContract: this.send_revokerContract,
			update_balance_bsv: this.update_balance_bsv,
			reload_bsv: this.reload_bsv,
			reload_token: this.reload_token,

			// this prevents staring a new sync if one is already occuring, but will return once the current once ends
			inventory_sync: this.inventory_sync, // ask inventory sync with debouncing as a promise
			update_disable_all_sync: this.update_disable_all_sync,

			// wallet unlock: when an encrypted blob is found on mount but not yet decrypted
			awaiting_unlock: false,
			// info about the wallet pending unlock (walletname, address_owner, network) for display
			pending_unlock_info: null,

			// encrypted wallet session management
			setWalletPassword: this.setWalletPassword,
			save_session_encrypted_wallet: this.save_session_encrypted_wallet,
			unlock_wallet_from_password: this.unlock_wallet_from_password,
			verifyWalletPassword: this.verifyWalletPassword,
			change_wallet_password: this.change_wallet_password,
			dismiss_weak_password_warning: this.dismiss_weak_password_warning,
			clear_session_encrypted_wallet: this.clear_session_encrypted_wallet,
			clear_remembered_encrypted_wallet: this.clear_remembered_encrypted_wallet,
			has_remembered_wallet: this.has_remembered_wallet,
			has_session_encrypted_wallet: this.has_session_encrypted_wallet,
			get_pending_unlock_info: this.get_pending_unlock_info,
			get_remembered_wallet_info: this.get_remembered_wallet_info,
			prepare_unlock_from_storage: this.prepare_unlock_from_storage,

			// pending wallet staging area (create/restore flow)
			pending_wallet: null,
			set_pending_wallet: this.set_pending_wallet,
			clear_pending_wallet: this.clear_pending_wallet,
			generate_new_wallet: this.generate_new_wallet,
			commit_wallet: this.commit_wallet,
			cache_history_bsv: this.cache_history_bsv,
			get_history_bsv: this.get_history_bsv,
			cache_history_bsv_raw: this.cache_history_bsv_raw,
			get_history_bsv_raw: this.get_history_bsv_raw,
			fetch_bsv_history_raw: this.fetch_bsv_history_raw,
			enrich_one_bsv_tx: this.enrich_one_bsv_tx,

			update_selected_coin: this.update_selected_coin,
			get_selected_coin_props: this.get_selected_coin_props,
			get_coin_props: this.get_coin_props,

			reset_cache_history_bsv: this.reset_cache_history_bsv,
		}
		this.initial_state = this.state
		this.askedReloadCount = this.globalErrorContext.askedReloadCount
	}

	// Only non-sensitive UI state is persisted to sessionStorage.
	// mnemonic, privkey_owner, privkey_purse are NEVER stored here —
	// they are stored encrypted in a separate key (SESSION_WALLET_KEY).
	// The allowlist approach is safer than filterSerializable's blacklist,
	// because any new sensitive field added to state in the future won't
	// accidentally leak unless explicitly added to the list below.
	SESSION_STATE_ALLOWLIST = [
		'network',
		'runapi',
		'tokenorigin',
		'SYNC_INNER',
		'walletname',
		'bsvprice',
		'globalError',
		'inventory_synced_atLeastOnce',
		'disable_all_sync',
		'selected_coin',
		'address_owner',
		'address_purse',
		'isMockWallet',
		'weak_password_warning',  // persists across refresh so the banner reappears until password is changed
	]

	saveStateToSessionStorage = () => {
		const log = getLog("UserContext: saveStateToSessionStorage:")
		const serializableState = {}
		for (const key of this.SESSION_STATE_ALLOWLIST) {
			if (key in this.state) {
				serializableState[key] = this.state[key]
			}
		}
		const dataToStore = {
			state: serializableState,
			timestamp: Date.now(),
		}
		sessionStorage.setItem('userContextState', JSON.stringify(dataToStore))
		log('Saved UI state to sessionStorage (secrets excluded):', serializableState)
	};

	// componentDidUpdate to detect state changes
	componentDidUpdate = (prevProps, _prevState) => {
		const log = getLog("UserContext: componentDidUpdate:")
		const oldState = filterSerializable(_prevState)
		const newState = filterSerializable(this.state)
		if (oldState !== newState) {
			// log('State changed from:', oldState, 'to:', newState)
			// Log only what changed by creating an object with changed keys and their new values
			const changes = Object.keys(newState)
				.filter(key => newState[key] !== oldState[key])
				.reduce((obj, key) => {
					obj[key] = newState[key];
					return obj;
				}, {});
			// test if changes!={} aka not empty
			if (Object.keys(changes).length !== 0) {
				// BEWARE LOGGING changes HERE WILL LOG UNENCRYPTED MNEMONICS AND PRIVKEYS
				// log('State changed:', changes);
				log('State changed:', Object.keys(changes)) // keys() prevents logging raw keys
				// only save to cache if there is a privkey
				if (newState.privkey_owner) {
					this.saveStateToSessionStorage()
				}
			}
		}
	}


	// Load state from sessionStorage on mount.
	// Only non-sensitive UI state is restored from 'userContextState'.
	// The encrypted mnemonic blob (SESSION_WALLET_KEY / REMEMBERED_WALLET_KEY)
	// requires a password to decrypt — we set awaiting_unlock and let the
	// app route to the unlock screen instead of auto-loading the wallet.
	componentDidMount() {
		const log = getLog("UserContext: componentDidMount:")

		// 1. Restore non-sensitive UI state from sessionStorage (allowlisted, no secrets)
		const cachedData = sessionStorage.getItem('userContextState')
		try {
			log("cachedData:", JSON.parse(cachedData))
		} catch (e) { }

		if (cachedData) {
			const { state, timestamp } = JSON.parse(cachedData);
			const now = Date.now();
			const oneHour = 60 * 60 * 1000;
			if (now - timestamp < oneHour) {
			state.disable_all_sync = false  // force resync if it got disabled
			// Migration: older sessions stored the slug "delphe"/"bsv" as
			// selected_coin; ALLOWED_COINS is now keyed by txid. Reset stale
			// values to the default so consumers don't get undefined.
			if (!ALLOWED_COINS_KEYS.includes(state.selected_coin)) {
				log("selected_coin='" + state.selected_coin
					+ "' is stale (not in ALLOWED_COINS_KEYS) — resetting to default (" + default_token_origin_mainnet + ")")
				state.selected_coin = default_token_origin_mainnet
			}
			// Restore the cached UI state (no secrets in here anymore)
				this.setState(state, () => {
					log("state.isMockWallet:", state.isMockWallet, "address_owner:", state.address_owner)
					if (state.isMockWallet !== true) {
						this.setStateSafeAsync({ isMockWallet: false })
					}
				})
				log('Restored UI state from sessionStorage:', state)
				this.initial_state = state  // important !
			} else {
				// expired data
				sessionStorage.removeItem('userContextState')
				log("sessionStorage too old, deleting.")
			}
		}

		// 2. Check for an encrypted wallet blob (session first, then remembered/localStorage).
		// If found, we set awaiting_unlock so the app routes to the unlock screen
		// instead of auto-loading the wallet (which would fail without privkeys).
		const sessionBlob = this._read_encrypted_blob(SESSION_WALLET_KEY, SESSION_WALLET_TTL_MS)
		const rememberedBlob = (!sessionBlob) ? this._read_encrypted_blob(REMEMBERED_WALLET_KEY, REMEMBERED_WALLET_TTL_MS) : null
		const blob = sessionBlob || rememberedBlob

		if (blob) {
			log("found encrypted wallet blob, walletname=", blob.walletname, "address=", blob.address_owner)
			// Stash the blob for unlock_wallet_from_password() to use
			this._pending_encrypted_blob = blob
			// Pre-populate display info so the unlock screen can show which wallet is being unlocked
			this.setStateSafeAsync({
				awaiting_unlock: true,
				pending_unlock_info: {
					walletname: blob.walletname,
					address_owner: blob.address_owner,
					network: blob.network,
				},
				walletname: blob.walletname || "",
				network: blob.network || this.state.network,
				address_owner: blob.address_owner || "",
			})
		} else {
			// No encrypted blob and no privkeys: let the app render normally.
			// The router will show the default route and the user can navigate
			// to /select_wallet to create or restore a wallet.
			// (Do NOT use window.location.href = '/' here — it causes a full
			// page reload loop because componentDidMount re-fires on each load.)
			log("no encrypted blob and no privkeys, letting app render normally")
		}
	}

	cache_history_bsv = (txdata, prepend = false) => {
		// concatenate received data with pre-existing cache based on txhashes
		if (!this.data_cache_history_bsv) this.data_cache_history_bsv = []
		const existing_txhs = this.data_cache_history_bsv.map(e => e.tx_hash)
		const new_entries = []
		for (let data_elem of txdata) {
			if (data_elem.tx_hash && !existing_txhs.includes(data_elem.tx_hash)) {
				new_entries.push(data_elem)
			}
		}
		if (new_entries.length > 0) {
			if (prepend) {
				// prepend: newest txs go to the front so they appear in the display
				// window (which slices from the beginning). Used for injecting a
				// just-broadcast tx so it shows up immediately.
				this.data_cache_history_bsv = new_entries.concat(this.data_cache_history_bsv)
			}
			else {
				// append: normal enrichment order (follows WoC's raw list order)
				this.data_cache_history_bsv = this.data_cache_history_bsv.concat(new_entries)
			}
		}
	}
	get_history_bsv = () => {
		return this.data_cache_history_bsv
	}
	// cache for the raw tx-hash list from WoC, so navigating away and back to
	// the BSV history doesn't refetch (mirrors how token history persists in
	// the context). Invalidated together with the txdata cache on reload/send.
	// Also mirrored to a localStorage snapshot (per network + owner) so a cold
	// app start can render the tx count + drive background enrichment from the
	// IDB cache before the first WoC refetch lands.
	cache_history_bsv_raw = (history) => {
		this.data_cache_history_bsv_raw = history
		// mirror to localStorage (unified per-wallet cache blob) for fast
		// cold-start load on next app start. Delegates to _update_wallet_cache
		// (synchronous read-modify-write) so it can't race other cache writers.
		this._update_wallet_cache(blob => {
			blob.bsvrawhistory = { history }
		})
	}
	get_history_bsv_raw = () => {
		return this.data_cache_history_bsv_raw
	}
	reset_cache_history_bsv = () => {
		this.data_cache_history_bsv = []
		this.data_cache_history_bsv_raw = null
	}

	/**
	 * Shared per-tx enrichment with a write-through IndexedDB cache.
	 *
	 * processOneTxData() costs 1 WhatsOnChain fetchTxInfo call per tx.
	 * On a cold start (or after "Erase cache"), the BsvHistoryCache (IDB)
	 * already holds previously enriched txs, so we serve them from there
	 * and only hit WoC for cache misses. Both the BSV history page and
	 * _refresh_bsv_history() route through here so the cache is always
	 * consistent.
	 *
	 * @param {object} tx_data  raw tx entry from WoC ({tx_hash, height, time, ...})
	 * @param {string} purse_address
	 * @returns enriched txdata (or null on failure)
	 */
	enrich_one_bsv_tx = async (tx_data, purse_address) => {
		const function_id = this.classname + "enrich_one_bsv_tx(): "
		const log = getLog(function_id)

		const tx_hash = tx_data && tx_data.tx_hash
		if (!tx_hash) {
			log("ignoring tx_data without tx_hash", tx_data)
			return null
		}

		// cache hit: skip the WoC fetchTxInfo call entirely
		if (this.bsv_history_cache && this.bsv_history_cache.isTXhashInCache(tx_hash)) {
			return this.bsv_history_cache.get_entry(tx_hash)
		}

		// cache miss: enrich + write-through to IDB
		let processedTxData
		try {
			processedTxData = await processOneTxData(tx_data, purse_address)
		} catch (err) {
			log("processOneTxData failed for tx=", tx_hash, err)
			return null
		}
		if (processedTxData && processedTxData.tx_hash && this.bsv_history_cache) {
			await this.bsv_history_cache.add_entry(processedTxData)
		}
		return processedTxData
	}

	/**
	 * Unified per-wallet localStorage cache key. Keyed per (network + purse
	 * address) so mainnet/testnet and wallets are isolated. BSV history is
	 * fetched per purse address, so we key by purse — NOT by owner.
	 *
	 * Replaces the former split keys ("bsvrawhistory_<net>_<purse>" and
	 * "tokkenr_balances_<net>_<purse>") with a single blob:
	 *   { time, balances:{...}, bsvrawhistory:{history:[...]},
	 *     tokenSpecifics:{ <tokenid>:{ mintuples:{...} } } }
	 * Batching under one key keeps the per-wallet footprint to a single
	 * localStorage entry and lets mintuples ride along without a 3rd key.
	 *
	 * IMPORTANT: derive the components from this.bsv_history_cache (the single
	 * source of truth, built from the local run.purse.address var) — NOT from
	 * this.state. setStateSafe() (non-callback variant) returns before React
	 * has flushed this.state, so reading this.state.address_purse right after
	 * wallet unlock can yield the stale/empty value and skip hydration.
	 */
	_wallet_cache_storage_key = () => {
		if (this.bsv_history_cache && this.bsv_history_cache.network && this.bsv_history_cache.purse) {
			return "cache_" + this.bsv_history_cache.network + "_" + this.bsv_history_cache.purse
		}
		// fallback (e.g. before bsv_history_cache is built): use this.state
		if (this.state && this.state.network && this.state.address_purse) {
			return "cache_" + this.state.network + "_" + this.state.address_purse
		}
		return null
	}

	/**
	 * Centralized synchronous read-modify-write for the unified per-wallet
	 * cache blob. This is what makes batching multiple sub-objects (balances,
	 * bsvrawhistory, tokenSpecifics) under one key safe WITHOUT a queue/lock:
	 * localStorage.getItem/setItem are synchronous and block the JS main
	 * thread, and the mutator runs synchronously (no await) between the read
	 * and the write, so two writers can never interleave their read-modify-
	 * write cycles. Each cache_* writer below delegates here.
	 *
	 * @param {(blob: object) => void} mutator  synchronously mutates the
	 *   parsed blob (creates sub-objects as needed). `time` is stamped
	 *   automatically after the mutation runs.
	 */
	_update_wallet_cache = (mutator) => {
		const key = this._wallet_cache_storage_key()
		if (!key) return
		// Skip persisting for the mock ("example") wallet: it uses fresh
		// random purse keys on every load, so a cached entry would be a
		// junk cache_<network>_<random-purse> blob never read again.
		if (this.state && this.state.isMockWallet === true) return
		try {
			let blob = {}
			const raw = localStorage.getItem(key)
			if (raw) {
				const parsed = JSON.parse(raw)
				if (parsed && typeof parsed === "object") blob = parsed
			}
			mutator(blob)
			blob.time = Date.now()
			localStorage.setItem(key, JSON.stringify(blob))
		} catch (e) {
			getLog(this.classname + "_update_wallet_cache(): ")(key, e)
		}
	}

	/**
	 * Hydrate the in-memory BSV history caches from persistent storage on
	 * wallet load, so the BSV history page renders instantly on a cold start
	 * (no WoC refetch / re-enrichment needed to show the previously-seen txs).
	 *
	 *   - raw tx-hash list  ← localStorage snapshot (fast, small, synchronous)
	 *   - enriched txdata   ← BsvHistoryCache (IndexedDB, written through by enrich_one_bsv_tx)
	 *
	 * Only hydrates when the in-memory caches are empty, so a mid-session
	 * reload_wallet() never overwrites live caches with stale snapshots.
	 */
	hydrate_bsv_history_from_storage = async () => {
		const function_id = this.classname + "hydrate_bsv_history_from_storage(): "
		const log = getLog(function_id)

		// 1. enriched txdata from IndexedDB
		if (this.bsv_history_cache
			&& (!this.data_cache_history_bsv || this.data_cache_history_bsv.length === 0)) {
			const all = this.bsv_history_cache.get_all()
			if (all && all.length > 0) {
				log("hydrating data_cache_history_bsv from IDB, count=", all.length)
				this.data_cache_history_bsv = all
			}
		}

		// 2. raw tx-hash list from the unified localStorage blob
		if (this.data_cache_history_bsv_raw == null) {
			const key = this._wallet_cache_storage_key()
			if (key) {
				try {
					const blob = localStorage.getItem(key)
					if (blob) {
						const parsed = JSON.parse(blob)
						const raw = parsed && parsed.bsvrawhistory
						if (raw && Array.isArray(raw.history)) {
							log("hydrating data_cache_history_bsv_raw from localStorage, count=", raw.history.length)
							this.data_cache_history_bsv_raw = raw.history
						}
					}
				} catch (e) {
					log("localStorage hydrate failed", e)
				}
			}
		}
	}

	/**
	 * Persist a balances snapshot to the unified per-wallet cache blob (merge
	 * with any existing balances sub-object so a BSV-only update doesn't wipe
	 * the cached token balance / price and vice-versa). Delegates to
	 * _update_wallet_cache() (synchronous read-modify-write) — see the
	 * atomicity note there. try/catch + non-critical on quota / serialization
	 * errors (the in-memory state still works).
	 *
	 * @param {object} partial  { balance_bsv?, tokens_balance?, bsvprice? }
	 *   Only the provided fields are merged into the stored balances.
	 */
	cache_balances = (partial) => {
		this._update_wallet_cache(blob => {
			blob.balances = { ...(blob.balances || {}), ...partial }
		})
	}

	/**
	 * Hydrate balance_bsv / tokens_balance / bsvprice from the localStorage
	 * snapshot on wallet load, so the balance components (SoldeBSV, SoldeToken)
	 * render cached values immediately instead of skeleton loaders on a cold
	 * start. reload_wallet()'s background refetch will overwrite them shortly
	 * after (stale-while-revalidate).
	 *
	 * Only fills fields that are still at their default (null / empty object)
	 * so a mid-session reload_wallet() never clobbers live state — same guard
	 * pattern as the tokens_txdata hydration in _early_init_history_caches().
	 *
	 * Note: bsvprice is network-wide (not wallet-specific), so it correctly
	 * carries over across wallet switches on the same network.
	 */
	hydrate_balances_from_storage = async () => {
		const function_id = this.classname + "hydrate_balances_from_storage(): "
		const log = getLog(function_id)

		const key = this._wallet_cache_storage_key()
		if (!key) return
		let parsed
		try {
			const blob = localStorage.getItem(key)
			if (!blob) return
			parsed = JSON.parse(blob)
			if (!parsed || typeof parsed !== "object") return
		} catch (e) {
			log("localStorage hydrate failed", e)
			return
		}

		// balances are a sub-object of the unified blob
		const b = parsed.balances
		if (!b || typeof b !== "object") return

		const patch = {}
		if (this.state.balance_bsv == null
			&& b.balance_bsv != null) {
			patch.balance_bsv = b.balance_bsv
		}
		if (this.state.tokens_balance
			&& Object.keys(this.state.tokens_balance).length === 0
			&& b.tokens_balance
			&& typeof b.tokens_balance === "object") {
			patch.tokens_balance = b.tokens_balance
		}
		if (this.state.bsvprice == null
			&& b.bsvprice != null) {
			patch.bsvprice = b.bsvprice
		}

		if (Object.keys(patch).length > 0) {
			log("hydrating balances from localStorage:", Object.keys(patch))
			await this.setStateSafeAsync(patch)
		}
	}

	/**
	 * Persist the selected coin's mintuples (multlist + multlist_timestamps)
	 * under the unified per-wallet cache blob:
	 *   tokenSpecifics.<tokenid>.mintuples = { multlist, multlist_timestamps }
	 * Called at the end of get_multlist_timestamps() — by then get_multlist()
	 * (which sets this.state.multlist_list) has already completed in the
	 * reload_wallet flow, so both arrays are in hand. Enables stale-while-
	 * revalidate for the Mintuples page on cold start.
	 */
	cache_mintuples = (tokenid, multlist, multlist_timestamps) => {
		if (!tokenid || !Array.isArray(multlist) || !Array.isArray(multlist_timestamps)) return
		this._update_wallet_cache(blob => {
			blob.tokenSpecifics = blob.tokenSpecifics || {}
			blob.tokenSpecifics[tokenid] = blob.tokenSpecifics[tokenid] || {}
			blob.tokenSpecifics[tokenid].mintuples = { multlist, multlist_timestamps }
		})
	}

	/**
	 * Hydrate this.state.multlist_list / multlist_timestamps for the currently
	 * selected coin from the unified per-wallet cache blob, so the Mintuples
	 * page renders instantly on a cold start instead of skeleton loaders.
	 * Only fills fields that are still null so a mid-session reload_wallet()
	 * never clobbers live state — same guard pattern as hydrate_balances.
	 *
	 * @param {string} tokenid  the selected coin's id (this.state.selected_coin)
	 */
	hydrate_mintuples_from_storage = async (tokenid) => {
		const function_id = this.classname + "hydrate_mintuples_from_storage(): "
		const log = getLog(function_id)

		if (!tokenid) return
		if (this.state && this.state.isMockWallet === true) return

		const key = this._wallet_cache_storage_key()
		if (!key) return
		let parsed
		try {
			const blob = localStorage.getItem(key)
			if (!blob) return
			parsed = JSON.parse(blob)
			if (!parsed || typeof parsed !== "object") return
		} catch (e) {
			log("localStorage hydrate failed", e)
			return
		}

		const ts = parsed.tokenSpecifics
			&& parsed.tokenSpecifics[tokenid]
			&& parsed.tokenSpecifics[tokenid].mintuples
		if (!ts) return

		const patch = {}
		if (this.state.multlist_list == null
			&& Array.isArray(ts.multlist)) {
			patch.multlist_list = ts.multlist
		}
		if (this.state.multlist_timestamps == null
			&& Array.isArray(ts.multlist_timestamps)) {
			patch.multlist_timestamps = ts.multlist_timestamps
		}

		if (Object.keys(patch).length > 0) {
			log("hydrating mintuples from localStorage for", tokenid, ":", Object.keys(patch))
			await this.setStateSafeAsync(patch)
		}
	}

	/**
	 * Hydrate the mock ("example") wallet with explicit 0 balances for BSV
	 * and every token in ALLOWED_COINS, so the wallet home renders "0.00"
	 * immediately instead of skeleton loaders. The mock wallet uses fresh
	 * random keys on each load (no localStorage snapshot, no jigs, no utxos),
	 * so 0 is the truthful value.
	 *
	 * Mirrors hydrate_balances_from_storage()'s shape (setState patch) but
	 * forces 0s unconditionally — does NOT touch cache_balances() (mock
	 * wallet snapshots are intentionally not persisted, see cache_balances()).
	 *
	 * Only runs when this.state.isMockWallet === true (set inside
	 * init_run_and_caches_from_privkeys' mock branch, after create_new_wallet()
	 * resets state to get_default_walletdata_state()).
	 */
	hydrate_mock_wallet_zero_balances = async () => {
		const function_id = this.classname + "hydrate_mock_wallet_zero_balances(): "
		const log = getLog(function_id)

		if (!this.state || this.state.isMockWallet !== true) {
			log("skipped (not a mock wallet)")
			return
		}

		const zero_tokens_balance = Object.fromEntries(
			ALLOWED_COINS_KEYS.filter(k => k !== "bsv").map(k => [k, 0])
		)

		log("hydrating mock wallet with 0 balances for BSV +", Object.keys(zero_tokens_balance))
		await this.setStateSafeAsync({
			balance_bsv: 0,
			tokens_balance: zero_tokens_balance,
		})
	}

	/**
	 * Per-token manual reload (BSV side).
	 * Refreshes the BSV balance (light REST call) and fetches new BSV txs
	 * from WhatsOnChain, enriching only the ones not yet in the cache and
	 * appending them (does NOT reset the cache — new txs are added).
	 */
	reload_bsv = async () => {
		const function_id = this.classname + "reload_bsv(): "
		const log = getLog(function_id)
		log("start")

		const purse_address = this.state.address_purse
		if (!purse_address) {
			log("no purse address, aborting")
			return
		}

		// 1. refresh BSV balance (light REST call, no RUN sync)
		await this.update_balance_bsv()

		// 2. fetch-and-append BSV history (don't reset cache)
		await this._refresh_bsv_history(purse_address)

		log("done")
	}

	/**
	 * Shared, short-TTL single-flight wrapper around WoC's fetchAddressHistory.
	 *
	 * Both _refresh_bsv_history() (called by reload_bsv) and
	 * Slide_History_BSV.fetch_history() (called on BSV history page mount) used
	 * to each fire their own wocConnector.fetchAddressHistory(purse_address)
	 * independently. On a cold mount of the BSV history page during wallet
	 * load, both could race and hit the same WoC endpoint simultaneously.
	 *
	 * This helper dedupes concurrent calls: the first caller fires the network
	 * request and concurrent callers await the same promise. A short freshness
	 * window (3s) also collapses back-to-back calls (e.g. navigate to BSV
	 * history, then immediately click refresh).
	 */
	fetch_bsv_history_raw = async (purse_address) => {
		const function_id = this.classname + "fetch_bsv_history_raw(): "
		const log = getLog(function_id)

		const now = Date.now()
		const FRESH_TTL_MS = 3000

		// Reuse if we have a fresh result for this address
		if (this._last_bsv_history_raw
			&& this._last_bsv_history_raw.address === purse_address
			&& (now - this._last_bsv_history_raw.time) < FRESH_TTL_MS) {
			log("returning fresh cached raw history (age=", now - this._last_bsv_history_raw.time, "ms)")
			return this._last_bsv_history_raw.history
		}

		// Single-flight: join an in-flight fetch for this address if one exists
		if (this._bsv_history_raw_promise
			&& this._bsv_history_raw_promise.address === purse_address) {
			log("joining in-flight fetchAddressHistory for", purse_address)
			return await this._bsv_history_raw_promise.promise
		}

		const promise = (async () => {
			const wocConnector = await waitForSharedWhatsOnChainConnector()
			const history = await wocConnector.fetchAddressHistory(purse_address)
			this._last_bsv_history_raw = { address: purse_address, time: Date.now(), history }
			// clear the in-flight marker
			if (this._bsv_history_raw_promise
				&& this._bsv_history_raw_promise.address === purse_address) {
				this._bsv_history_raw_promise = null
			}
			return history
		})()

		this._bsv_history_raw_promise = { address: purse_address, promise }
		return await promise
	}

	/**
	 * Internal helper: fetch the raw tx-hash list from WoC, diff against the
	 * enriched cache, and enrich only the new txs (sequentially + throttled
	 * to respect WoC's rate limit, same pattern as Slide_History_BSV).
	 * Appends to data_cache_history_bsv (dedup by tx_hash) and updates
	 * data_cache_history_bsv_raw with the full fresh list.
	 */
	_refresh_bsv_history = async (purse_address) => {
		const function_id = this.classname + "_refresh_bsv_history(): "
		const log = getLog(function_id)
		log("start")

		let history = await this.fetch_bsv_history_raw(purse_address)
		// NOTE: WoC returns newest-first; we don't reverse here because the
		// display layer (Slide_History_BSV) sorts explicitly by time desc.
		log("fetched raw history.length=", history.length)

		// diff against enriched cache: find tx_hashes not yet enriched
		const cached_txdata = this.data_cache_history_bsv || []
		const existing_txhs = new Set(cached_txdata.map(e => e.tx_hash))
		const new_raw_txs = history.filter(e => e.tx_hash && !existing_txhs.has(e.tx_hash))
		log("new txs to enrich:", new_raw_txs.length)

		// enrich only the new ones (sequential + throttled), routing through
		// enrich_one_bsv_tx so the BsvHistoryCache (IDB) short-circuits WoC
		// fetchTxInfo for already-enriched txs and write-throughs on miss.
		const new_tokens_txdata = []
		for (let tx_data of new_raw_txs) {
			try {
				const processedTxData = await this.enrich_one_bsv_tx(tx_data, purse_address)
				if (processedTxData && processedTxData.tx_hash) {
					new_tokens_txdata.push(processedTxData)
				}
			} catch (err) {
				log("processOneTxData failed for tx=", tx_data && tx_data.tx_hash, err)
			}
		}

		// append to cache (dedup by tx_hash) + update raw cache (full fresh list)
		if (new_tokens_txdata.length > 0) {
			this.cache_history_bsv(new_tokens_txdata)
		}
		this.cache_history_bsv_raw(history)

		// signal consumers that the BSV cache (raw + enriched) changed so they
		// re-sync their display from the cache. The send path already does this
		// via syncWallet_nForceRerender; reload_bsv needs it here too, otherwise
		// the BSV history component keeps showing stale local state during/after
		// a background refresh (e.g. "loading 1/61..." with only the injected tx).
		this.forceReRender()

		// evict confirmed pending spends from the blockchain's filter:
		// any tx with a non-zero height is confirmed, so its inputs are no longer
		// "pending" — WoC's /unspent will have dropped them.
		try {
			const run = await this.runContext.get_run_asyncf()
			if (run && run.blockchain && typeof run.blockchain.evict_confirmed_spends === "function") {
				const confirmed_txids = history
					.filter(e => e.tx_hash && e.height && e.height > 0)
					.map(e => e.tx_hash)
				if (confirmed_txids.length > 0) {
					await run.blockchain.evict_confirmed_spends(confirmed_txids)
				}
			}
		} catch (e) {
			// non-critical: eviction failure just means stale entries linger until TTL
		}

		log("done, enriched", new_tokens_txdata.length, "new txs, total cached:", (this.data_cache_history_bsv || []).length)
	}

	/**
	 * Per-token manual reload (token/delphe side).
	 * Refreshes the token balance (heavy: syncs jigs + inventory) and
	 * fetches new token tx history (get_tx_history already merges new + cached,
	 * so it appends without resetting).
	 */
	reload_token = async () => {
		const function_id = this.classname + "reload_token(): "
		const log = getLog(function_id)
		log("start")

		// 1. refresh token balance (heavy: syncs jigs + inventory)
		await this.get_token_balance()

		// 2. fetch-and-append token tx history (get_tx_history merges new + cached)
		await this.get_tx_history()

		log("done")
	}


	update_selected_coin = async (new_selected_coin) => {
		const function_id = this.classname + "update_selected_coin(new_selected_coin=" + new_selected_coin + "): "
		const log = getLog(function_id)
		log()

		if (!ALLOWED_COINS_KEYS.includes(new_selected_coin)) {
			throw new Error("Unallowed coin: " + new_selected_coin)
		}
		this.setState({ selected_coin: new_selected_coin })
	}

	// this must be synced
	get_selected_coin_props = () => {
		const function_id = this.classname + "get_selected_coin_props(): "
		const log = getLog(function_id)

		log("this.state.selected_coin=", this.state.selected_coin,
			"ALLOWED_COINS_KEYS=", ALLOWED_COINS_KEYS)
		// Defensive: if selected_coin is not a valid key (e.g. stale value from
		// an older sessionStorage schema), fall back to the default instead of
		// returning undefined and crashing consumers.
		if (!ALLOWED_COINS_KEYS.includes(this.state.selected_coin)) {
			log("WARNING: selected_coin='" + this.state.selected_coin
				+ "' is not in ALLOWED_COINS_KEYS — falling back to default (" + default_token_origin_mainnet + ")")
			return ALLOWED_COINS[default_token_origin_mainnet]
		}
		return ALLOWED_COINS[this.state.selected_coin]
	}
	// TODO
	get_coin_props = (tokenid) => {
		const function_id = this.classname + "get_coin_props(): with tokenid=" + tokenid + ": "
		const log = getLog(function_id)

		if (!ALLOWED_COINS_KEYS.includes(tokenid)) {
			log("WARNING: tokenid='" + tokenid
				+ "' is not in ALLOWED_COINS_KEYS — falling back to default (" + default_token_origin_mainnet + ")")
			return ALLOWED_COINS[default_token_origin_mainnet]
		}
		return ALLOWED_COINS[tokenid]
	}


	reset_state_contract = async (new_contractorigin) => {
		// const log=(...args)=>{console.log("reset_state_contract("+new_contractorigin+")",...args)}

		// reset
		this.tokenoriginjig = null
		this.history_size = null  // for get_history_loading_progress()
		this.history_nbloaded = null

		var new_state = {
			...this.initial_state,
			walletname: this.state.walletname
		}
		// log("new_state = ",new_state)  // DONT PRINT STATE IT HAS PRIVKEYS

		new_state['tokenorigin'] = new_contractorigin
		// log("new_state = ",new_state)  // DONT PRINT STATE IT HAS PRIVKEYS

		const run = await this.runContext.get_run_asyncf()
		run.activate()
		const myOraclesUtils = new OraclesUtils()
		// await run.trust(new_contractorigin.split('_')[0])
		let tokenoriginjig = await myOraclesUtils.load_trustRecursive(run, new_contractorigin)
		log("tokenoriginjig:", tokenoriginjig)

		await this.setStateSafeAsync(new_state)
	}


	get_reload_count = () => {
		return this.reloadCount
	}

	getJigs = (otherRun = null) => {
		const function_id = this.classname + "getJigs(): "
		let log = getLog(function_id)

		log("this.runContext.get_syncedAtLeastOnce()=", this.runContext.get_syncedAtLeastOnce())

		return this.runContext.get_inventory().jigs
	}


	update_disable_all_sync = async (newval, manual_call = true) => {
		// for disable_all_sync to work, we must handle it in the Blockchain object
		// to make sure we only use the cache for all retrievals
		// note: we probably don't want to persist this setting on disk since it should remain extremely rare

		const function_id = this.classname + "update_disable_all_sync(): "
		let log = getLog(function_id)

		log("old value:", this.state.disable_all_sync, "=> new value:", newval)
		if (this.state.disable_all_sync == newval) {
			log("aborting because the value is already at", newval)
			return
		}

		await this.setStateSafeAsync({ disable_all_sync: newval })
		if (newval == true) {
			if (!manual_call) {
				let alert_mess = "3 échecs de chargement successif: désactivation des synchronisations et passage en mode broadcast uniquement."
				window.alert(alert_mess)
			}
			else if (manual_call) {
				window.alert("Succès de la désactivation des synchronisations.")
			}
		} else {
			window.alert("Succès de l'activation des synchronisations.")
		}

		const force_update_run = true
		this.reload_wallet(force_update_run)

		log("updated to", newval, ", started wallet reloading")
	}



	/**
	 * syncs inventory without parallel OR redundant syncs, as a promise
	 * 
	 * DO NOT CALL: AWAIT RUN.INVENTORY.SYNC() DIRECTLY BECAUSE WE WILL HAVE MANY IN PARALLEL
	 * AND IT WILL SLOW THE APP DOWN TOO MUCH
	 * INSTEAD CALL: AWAIT THIS.INVENTORY_SYNC() to make sure we don't have parallel OR redundant syncs
	 *
	 * Design (fixes a "sync storm" bug where a single send-tx flow could trigger 3+ full
	 * inventory reloads back-to-back, each firing hundreds of API calls, see INVENTORY_SYNC_MIN_INTERVAL_MS doc):
	 *  - this.is_inventory_syncing: mutex, only 1 real sync runs at a time, concurrent callers
	 *    join the same in-flight promise instead of starting their own.
	 *  - this.need_inventory_sync: dirty flag, if new callers arrive WHILE a sync is running,
	 *    the in-flight driver loops once more right after finishing instead of missing them
	 *    (so nobody waits on stale data, without stacking N redundant full syncs either).
	 *  - freshness window (INVENTORY_SYNC_MIN_INTERVAL_MS): if a sync just completed very
	 *    recently and nobody flagged a need since, we skip hitting the network again.
	 *  BEWARE the lock is ALWAYS released in a finally(), even if the sync throws,
	 *  otherwise all future callers would be stuck retrying until the global timeout, forever.
	 */
	inventory_sync = async () => {
		const function_id = this.classname + "inventory_sync(): "
		const log = getLog(function_id)

		this.need_inventory_sync = true // signal that a fresh-enough sync is owed to us

		log("requested, is_inventory_syncing=", this.is_inventory_syncing,
			"\n nbjigs=", this.getJigs().length)

		return await this._drive_inventory_sync()
	}

	/** internal driver for inventory_sync(), see its doc comment above for the full design */
	_drive_inventory_sync = async () => {
		const function_id = this.classname + "_drive_inventory_sync(): "
		const log = getLog(function_id)

		// join the currently in-flight sync (single-flight): it already loops internally
		// to catch our request via this.need_inventory_sync, so we just await it.
		if (this.is_inventory_syncing) {
			log("joining in-flight sync")
			return await this.inventory_sync_promise
		}

		this.is_inventory_syncing = true // take lock
		this.inventory_sync_promise = (async () => {
			try {
				while (this.need_inventory_sync) {
					// consume the request BEFORE starting, so a NEW request arriving during
					// the sync below re-flags it and causes exactly one more loop iteration
					this.need_inventory_sync = false

					const elapsed = Date.now() - (this.last_inventory_sync_end_time || 0)
					if (this.last_inventory_sync_end_time && elapsed < INVENTORY_SYNC_MIN_INTERVAL_MS) {
						log("last real sync was", elapsed, "ms ago (<", INVENTORY_SYNC_MIN_INTERVAL_MS,
							"ms) => still fresh enough, skipping network sync")
						break
					}

					// BEWARE DONT LOG run BECAUSE IT CONTAINS PRIVKEYS !
					const run = await this.runContext.get_run_asyncf()
					const start_time = Date.now()

					log("calling runContext.inventory_sync() for", run.owner.address,
						"\n nbjigs=", this.getJigs().length)

					/* by passing the array 'class_origins_to_load', we only load the jigs we are interested into
						this optimizes a lot for multi-coin & prevents spamming to increase load time.
					*/
					const coin_class_origin = this.get_selected_coin_props().class_origin
					// TODO if we use RunCraft buy/sell contracts, we will need to add them to this list
					// also unsure what this does on the admin client, do we need to add subcontracts to the list?
					const class_origins_to_load = [coin_class_origin,]
					log("class_origins_to_load=", class_origins_to_load)
					await this.runContext.inventory_sync(class_origins_to_load)

					this.last_inventory_sync_end_time = Date.now()

					log("inventory_sync() over in", (this.last_inventory_sync_end_time - start_time), "ms:",
						"\n nbjigs=", this.getJigs().length)

					// this will be useful for loading swapbotContext
					if (!this.state.inventory_synced_atLeastOnce) {
						this.setState({
							inventory_synced_atLeastOnce: true,
						})
					}
					// loop repeats only if this.need_inventory_sync got re-flagged while we awaited above
				}
				log("finished, nbjigs=", this.getJigs().length)
			} finally {
				this.is_inventory_syncing = false // ALWAYS release the lock, even on error/throw
			}
		})()

		return await this.inventory_sync_promise
	}




	/**
	 * Returns tokenoriginjig as a promise.
	 * It should be synced to latest state.
	 *
	 * Design: same mutex + finally pattern as inventory_sync() above.
	 * this.is_getting_tokenoriginjig is the lock, released in a finally() so it can
	 * never get stuck forever if the fetch throws. Concurrent callers just await the
	 * same this.get_tokenoriginjig_promise instead of polling this.tokenoriginjig every 700ms.
	 */
	get_tokenoriginjig = async () => {
		const function_id = this.classname + "get_tokenoriginjig(): "
		const log = getLog(function_id)

		// Dont do this! we still need to be able to sync
		// abort mechanism if we need to exchange tokens
		// if (this.state.revokedetected) throw new Error(function_id + ".1 aborting because revokedetected")

		log("start")

		if (test_tokenoriginjig_notresponding) throw new Error("test_tokenoriginjig_notresponding")

		// fast path: already cached & matches the currently selected token origin
		if (this.tokenoriginjig && this.tokenoriginjig.origin === this.state.tokenorigin) {
			/*
			console.log(function_id+"found existing tokenoriginjig, syncing subcontracts...")
			// DONT DO THIS => SEEMS TO BE REPSONSIBLE FOR MOST OF THE CREATION OF UNWANTED JIGS
			//await this.tokenoriginjig.sync() //on peut pas sync un tokenorigin car c'est une classe mais on peut sync la multlist après?
			if(this.tokenoriginjig.revokercontract) await this.tokenoriginjig.revokercontract.sync()
			if(this.tokenoriginjig.admincounter) 	await this.tokenoriginjig.admincounter.sync()
			if(this.tokenoriginjig.blacklist) 		await this.tokenoriginjig.blacklist.sync()
			if(this.tokenoriginjig.multlist) 		await this.tokenoriginjig.multlist.sync()
			console.log(function_id+"subcontracts synced!")
			*/

			// note we don't want to resync the contract here, we should let each calling function sync on its own

			log("tokenoriginjig.origin=", this.tokenoriginjig.origin,
				", state.tokenorigin=", this.state.tokenorigin,
				", tokenoriginjig.location=", this.tokenoriginjig.location)

			return this.tokenoriginjig
		}

		// join the in-flight fetch if any (single-flight, avoids parallel redundant fetches)
		if (this.is_getting_tokenoriginjig) {
			log("joining in-flight get_tokenoriginjig()")
			return await this.get_tokenoriginjig_promise
		}

		this.is_getting_tokenoriginjig = true // take lock
		let start_time = Date.now()
		this.get_tokenoriginjig_promise = (async () => {
			try {
				var myrun, tokenoriginjig

				try {
					log("calling get_run_asyncf()...")
					myrun = await this.runContext.get_run_asyncf()
					myrun.activate()
				}
				catch (error) {
					let errormess = "Error in " + function_id + ".3 : this.state.tokenorigin = "
						+ this.state.tokenorigin + " : " + error
					throw new Error(errormess)
				}

				if (!this.state.tokenorigin || this.state.tokenorigin.length === 0) {
					throw new Error("no state.tokenorigin found")
				}

				try {
					log("loading tokenorigin at", this.state.tokenorigin + "...")

					const tokenorigin_txh = this.state.tokenorigin.split("_")[0]
					myrun.trust(tokenorigin_txh)
				}
				catch (error) {
					let errormess = "Error in " + function_id + ".4 :" + error
					throw new Error(errormess)
				}

				let token_location_to_load = this.state.tokenorigin // default
				// if we are on an hardcoded origin, we can load the latest location instead
				// TODO will have to turn these 2 vars into some sort of object for multi-contracts
				//    ex: tokenOrigins = [{origin: "...", latest: "..."}, ...]
				if (this.state.tokenorigin == default_token_origin_mainnet) {
					token_location_to_load = latest_token_location_mainnet
				}

				try {
					log("trust_recursive...")
					const myOraclesUtils = new OraclesUtils()
					myrun.activate()
					tokenoriginjig = await myOraclesUtils.load_trustRecursive(myrun, token_location_to_load)
					log("success of trust_recursive for tokenoriginjig.")
					log("tokenoriginjig.location=", tokenoriginjig.location)
				}
				catch (error) {
					let errormess = "Error in " + function_id + ".4.2 :" + error
					throw new Error(errormess)
				}

				try {
					var multlist_txid = tokenoriginjig.multlist.origin.split("_")[0]
					log("trusting multlist at", multlist_txid)
					myrun.trust(multlist_txid)

					var blacklist_txid = tokenoriginjig.blacklist.origin.split("_")[0]
					log("trusting blacklist at", blacklist_txid)
					myrun.trust(blacklist_txid)

					var revokercontract_txid = tokenoriginjig.revokercontract.origin.split("_")[0]
					log("trusting revokercontract at", revokercontract_txid)
					myrun.trust(revokercontract_txid)
				}
				catch (error) {
					let errormess = "Error in " + function_id + ".4.5 :" + error
					throw new Error(errormess)
				}

			try {
				log("syncing tokenoriginjig 1...")
				await tokenoriginjig.sync()
				this._last_tokenoriginjig_sync_time = Date.now()
				log("tokenoriginjig.location=", tokenoriginjig.location)
				log("tokenoriginjig.multlist.location=", tokenoriginjig.multlist.location)
			}
			catch (error) {
				log("tokenoriginjig.sync() 1.5...")
				await tokenoriginjig.sync()
				this._last_tokenoriginjig_sync_time = Date.now()
				log("tokenoriginjig.location=", tokenoriginjig.location)

				// DO NOT PRINT JIGS IT WILL CREATE "ASSERT ERRORS" IN PROD !!!!!!
				// log("tokenoriginjig=",tokenoriginjig)

				// this actually made things worse "assert failed" => fail & infinite loading display
				if (error.toString().includes("Payload mismatch")) {
					console.error(function_id + ".6 ignoring error : " + error)
					// force it anyway
					log("force tokenoriginjig.sync()...")
					await tokenoriginjig.sync()
					this._last_tokenoriginjig_sync_time = Date.now()
					log("tokenoriginjig.location=", tokenoriginjig.location)
				}
					else {
						var errormess = "Error in " + function_id + ".5 :\n this.state.tokenorigin = \n"
							+ this.state.tokenorigin + "\n error : " + error
						throw new Error(errormess)
					}
				}

				try {
					/* // seems useless to sync a second time ?
					await tokenoriginjig.sync()
					log("tokenoriginjig.location=", tokenoriginjig.location)
					log("tokenoriginjig.multlist.location=", tokenoriginjig.multlist.location)
					*/

					this.tokenoriginjig = tokenoriginjig  // save for future requests, but only after sync() has been called

					// we also need to trust all the previous contracts linked in .accepted_conversions

					log("tokenoriginjig.accepted_conversions =", tokenoriginjig.accepted_conversions)

					if (tokenoriginjig.accepted_conversions) {
						const accepted_conversions = tokenoriginjig.accepted_conversions

						for (var i = 0; i < accepted_conversions.length; i++) {
							var origin = accepted_conversions[i][0]
							myrun.trust(origin.split("_")[0])
						}
					}

					this.setState({
						tokenoriginjig_decimals: this.tokenoriginjig.decimals,
					})

					log("resolving in", (Date.now() - start_time), "ms")
					return this.tokenoriginjig
				}
				catch (error) {
					let errormess = "Error in " + function_id + ".7 : " + error
					throw new Error(errormess)
				}
			}
			finally {
				this.is_getting_tokenoriginjig = false // ALWAYS release the lock, even on error/throw
			}
		})()

		return await this.get_tokenoriginjig_promise
	}

	/**
	 * Freshness-aware tokenoriginjig.sync() wrapper.
	 *
	 * Multiple follow-up functions (get_multlist_timestamps, getTokenSupply, …)
	 * used to each call tokenoriginjig.sync() / sync({inner:true}) right after
	 * reload_all_contracts() had just done it milliseconds earlier. Each sync is
	 * a network round-trip even when the jig is already up-to-date.
	 *
	 * This helper skips the sync if one happened within max_age_ms, and records
	 * the timestamp so subsequent callers benefit too. The initial sync done
	 * inside get_tokenoriginjig() also stamps the field.
	 */
	sync_tokenoriginjig_if_stale = async (max_age_ms = 5000, opts = {}) => {
		const function_id = this.classname + "sync_tokenoriginjig_if_stale(): "
		const log = getLog(function_id)

		const tokenoriginjig = await this.get_tokenoriginjig()
		const now = Date.now()
		const last_sync = this._last_tokenoriginjig_sync_time || 0
		const age = now - last_sync

		if (age < max_age_ms) {
			log("skipping sync, last sync was", age, "ms ago (<", max_age_ms, "ms)")
			return tokenoriginjig
		}

		log("syncing tokenoriginjig, last sync was", age, "ms ago (>= ", max_age_ms, "ms)")
		await tokenoriginjig.sync(opts)
		this._last_tokenoriginjig_sync_time = Date.now()
		return tokenoriginjig
	}



	/**
	 * clears the CustomBlockchain / CustomStateClient in-memory caches (memoize_cache)
	 * attached to the given run, so the next fetch/spends/pull calls hit the network for
	 * fresh data instead of possibly-stale cached results (up to their TTL old).
	 *
	 * call this right before building/broadcasting a critical jig-based transaction
	 * (sendtx_Token/mint_tokens/burn_tokens), NOT for plain BSV sends which don't go
	 * through RUN/jigs at all.
	 */
	clear_run_caches = (run) => {
		const function_id = this.classname + "clear_run_caches(): "
		const log = getLog(function_id)
		try {
			if (run && run.blockchain && typeof run.blockchain.clear_cache === "function") {
				log("clearing run.blockchain cache")
				run.blockchain.clear_cache()
			}
			if (run && run.state && typeof run.state.clear_cache === "function") {
				log("clearing run.state cache")
				run.state.clear_cache()
			}
		} catch (error) {
			// non-critical: never let a cache-clear failure block the send flow
			console.error(function_id + "failed (non-critical, continuing): " + error)
		}
	}

	// DO NOT CALL THIS FUNCTION WITH AWAIT OR YOU RISK CREATING INFINITE LOOPS !!!
	// 2026: did i mean "without await" when writing above comment?? doesnt seem to make sense
	// already_synced: when true, skips the initial tokenoriginjig.sync({inner:true})
	// because the caller (e.g. reload_all_contracts) just did it milliseconds ago.
	check_revokestate_and_convertifneeded = async (run, tokenoriginjig, already_synced = false) => {
		const function_id = this.classname + "check_revokestate_and_convertifneeded(): "
		const log = getLog(function_id)

		if (this.lock_check_revokestate_and_convertifneeded) return
		else this.lock_check_revokestate_and_convertifneeded = true

		// we need a "let"" to avoid "no-loop-func" warning & bugs further on (vs using "var")
		let tokenoriginjig_let = tokenoriginjig

		if (!tokenoriginjig || !run) return

		if (TURNOFF_CHECK_CONTRACT_REVOKED) throw new Error(function_id + " TURNOFF_CHECK_CONTRACT_REVOKED")

		try {
			if (test_needtoconverttokens) await this.setStateSafeAsync({ revokedetected: true })

			//var run = await this.get_run() // DO NOT DO THAT IT CREATES INFINITE LOOP => GIVE AS PARAMETER !

			//let tokenoriginjig = await this.get_tokenoriginjig() // DO NOT DO THAT IT CREATES INFINITE LOOP => GIVE AS PARAMETER !
			//run.trust(tokenoriginjig.origin.split('_')[revokercontract0]) // should already have been done but rather redo it as a safety check
			try {
				log(" tokenoriginjig.sync()...")
				run.trust(tokenoriginjig.origin.split('_')[0]) // safety check
				// with true:   Error syncing tokenoriginjig: Error: Cannot read location Hint: Sync the jig to assign it in a transaction
				if (!already_synced) {
					await tokenoriginjig.sync({ inner: true })
				} else {
					log(" skipping tokenoriginjig.sync({inner:true}) because already_synced=true")
				}
			} catch (error) {
				throw new Error(function_id + ".1 Error syncing tokenoriginjig: " + error)
			}

			let tokenstoconvert = []
			let revokedetected = false // to prevent infinite loops by calling other functions uselessly

			// now let's see if this was revoked or backedup
			// we loop until being sure we are on the last active contract
			let iteration_count = 0
			while (tokenoriginjig.isRevoked() || tokenoriginjig.isBackedup()) {
				if (iteration_count === 0) console.log(function_id + " starting conversion loop..."); iteration_count++

				revokedetected = true
				console.error(function_id + " DETECTED revoked or backedup contract at " + tokenoriginjig.origin)

				// indicate to rendering that we are dealing with a revoke detected
				if (this.state.revokedetected === false) {
					await this.setStateSafeAsync({ revokedetected: true })
					this.forceReRender()
				}

				try {
					run.trust(tokenoriginjig.origin.split('_')[0])
					// we need true here because we need it to sync the revokercontract too to check it !
					await tokenoriginjig.sync({ inner: true })
				}
				catch (error) {
					throw new Error(function_id + ".2 Error syncing tokenoriginjig: " + error)
				}

				// now we also want to convert all intermediate coins jig so we must load and save them to tokenstoconvert
				//		(unless we are on the last contract already)
				let noerror_during_inventorysync = true
				try {
					await run.sync()
					await this.inventory_sync()
				}
				catch (error) {
					noerror_during_inventorysync = false
					console.error(function_id + ".2.5 error during inventory syncing, "
						+"moving to next contract without checking tokens in this one."
						+" Error was: \n" + error)
				}

				if (noerror_during_inventorysync) {
					// we get the delphe coins jigs to be able to convert them later
					let jigs = this.getJigs(run)

					let new_tokenstoconvert = jigs.filter(jig =>
						jig instanceof tokenoriginjig_let && jig.amount > 0
					) // filter == get all valid tokens (vs find() => only the 1st)
					log("\n scan wallet for tokencontract " + tokenoriginjig.origin
						+ "\n DETECTED all nb jigs in wallet: " + jigs.length
						+ "\n DETECTED jigs of that contract in wallet: " + new_tokenstoconvert.length)

					for (let i = 0; i < new_tokenstoconvert.length; i++) {
						let new_token_toconvert = new_tokenstoconvert[i]
						log(" syncing token of origin " + new_token_toconvert.constructor.origin
							+ " at " + new_token_toconvert.origin)
						await new_token_toconvert.sync()
						log(" synced token, amount= " + new_token_toconvert.amount
							+ ", location= " + new_token_toconvert.location)
						if (new_token_toconvert.amount > 0) { // otherwise it is probably a destroyed token
							// in case of revoke we need to make sure the token is not one of the revoked tokens
							let revoked_token = false
							if (tokenoriginjig.isRevoked()) {
								if (new_token_toconvert.oldest_mint_count >= tokenoriginjig.revokercontract.revoke_count) {
									revoked_token = true
								}
							}
							if (!revoked_token) {
								log(" adding it to the array of tokenstoconvert...")
								tokenstoconvert.push(new_token_toconvert)
								log(" added successfully.")
							}
						}
					}
				}

				log(" now checking revoker contract...")
				let revokercontract = tokenoriginjig.revokercontract
				await revokercontract.sync()
				console.error(function_id + " DETECTED contract has been " + revokercontract.revoked_state)
				let new_token_contract = revokercontract.new_token_contract
				await new_token_contract.sync()

				if (new_token_contract) {
					console.error(function_id + " DETECTED new contract is " + new_token_contract.origin)
					tokenoriginjig = new_token_contract

					this.tokenoriginjig = new_token_contract // very important
					await this.setStateSafeAsync({
						tokenorigin: new_token_contract.origin,
						revokerJig: new_token_contract.revokercontract,
					})
				}
			}

			log("revokedetected:", revokedetected)
			if (revokedetected) {
				console.error(function_id + " DETECTED stop, reached active contract: "
					+ tokenoriginjig.origin + "")

				let vals = []
				for (let i_tokenstoconvert = 0; i_tokenstoconvert < tokenstoconvert.length; i_tokenstoconvert++) {
					let token = tokenstoconvert[i_tokenstoconvert]
					await token.sync();
					vals.push([token.amount, token.constructor.origin])
				}

				console.error(function_id + " found " + tokenstoconvert.length
					+ " tokens to convert:\n"+ JSON.stringify(vals))

				// now we check if we should exchange tokens
				if (tokenstoconvert.length > 0) {
					log(" scan over, DETECTED NEED TO CONVERT " + tokenstoconvert.length + " jigs")

					// bug with MyToken.convert() => the owner of the new tokens is the token class' owner ????!!!! because static function ???
					//var new_tokens = await tokenoriginjig.convert_tokens(Date.now(), ...tokenstoconvert) // converting to new tokens

					// new version without a static function
					let MyToken = tokenoriginjig // not .constructor !
					await MyToken.sync({ inner: true })
					log("tokenstoconvert[0].constructor.origin = "
						+ tokenstoconvert[0].constructor.origin + "\n   VS   "
						+ "\n MyToken.constructor.origin = " + MyToken.constructor.origin
						+ "\n MyToken.origin = " + MyToken.origin)

					let new_token = new MyToken(Date.now(), ...tokenstoconvert)

					log(" syncing new_token...")
					await new_token.sync()

					log(" finished converting all tokens to latest contract! \n new_token.amount = "
						+ new_token.amount, "\n new_token.origin = " + new_token.origin)
				}
				//
				//		UPDATE TOKEN ORIGIN IN DISK CACHE    BEWARE ONLY DO THIS AFTER THE CONVERSION, we don't want to update cache if conversion failed
				//
				// now WRITE THE NEW CONTRACT ON THE DISK & MAKE SURE IT RELOADS FROM DISK
				if (IS_IN_PRODUCTION) {
					if (!this.disksaved_tokenorigin) {
						this.disksaved_tokenorigin = get_store_WalletHistoryCache(run.owner.address + "_lastTokenContractOrigin") // will return null if not in production
					}
					// set the new token origin to disk
					this.disksaved_tokenorigin.set("lastTokenContractOrigin", tokenoriginjig.origin)
					this.disksaved_tokenorigin.set("last_set", Date.now())
				}

				// update tokenorigin in state and indicate to rendering that we are finised dealing with a revoke detected
				await this.setStateSafeAsync({
					tokenorigin: tokenoriginjig.origin,
					revokedetected: false,
					revokedetected_error: null,
				})
				this.forceReRender()

				this.reload_wallet() // does a forceReRender() too at the end
			} else {
				log("current contract is not backuped nor revoked.")
			}
			// release lock
			this.lock_check_revokestate_and_convertifneeded = false
		}
		catch (error) {
			let errormess = "Error in " + function_id + " : " + error.toString()
			console.error(errormess)
			await this.setStateSafeAsync({
				// revokedetected: true,  // we probably dont want to do this on any error
				revokedetected_error: function_id + error.toString()
			})
			this.forceReRender()
			
			// commenting bc don't release the lock on error otherwise it will pass it & keep converting to further contracts
			//this.lock_check_revokestate_and_convertifneeded = false // release lock 

			throw new Error(function_id + ".3 " + errormess)
		}
	}

	/**
	 * You can call throwRunError() when using run:
	 *		new Run(..)
	 *		await run.load(...)
	 *		await run.sync(...)
	 *NOT when calling others like get_run_asyncf() => throwContextError for those
	 *
	 * @param {*} error 
	 * @param {string} premess 
	 */
	throwRunError(error, premess = "") {
		// this.errormess = premess+error
		// this.throwContextError(error,  "RunError: "+premess)
		this.runContext.throwRunError(error, premess)
	}


	/**
	 * beware this will immediately display the error to the user 
	 */
	throwContextError(error, premess = "") {
		this.globalErrorContext.throwContextError(error, premess)

		// if error is a known non-fatal pattern (handled by global via needAutoReload), don't re-throw
		const msg = premess + String(error)
		if (
			msg.includes("WhatsOnChain API does not support spends")
			// || msg.includes("TokkenrBlockchain")
			// || msg.includes("Error: Cannot read location")
			// || msg.includes("not found in the transaction txid")
		) {
			return
		}

		// throw for callers to catch it
		throw new Error("UserContext: throwContextError(): " + premess + error)

	}


	resetGlobalError() {
		const function_id = this.classname + "resetGlobalError(): "
		let log = getLog(function_id)
		log()

		this.globalErrorContext.resetGlobalError()

		// setTimeout to leave delay for display to update, 200ms works well
		setTimeout(() => {
			// let's try again to load wallet
			// TODO check if we could have a PROBLEM IF RELOAD_WALLET FAILS IT WILL CREATE AN INFINITE LOOP OF RELOADING ? apparenly not
			this.reload_wallet()
		}, 200)

	}



	/* setStateSafe() only updates if there is a change to the state,
		because all setState() for context cause re-rendering!!!!
	*/
	async setStateSafe(newstate) {
		var keys = Object.keys(newstate)
		var shouldupdate = false
		for (let i = 0; i < keys.length; i++) {
			var ikey = keys[i]
			var obj = newstate[ikey]
			if (this.state[ikey] !== obj) {
				i = keys.length//stop loop
				shouldupdate = true
			}
		}
		// only update if necessary because all setState() cause re-rendering otherwise!
		if (shouldupdate) this.setState(newstate)
	}


	// this allows: await this.setStateSafeAsync({ load: true }); and be sure it is over after
	// cf https://medium.com/horizon-alpha/await-setstate-in-react-native-631d182e8738
	async setStateSafeAsync(newstate) {
		/* always resolve so no need for try-catch */
		return new Promise((resolve) => {
			var keys = Object.keys(newstate)
			var shouldupdate = false
			for (let i = 0; i < keys.length; i++) {
				var ikey = keys[i]
				var obj = newstate[ikey]
				if (this.state[ikey] !== obj) {
					i = keys.length//stop loop
					shouldupdate = true
				}
			}
			// only update if necessary because all setState cause re-rendering!!!!
			if (shouldupdate) this.setState(newstate, resolve)
			else return resolve()
		});
	}

	/**
	 * force re-render all sub-components that consume context, by incrementing a variable in the state.
	 */
	forceReRender = () => {
		const function_id = this.classname + "forceReRender(): "
		const log = getLog(function_id)

		log("increasing this.reloadCount to ", this.reloadCount + 1)
		this.setState(prevState => {
			return { reloadCount: prevState.reloadCount + 1 }
		})
		this.reloadCount += 1  // to deprecate ?
	}


	async _startloading(loader_function_id) {
		const function_id = "UserContext->_startloading(" + loader_function_id + "): "
		const log = getLog(function_id)

		if (!loader_function_id) {
			var errmess = "empty loader_function_id"
			console.error(function_id + errmess)
			throw new Error(function_id + errmess)
		}

		if (!this.loaders[loader_function_id]) this.loaders[loader_function_id] = 1
		else this.loaders[loader_function_id] += 1

		log("this.loaders[loader_function_id] =", this.loaders[loader_function_id] - 1)

		if (this.loaders[loader_function_id] > 100) {
			var errormess = "potential infinite loop with" + this.loaders[loader_function_id] + " call to " + loader_function_id
			console.error(function_id + errormess)
			throw new Error(function_id + errmess)
		}

		if (!this.isloading) {
			this.isloading = true
			if (!this.state.isloading) {
				await this.setStateSafeAsync({ isloading: true })
			}
		}

	}



	async _stoploading(loader_function_id) {
		const function_id = "UserContext->_stoploading(" + loader_function_id + "): "
		const log = getLog(function_id)

		if (!loader_function_id) {
			var errmess = "Error calling stoploading() with empty loader_function_id"
			console.error(function_id + errmess)
			throw new Error(function_id + errmess)
		}
		log("this.loaders[loader_function_id] =", this.loaders[loader_function_id])
		this.loaders[loader_function_id]--

		/*
		// BIG MISTAKE DO NOT DO THAT BECAUSE IT WILL ERASE THE VALUE JUST BEFORE WE RETURN IT!
		if(this.loaders[loader_function_id] == 0){
			//console.log(function_id+" == 0\n\tres = ", this.loaders_res[loader_function_id] )
			this.loaders_res[loader_function_id] = "no value" // we need this because the actual value might return null or undefined and we need to return those
		}
		*/
		if (this.loaders[loader_function_id] < 0) {
			throw new Error(function_id + " value of " + this.loaders[loader_function_id] + " for " + loader_function_id + "")
		}

		var nbloading = 0
		var loaders_keys = Object.keys(this.loaders)
		let str_loaders = ""
		//check if all loaders are at false (which means at 0)
		for (let loaders_key of loaders_keys) {
			if (this.loaders[loaders_key] > 0) {
				nbloading++
			}
			str_loaders += loaders_key + " " + this.loaders[loaders_key] + ", "
		}
		log("nbloading=", nbloading, "str_loaders=", str_loaders)

		if (nbloading == 0) {
			log("wallet has finished loading.")
			this.isloading = false
			if (this.state.isloading) {
				await this.setStateSafeAsync({ isloading: false })
			}

			if (loader_function_id === "create_new_wallet") {
				await this.setStateSafeAsync({
					create_new_wallet_ready: true,
				})
			}
			this.forceUpdate()
		}
	}


	/**
	 * returns result value from a loader function for debounced calls
	 */
	get_loader_res = async (loader_function_id) => {
		var function_id = "UserContext->get_loader_res( " + loader_function_id + " ) : "
		const log = getLog(function_id)

		var trycounter = 0
		return new Promise(function(resolve, reject) {
			(async function waitForLoaderRes() {
				trycounter += retryevery_ms
				if (trycounter > tryduring_ms) {
					try {
						var myerror = function_id + ": timed out after " + tryduring_ms / 1000 + " seconds"
							+ (this.errormess.length > 0 ? "\n" + this.errormess : "")

						return reject(myerror)
						//this.throwContextError(myerror, function_id) //this is better than reject(myerror) as it handles more stuff
					} catch (e) {
						//we need to try catch so we get the throw error to reject
						return reject(e)
					}
				}
				else {
					let nb_retry = parseInt(trycounter / retryevery_ms)
					log("nb_retry = ", nb_retry, " value=", this.loaders_res[loader_function_id])
				}
				// we use "no value" because the actual value might return null or undefined, in which case we need to return those
				if (this.loaders_res[loader_function_id] !== "no value") {
					// BEWARE THE RESULT MIGHT BE AN ERROR IN THIS CASE WE MUST REJECT WITH IT NOT RESOLVE!
					if (this.loaders_res[loader_function_id] instanceof Error) {
						return reject(this.loaders_res[loader_function_id])
					} else {
						return resolve(this.loaders_res[loader_function_id]);
					}
				}
				setTimeout(
					// bind allows us to pass 'this' context + arguments
					waitForLoaderRes.bind(this, loader_function_id),
					retryevery_ms
				)
			}.bind(this))();
		}.bind(this));
	}


	/**
	 * one of the advantages of this method is that all the wrapping logic is described just by this function
	 * isn't this the same as https://www.npmjs.com/package/p-debounce with "pDebounce.promise" mode ?
	 */
	launch_function_with_loaders = async (func, loader_function_id, ...args) => {
		var function_id = "UserContext->launch_function_with_loaders(" + loader_function_id + "): "
		const log = getLog(function_id)

		var res = null

		// prevent calling twice at the same time, instead await for the first func to end and return that value
		// if NOT first call:
		if (this.loaders[loader_function_id] && this.loaders[loader_function_id] > 0) {  // false if undefined or at 0, true above 0

			log("stacking call (wait for result of first call) " + this.loaders[loader_function_id])

			await this._startloading(loader_function_id)
			try {
				res = await this.get_loader_res(loader_function_id)
			} catch (error) {
				// this.loaders_res[loader_function_id] = error
				console.error(function_id + " Error in stacked call " + this.loaders[loader_function_id] + " \n error = ", error)
				await this._stoploading(loader_function_id)
				this.throwContextError(error, function_id)
			}
			log("normal end of stacked call " + this.loaders[loader_function_id])
			await this._stoploading(loader_function_id)
			return res
		}

		await this._startloading(loader_function_id)  // do this as soon as possible

		// if first call
		log("first call ")

		// we use "no value" because the actual value might return null or undefined and we need to return those
		this.loaders_res[loader_function_id] = "no value"

		try {
			res = await func.call(this, ...args)  // func.call allows us to pass the context
			this.loaders_res[loader_function_id] = res
			log("end of first call") // with res =",res)
			await this._stoploading(loader_function_id)
			// return res
		}
		catch (error) {
			var prefixmess = "first call failed with error: "
			this.loaders_res[loader_function_id] = new Error(function_id + prefixmess + error)

			await this._stoploading(loader_function_id)
			console.error(function_id + prefixmess, error)

			this.throwContextError(error, function_id + prefixmess)
		}

		return this.loaders_res[loader_function_id]
	}



	/**
	 * allows the password page to be used both for create_wallet & restore_from_mnemonic pages
	 */
	update_newpassword_previous = (mode) => {
		this.newpassword_previous = mode
		return true
	}
	get_newpassword_previous = (mode) => {
		return this.newpassword_previous
	}




	update_contract_origin_and_reload = async (new_contractorigin) => {
		const function_id = this.classname + "update_contract_origin_and_reload(): "
		let log = getLog(function_id)

		this.tokenoriginjig = null  // important to force reload
		const run = await this.runContext.get_run_asyncf()

		if (!new_contractorigin) {
			throw new Error(function_id + " Error: "
				+ "new_contractorigin is not valid : '" + new_contractorigin + "'")
		}

		log("start " + new_contractorigin)
		if (new_contractorigin !== this.state.tokenorigin) { //should we update ? 
			await this.reset_state_contract(new_contractorigin)

			const myOraclesUtils = new OraclesUtils()
			let tokenoriginjig = await myOraclesUtils.load_trustRecursive(run, new_contractorigin)
			log("tokenoriginjig.sync()...")
			await tokenoriginjig.sync()
		}
		else {
			window.alert("You are already on the right contract, click OK to reload wallet.")
		}

		try {
			log("new contract need reloading :\n\tnew_contractorigin = " + new_contractorigin + "\n\tthis.state.tokenorigin = " + this.state.tokenorigin)

			// we must reload_wallet() first to update addresses from privkeys
			await this.reload_wallet()
			await this.reload_all_contracts()
			await this.reload_wallet()

			if (IS_IN_PRODUCTION) {
				// hard update => override
				this.disksaved_tokenorigin.set("lastTokenContractOrigin", new_contractorigin)
				this.disksaved_tokenorigin.set("last_set", Date.now())
			}

			await this.syncWallet_nForceRerender()
		}
		catch (e) {
			this.throwContextError(e, function_id)
		}

		console.log(function_id + ": end")
	}




	/**
	 * will reload:
	 * 		- get_tokenoriginjig()
	 * 		- update multlist in state
	 * 		- check_revokestate_and_convertifneeded()
	 */
	reload_all_contracts = async () => {
		let function_id = this.classname + "reload_all_contracts(): "
		const log = getLog(function_id)

		log("start")

		let tokenoriginjig = null, myrun = null
		try {
		// load token contract
		// it's better to get the same jig than reload it to limit tx-mempool-conflict
		// retry with backoff because during startup get_run_asyncf() may still be
		// polling (it has its own 10-min loop in RunContext), and the first attempt
		// may fail before the run instance is ready.
		// Tightened from retries:5/minTimeout:1000 (up to ~16s cumulative backoff)
		// to retries:2/minTimeout:200 — the 10-min get_run_asyncf poll is what really
		// gates startup, so the long backoff here just stacked latency on top.
		tokenoriginjig = await retry(() => this.get_tokenoriginjig(), {
			retries: 2,		// 3 total attempts
			minTimeout: 200,
			maxTimeout: 2000,
			factor: 2,
		})
		}
		catch (error) {
			// throw as RunError because we don't call other this.functions but only do run operations
			console.error(error)
			this.throwRunError(error, function_id + ".1 : ")
			return // throwRunError may not re-throw — don't continue with tokenoriginjig=null
		}
		log("got tokenoriginjig, now syncing...")

		try {
			// sync supply with inner:true because we want the revokercontract, blacklist, etc synced
			await tokenoriginjig.sync({ inner: true })
			this._last_tokenoriginjig_sync_time = Date.now()
		}
		catch (error) {
			// throw as RunError because we don't call other this.functions but only do run operations
			console.error(error)
			this.throwRunError(error, function_id + ".1.5 : ")
			return
		}

		try {

			log("tokenoriginjig.supply = ", tokenoriginjig.supply)
			// log("tokenoriginjig.currency = "+tokenoriginjig.currency) // currency is now tokenName
			log("tokenoriginjig.decimalsDisplay = " + tokenoriginjig.decimalsDisplay)

			// Sync the 3 independent sub-contracts (revoker, blacklist, multlist) in
			// parallel. They are separate jigs referenced by tokenoriginjig, so
			// syncing them concurrently is safe and saves 2 sequential network
			// round-trips on the critical path. Each sub-contract's sync uses
			// inner:true to pull in nested refs (e.g. revoker.new_token.contract).
			//
			// We use Promise.allSettled so a failure in one sub-contract doesn't
			// prevent the others from syncing. Errors are surfaced via throwRunError
			// below, matching the original per-contract error semantics.
			const subcontracts = []
			if (tokenoriginjig.revokercontract) {
				subcontracts.push({ name: "revokercontract", jig: tokenoriginjig.revokercontract })
			} else {
				log("no revokercontract found")
			}
			if (tokenoriginjig.blacklist) {
				subcontracts.push({ name: "blacklist", jig: tokenoriginjig.blacklist })
			} else {
				log("no blacklist found")
			}
			if (tokenoriginjig.multlist) {
				subcontracts.push({ name: "multlist", jig: tokenoriginjig.multlist })
			} else {
				log("no multlist found")
			}

			log("syncing " + subcontracts.length + " sub-contracts in parallel:", subcontracts.map(s => s.name))
			const sub_results = await Promise.allSettled(
				subcontracts.map(s => s.jig.sync({ inner: true }).then(() => ({ name: s.name, jig: s.jig })))
			)

			// Process results: apply state updates for the ones that succeeded,
			// and throw on the first rejection (matches original early-return semantics).
			for (let i = 0; i < sub_results.length; i++) {
				const res = sub_results[i]
				const sub = subcontracts[i]
				if (res.status === "rejected") {
					const error = res.reason
					this.throwRunError(error, function_id + ".sync_" + sub.name + " : ")
					return
				}
				if (sub.name === "revokercontract") {
					log("loaded revokercontract = " + res.value.jig.location)
					await this.setStateSafeAsync({
						revokerJig: res.value.jig,
					})
				} else if (sub.name === "blacklist") {
					log("loaded blacklist.list = " + res.value.jig.list)
				} else if (sub.name === "multlist") {
					log("loaded multlist.list = " + res.value.jig.list)
					if (!isEqual(res.value.jig.list, this.state.multlist)) { //deepcompare
						await this.setStateSafeAsync({
							multlist: res.value.jig.list
						})
						this.forceReRender()
					}
				}
			}
		} catch (error) {
			// throw as RunError because we don't call other this.functions but only do run operations
			this.throwRunError(error, function_id + ".2 : ")
			return
		}

		try {
			myrun = await this.runContext.get_run_asyncf()
			log("calling check_revokestate_and_convertifneeded()...")
			// already_synced=true: tokenoriginjig.sync({inner:true}) was just done
			// above, no need to repeat it (saves a network round-trip on every reload).
			await this.check_revokestate_and_convertifneeded(myrun, tokenoriginjig, true)
		}
		catch (error) {
			// throw as RunError because we don't call other this.functions but only do run operations
			this.throwRunError(error, function_id + ".5 : ")
			return
		}
		/* // old:
		// reload_all_contracts(): BEWARE I DONT KNOW WHY BUT IF I DONT SYNC THE ADMINCOUNTER FIRST, AND THE BLACKLIST, THEN RUN WILL KEEP TRYING TO INIT() NEW CONTRACTS FOR THEM INFINITELY
		// seems to be when attaching a jig to another and loading the outer jig before the inner jig being synced before (which is impossible to do since you cannot attach without a method unless it's a class)
		// TODO TRY TO MAKE A DEMO_PAGE OF THAT FOR RUN CREATOR
		*/

		log("end success")
	}





	get_token_balance = async () => {
		const function_id = this.classname + "get_token_balance(): "
		const log = getLog(function_id)
		log("start")

		var myrun, totalmult, tokenoriginjig

		let start_time = Date.now()
		//load token contract
		try {
			// TODO see how to improve, this await is pretty slow, it takes ~27secs
			[myrun, totalmult, tokenoriginjig] = await Promise.all([
				this.runContext.get_run_asyncf(),
				this.get_total_mult(),  // this is the lowest of the 3 for now, takes 95% of the total time
				// it's better to get the same jig than reload it to limit tx-mempool-conflict risks
				this.get_tokenoriginjig(),
			])
		}
		catch (error) {
			// throw as RunError because we only do run operations
			this.throwRunError(error, function_id + ".1 :")
			return
		}
		log(">>> loaded totalmult =", totalmult, "in", (Date.now() - start_time), "ms")

		var tokens, decimals, decimalsDisplay
		try {
			decimals = tokenoriginjig.decimals
			decimalsDisplay = tokenoriginjig.decimalsDisplay
			if (!decimalsDisplay) {
				console.error(function_id + ": decimalsDisplay not found in tokenoriginjig at " + tokenoriginjig.origin)
				decimalsDisplay = 2
			}
			log(">>> decimals=", decimals, "decimalsDisplay=", decimalsDisplay)
			log("looking for jigs with origin " + tokenoriginjig.origin)

			await myrun.sync()  // is this still needed ?

			log("calling this.inventory_sync()")
			let start_time = Date.now()
			await this.inventory_sync()
			log("finished inventory_sync() in", (Date.now() - start_time), "ms")

			let jigs = this.getJigs(myrun)
			log("jigs.length = ", jigs.length)

			// we use filter to get all valid tokens (vs find() => only the 1st)
			let i = 0
			for (let jig of jigs) {
				i += 1
				log("jig", i, "class origin=", jig.constructor.origin, "for", jig.location)
			}
			tokens = jigs.filter(jig => jig instanceof tokenoriginjig)

			// we NEED to filter invalid timestamps otherwise we could display tokens that are locked into the future
			// by a malicious sender (because we let timestamp as a user-input on sending tokens)
			const margin_ms = 5 * 1000 // a small margin to give room for non problematic discrepancies (5000 for 5 seconds)
			tokens = tokens.filter(jig => jig.timestamp < Date.now() + margin_ms)

			const auto_call_contract_function = async (functionName = "melt") => {
				let function_id_local = function_id + "auto_call_contract_function(functionName='" + functionName + "'): "
				const loglocal = getLog(function_id_local)


				// TODO we may want to relax the  jig.satoshis > 0 constraint in the future ?
				const meltable_jigs = jigs.filter(jig => jig.satoshis > 0 && typeof (jig[functionName]) === "function")
				loglocal("meltable_jigs=", meltable_jigs)

				// Pre-sync all meltable jigs in parallel — these are independent reads
				// and were previously sequential (1 round-trip per jig). The actual
				// method call + post-call sync below MUST stay sequential because each
				// call broadcasts a tx that may spend from the same purse.
				if (meltable_jigs.length > 0) {
					loglocal("pre-syncing", meltable_jigs.length, "meltable jigs in parallel")
					await Promise.allSettled(meltable_jigs.map(jig => jig.sync()))
				}

				for (let i = 0; i < meltable_jigs.length; i++) {
					let meltable_jig = meltable_jigs[i]

					try {
						// after sync we need to check if the jig is still valid to extract
						if (meltable_jig && meltable_jig.satoshis > 0 && typeof (meltable_jig[functionName]) === "function") {
							loglocal("melting meltable_jig for " + meltable_jig.satoshis + " satoshis at", meltable_jig.location, ":\n", meltable_jig)
							loglocal(
								"typeof(meltable_jig)=", typeof (meltable_jig),
								"typeof(meltable_jig[functionName])=", typeof (meltable_jig[functionName]),
							)
							loglocal("meltable_jig[functionName]=", meltable_jig[functionName])
							loglocal("meltable_jig[functionName].call=", meltable_jig[functionName].call)
							meltable_jig[functionName]()  // tried .call() but it gave: "cannot call X on undefined"
							await meltable_jig.sync()
							loglocal("melted meltable_jig:", meltable_jig)
							this.update_balance_bsv()
							// TODO catch and display error about need for more bsv to melt ? quite paradoxal
						}
					} catch (e) {
						const error_mess = function_id_local + "Error catched for location " + meltable_jig.location + ":" + e
						loglocal("Error:", error_mess, e)
						console.error(error_mess, e)
					}
				}

			}
			// auto melt the meltable jigs (like BSV_Payment)
			await auto_call_contract_function("melt")
			await auto_call_contract_function("extract_satoshis")  // for admin_sell_requests
		}
		catch (error) {
			// throw as RunError because we don't call other this.functions but only do run operations
			this.throwRunError(error, function_id + ".3 :")
			return
		}

		log("# of utxos of the target token=", tokens.length, "tokenoriginjig.origin=", tokenoriginjig.origin)

		function amount_to_tokens_balance(total_amount) {
			const _totaltokens_premult = parseFloat(total_amount / Math.pow(10, decimals))
			log("_totaltokens_premult=", _totaltokens_premult)
			// tofixedown() important here because we rather show -1 than +1 which couldn't be sent entirely
			const _totalvalue_aftermult = toFixedDown((_totaltokens_premult * totalmult), decimalsDisplay)
			return _totalvalue_aftermult
		}

		let sum_amount = tokens.reduce((partialSum, a) => partialSum + a.amount, 0)
		let totalvalue_aftermult = amount_to_tokens_balance(sum_amount)

		log("sum_amount=", sum_amount, "totalvalue_aftermult=", totalvalue_aftermult)

		this.setState_update_token_balance(this.get_selected_coin_props().tokenid, totalvalue_aftermult)
		return totalvalue_aftermult

		/* // 18.12.2022 we used to require syncing() each utxo individually but it seems not needed anymore ?
		// keep this at least 2-3 months just to make sure
		try {
			// -- we resync each utxo individually bc of issues with last update missing (destroy), 09.02.2022

			var tokens_run_txids = tokens.map(token => token.location)
			log("# of utxos of the target token=", tokens.length, "\n", tokens_run_txids)
			const all_promises = []
			let nb_finished = 0

			const sync_and_return_amount = async (i, curr_token, nb_tokens) => {
				await curr_token.sync()
				nb_finished += 1
				log("> finished loading utxo " + i + "\t progress: " + nb_finished + "/" + nb_tokens + " \t amount: " + curr_token.amount
					+ "\t value: " + curr_token.amount * totalmult / Math.pow(10, decimals)
					+ "\t location: " + deepcopy(curr_token.location)
				)
				return curr_token.amount
			}

			for (var i = 0; i < tokens.length; i++) {
				all_promises.push(sync_and_return_amount(i, tokens[i], tokens.length))
			}
			const start_time = Date.now()
			const all_amounts = await Promise.all(all_promises)
			log("finished loading all_amounts in ", (Date.now() - start_time), "ms :", all_amounts)
			const sum_amount = all_amounts.reduce((partialSum, a) => partialSum + a, 0)

			var totalvalue_aftermult = amount_to_tokens_balance(sum_amount)

			log("sum_amount=", sum_amount, "totalvalue_aftermult=", totalvalue_aftermult)

			this.setState_update_token_balance(this.get_selected_coin_props().tokenid, totalvalue_aftermult)

			return totalvalue_aftermult
		}
		catch (error) {
			// throw as RunError because we don't call other this.functions but only do run operations
			this.throwRunError(error, function_id + ".4 :")
		}
		*/
	}




	get_total_mult = async () => {
		var function_id = this.classname + "get_total_mult(): "
		const log = getLog(function_id)

		// get_multlist() already computes total_mult from the multlist and sets
		// it in state (this.state.total_mult). We used to recompute it here
		// (TODO doublon, see comment in get_multlist) — now we just delegate
		// and read the value get_multlist already set, avoiding the duplicate
		// loop + setState.
		let start_time = Date.now()
		try {
			await this.get_multlist()
		}
		catch (error) {
			this.throwContextError(error, "UserContext->get_total_mult() :")
			return 1.0  // safe fallback (no mult means 1x)
		}

		const totalmult = this.state.total_mult || 1.0
		log("totalmult=", totalmult, "in", (Date.now() - start_time), "ms")
		return totalmult
	}



	// TODO rename into get_multlistjig_synced() for clarity
	get_multlistjig_synced = async () => {
		const function_id = this.classname + "get_multlistjig_synced(): "
		const log = getLog(function_id)

		log("start")
		let multlistjig = null, tokenoriginjig = null

		let start_time = Date.now()
		try {
			tokenoriginjig = await this.get_tokenoriginjig()
			log("got tokenoriginjig in", (Date.now() - start_time), "ms, now syncing...")
			start_time = Date.now()
			// diagnostic: log which blockchain is bound to this jig's Run instance
			if (tokenoriginjig && tokenoriginjig._run) {
				log("DIAGNOSTIC: tokenoriginjig._run.api=", tokenoriginjig._run.api,
					", tokenoriginjig._run.blockchain.api=", tokenoriginjig._run.blockchain?.api,
					", tokenoriginjig._run.blockchain.blockchains?=", tokenoriginjig._run.blockchain?.blockchains?.map(b => b.api))
			}
			await tokenoriginjig.sync()
			log("finished syncing tokenoriginjig in", (Date.now() - start_time), "ms")
		}
		catch (error) {
			// diagnostic on error: log the jig's bound Run and blockchain
			if (tokenoriginjig && tokenoriginjig._run) {
				console.error(function_id + "DIAGNOSTIC ON ERROR: tokenoriginjig._run.api=", tokenoriginjig._run.api,
					", tokenoriginjig._run.blockchain.api=", tokenoriginjig._run.blockchain?.api,
					", tokenoriginjig._run.blockchain.blockchains?=", tokenoriginjig._run.blockchain?.blockchains?.map(b => b.api))
			}
			this.throwRunError(error, function_id + ".1 multlistjig :")
			return
		}

		start_time = Date.now()
		try {
			multlistjig = tokenoriginjig.multlist
			// we should always sync to make sure we are at the latest state
			if (multlistjig) await multlistjig.sync()
			log("finished syncing multlistjig in", (Date.now() - start_time), "ms")
		}
		catch (error) {
			this.throwRunError(error, function_id + ".2 multlistjig = " + deepcopy(multlistjig) + " :")
			return
		}

		return multlistjig
	}



	get_revokerjig = async () => {
		const function_id = this.classname + "get_revokerjig(): "
		const log = (...props) => { console.log(function_id, ...props) }

		var revokerjig = null
		try {
			log("call get_tokenoriginjig...")
			let tokenoriginjig = await this.get_tokenoriginjig()
			revokerjig = tokenoriginjig.revokercontract
			// we should always sync to make sure we are at latest state
			await revokerjig.sync()
			// log("synced revokerjig.location = "+revokerjig.location)
			await this.setStateSafeAsync({ revokerJig: revokerjig })
		}
		catch (error) {
			this.throwRunError(error, function_id + ".1")
			return
		}
		log("revokerjig.origin=", revokerjig.origin)
		return revokerjig
	}



	/**
	 * sends the revoker contract to a new token address
	 */
	send_revokerContract = async (revoker_sendto) => {
		const function_id = this.classname + "send_revokerContract(): "
		const log = getLog(function_id)

		const tokenID = this.get_selected_coin_props().tokenid
		const tokenActionID = tokenID + "_sendRevoke"

		try {
			var revokerjig = await this.get_revokerjig()
			await revokerjig.send(revoker_sendto, Date.now())
			await revokerjig.sync()
		}
		catch (error) {
			return this.txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur lors de l'envoi de la transaction: ",
				{}, () => { this.syncWallet_nForceRerender() }
			)
		}

		this.txStateContext.sendtx_deal_with_success(
			function_id, tokenActionID,
			revokerjig.location, null,
			{}, () => {
				// refresh what has been impacted
				this.get_revokerjig()
				this.syncWallet_nForceRerender()
			}
		)

	}


	/**
	 * Publishes a new multiplicator (mintuple)
	 * 	values: new_mult=1.02 for +2% for example
	 * 	(beware calculating negative inflation is difficult, use percent_to_mult() )
	 */
	publish_mult = async (new_mult) => {
		const function_id = this.classname + "publish_mult(): "
		const log = getLog(function_id)

		const tokenID = this.get_selected_coin_props().tokenid
		const tokenActionID = tokenID + "_mintuple"

		var mult_contract = null
		try {
			mult_contract = await this.get_multlistjig_synced()

			let tokenoriginjig = await this.get_tokenoriginjig()  // todo remove this is you remove the use for unify()
			log("tokenoriginjig.sync()...")
			await tokenoriginjig.sync()

			// var run = await this.get_run()
			Run.util.unify(tokenoriginjig, mult_contract)

			mult_contract.publish(new_mult, Date.now())
			await mult_contract.sync()
		}
		catch (error) {
			return this.txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur lors de l'envoi de la transaction: ",
				{}, () => { this.syncWallet_nForceRerender() }
			)
		}

		this.txStateContext.sendtx_deal_with_success(
			function_id, tokenActionID,
			mult_contract.location, null,
			{}, () => {
				// refresh what has been impacted
				this.get_multlist()
				this.get_token_balance()
				this.get_tx_history()
				this.syncWallet_nForceRerender()
			}
		)

		// let's return the new location
		return mult_contract.location
	}



	get_multlist = async () => {
		var function_id = this.classname + "get_multlist(): "

		if (test_multlistfails) throw new Error("test_multlistfails")

		var multlistjig = null, start_time = Date.now()
		try {
			multlistjig = await this.get_multlistjig_synced()
		}
		catch (error) {
			this.throwRunError(error, function_id + ".1 ") // beware don't log jigs it will bug in prod
			return
		}
		if (!multlistjig) {
			// get_multlistjig_synced() caught an internal error and returned
			// undefined — bail out gracefully instead of throwing
			// "Cannot read properties of undefined (reading 'list')" below.
			log("get_multlistjig_synced() returned undefined, aborting")
			return
		}
		log("got synced multlistjig in", (Date.now() - start_time), "ms")
		var multlist = deepcopy(multlistjig.list)

		// ---------------------------------------
		// specific code to clean the 2 wrong mintuples from the delphe mistake of 01/10/2022 (where 3 instead of 1 were sent: 2x + correction)
		if (multlistjig.origin == "385ebd22491817fa6907e2ef155068ef1101b76200c6d5d651466f3628b6a1aa_o1") {
			multlist = clean_mistake_01102022(multlist)
		} // ---------------------------------------

		console.log(function_id + " multlist = ", multlist) // don't log jigs in prod it will bug!

		// force recompute total in state
		// (was a doublon with get_total_mult() — now resolved: get_total_mult()
		// just delegates to get_multlist() and reads this.state.total_mult)
		// turn function into getSync_multlist() ? to distinguish from userContext.multlist_list var

		var total_mult = 1.0
		if (multlist && multlist.length > 0) {
			for (var i = 0; i < multlist.length; i++) {
				total_mult *= multlist[i]
			}
		}

		this.setState({
			multlist_list: multlist,
			total_mult: total_mult,
		})

		return multlist
	}



	// TODO rename get_multlist_timestamps_synced() for clarity
	get_multlist_timestamps = async () => {
		const function_id = this.classname + "get_multlist_timestamps(): "
		const log = getLog(function_id)

		let multlist_timestamps = []
		let tokenoriginjig, multlistjig

		try {
			tokenoriginjig = await this.sync_tokenoriginjig_if_stale(5000)
			// log("tokenoriginjig=",tokenoriginjig) // don't log jigs in prod or it will bug!
		}
catch (error) {
            this.throwContextError(error, function_id + ".1 : cannot load tokenoriginjig")
            return
        }

		try {
			multlistjig = tokenoriginjig.multlist
			if (multlistjig) await multlistjig.sync()
		}
		catch (error) {
			this.throwRunError(error, function_id + ".2 : cannot sync multlistjig")
			return
		}

		multlist_timestamps = multlistjig.timestamps

		// -------------------------------------------
		// specific code to clean the 2 wrong mintuples from the delphe mistake of 01/10/2022 (where 3 instead of 1 were sent: 2x + correction)
		if (multlistjig.origin == "385ebd22491817fa6907e2ef155068ef1101b76200c6d5d651466f3628b6a1aa_o1") {
			multlist_timestamps = clean_mistake_01102022(multlist_timestamps)
		} // -------------------------------------------

		log("multlist_timestamps=", multlist_timestamps)

		this.setState({ multlist_timestamps: multlist_timestamps })

		// Persist mintuples for the selected coin so the Mintuples page can
		// hydrate instantly on the next cold start. In the reload_wallet flow
		// get_multlist() (which sets this.state.multlist_list) is awaited
		// before this fires, so both arrays are available here. cache_mintuples
		// guards on non-null arrays, so independent calls that run before
		// get_multlist simply skip caching that turn.
		this.cache_mintuples(this.state.selected_coin, this.state.multlist_list, multlist_timestamps)

		return multlist_timestamps
	}




	get_multlist_dates = async () => {
		const timestamps = await this.get_multlist_timestamps()
		// convert to dates
		var multlist_dates = []
		timestamps.forEach(function(timestamp) {
			multlist_dates.push(new Date(timestamp))
		})
		return multlist_dates
	}




	get_mnemonic_or_devmode = () => {
		if (this.state.mnemonic) {
			return this.state.mnemonic
		}
		else { // for dev mode
			return "No mnemonic found, should only happen in development mode."
				+ " Privkey purse : " + this.state.privkey_purse
				+ " Privkey owner : " + this.state.privkey_owner
		}
	}




	update_from_mnemonic_noreload = async (orig_mnemonic, network) => {
		const function_id = this.classname + "update_from_mnemonic_noreload(): "
		const log = getLog(function_id)

		while (orig_mnemonic[0] === " ") {
			orig_mnemonic = orig_mnemonic.substring(1, orig_mnemonic.length)  // remove spaces before
		}

		var mnemonic = orig_mnemonic

		function extract_first_word(first_word) {
			if (mnemonic.includes(first_word)) {
				var idx = mnemonic.indexOf(first_word)
				var length = first_word.length // ("delphe").length
				mnemonic = mnemonic.substring(idx + length, mnemonic.length)
				while (mnemonic[0] === " ") {
					mnemonic = mnemonic.substring(1, mnemonic.length)  // remove spaces before
				}
				log("extracted keyword '" + first_word + "' at the beginning of mnemonic ")
			}
		}
		extract_first_word("delphe")
		extract_first_word("tokkenR")
		extract_first_word("tokkenr")

		var bsvnetwork;
		if (network === "test") {
			bsvnetwork = bsv.Networks.testnet
		} else {
			bsvnetwork = bsv.Networks.mainnet
		}

		var privkey_purse = null, privkey_owner = null

		if (!mnemonic.includes(' ')) {
			// assume user entered 2 privkeys like '<privkey_purse>:<privkey_owner>', useful for debug/dev/tests
			privkey_purse = mnemonic.split(':')[0]
			privkey_owner = mnemonic.split(':')[1]
		}
		else {
			try {
				// DO NOT PRINT THIS mnemonic OBJECT BECAUSE IT CONTAINS THE SEED
				mnemonic = Mnemonic(mnemonic)
				// DO NOT PRINT THIS mnemonic OBJECT BECAUSE IT CONTAINS THE SEED
			} catch (error) {
				this.throwContextError(error, function_id + " Mnemonic(): ")
			}

			log("fromSeed() 1...")
			var hdPrivateKey = bsv.HDPrivateKey.fromSeed(mnemonic.toSeed(), bsvnetwork)  // this takes like 1 second, quite slow
			privkey_purse = hdPrivateKey.privateKey.toString()

			log("sha256()...")
			// generate a second one for owner from the seed + offset
			var hashed_seed = bsv.crypto.Hash.sha256(Buffer.from(mnemonic.toSeed() + offset_ownerprivkey))

			log("fromSeed() 2...")
			var hdPrivateKey2 = bsv.HDPrivateKey.fromSeed(hashed_seed, bsvnetwork)  // this takes like 1 second, quite slow
			privkey_owner = hdPrivateKey2.privateKey.toString()

			log("both privkeys were extracted from seed phrase.")
		}

		// retrieve addresses from privkeys (no Run instance needed)
		var owner_key = bsv.PrivateKey.fromString(privkey_owner)
		var purse_key = bsv.PrivateKey.fromString(privkey_purse)

		// important: force-reload the cached tokenoriginjig, it's tied to the previous wallet's run instance
		this.tokenoriginjig = null
		// also force run re-init so reload_wallet() creates a new Run instance with the new wallet's keys
		// (otherwise it would reuse the old wallet's Run and look at the wrong owner address)
		this.run_is_set = false

		await this.setStateSafeAsync({
			mnemonic: orig_mnemonic,
			privkey_owner: privkey_owner,
			privkey_purse: privkey_purse,
			network: network,
			address_owner: owner_key.toAddress().toString(),
			address_purse: purse_key.toAddress().toString(),
			isMockWallet: false,

			// important: reset previous wallet's financial/history data to defaults so stale values
			// (balance, supply, history, multlist, etc.) don't linger on screen until the new wallet's
			// reload_wallet() finishes re-fetching everything. Without this, the UI could keep showing
			// (or coincidentally re-confirm via isEqual() checks) the OLD wallet's data.
			...get_default_walletdata_state(),

			// We now have the live privkeys in memory, so there's no longer a
			// pending unlock. This must be cleared here (not only in
			// unlock_wallet_from_password) so that the file-restore and
			// create-new-wallet paths — which run update_from_mnemonic_noreload
			// while a *different* remembered wallet's blob is still staged for
			// unlock — don't bounce back to that other wallet's unlock screen
			// on the redirect to /wallet (display_wallet gates on this flag).
			awaiting_unlock: false,
			pending_unlock_info: null,
		})

		// drop any blob staged for unlock by componentDidMount — it belongs to
		// a different wallet than the one we just loaded into memory.
		this._pending_encrypted_blob = null

		// the purse address changed: the previous wallet's cached BSV tx
		// history is stale, so drop it (reload_wallet no longer resets it).
		this.reset_cache_history_bsv()

		this.initial_state = this.state  // important !

		// if a password was set by the caller (via setWalletPassword), persist
		// an encrypted session blob so the user stays logged in across refresh.
		// save_session_encrypted_wallet also checks password strength.
		if (this._walletPassword) {
			await this.save_session_encrypted_wallet(this._walletPassword, this._rememberDevice)
			this._walletPassword = null  // don't keep it longer than needed
		}
	}



	get_run_cache = (owner_address) => {
		const function_id = "get_run_cache(): "
		const log = getLog(function_id)

		log("isElectron=", isElectron())

		var run_cache = null
		try {
			if (isElectron()) {  // electron => prod
				// RunFileStore will automatically pre-populate with the disk-saved cache file
				// and prepopulated_cache
				run_cache = new RunFileStore(owner_address)
			}
			else {  // web => dev
				run_cache = new Run.plugins.BrowserCache({ maxMemorySizeMB: 500 })

				// prepopulate cache
				let keys = Object.keys(prepopulated_cache)
				for (let i = 0; i < keys.length; i++) {
					let key = keys[i]
					let val = prepopulated_cache[key]
					run_cache.set(key, val)
				}
				log("dev mode: prepopulated run_cache with ", keys.length, " entries.")
			}
		}
		catch (error) {
			this.throwRunError(error, function_id)
			return
		}

		return run_cache
	}


	init_run_and_caches_from_privkeys = async (privkey_owner, privkey_purse) => {
		const function_id = this.classname + "init_run_and_caches_from_privkeys(): "
		const log = getLog(function_id)
		log("start")

		let isMockWallet = false
		if (!privkey_owner && !privkey_purse) {
			log("displaying a MOCK mainnet wallet")
			// Generate the mock wallet by calling create_new_wallet(), which
			// atomically injects mnemonic + privkeys + addresses in a single
			// setStateSafeAsync call. Then read the generated keys back from
			// state so the Run instance below uses the same keys.
			await this.create_new_wallet()
			privkey_owner = this.state.privkey_owner
			privkey_purse = this.state.privkey_purse
			// Override isMockWallet to true (create_new_wallet sets it false)
			await this.setStateSafeAsync({ isMockWallet: true, walletname: "example wallet" })
			isMockWallet = true
			// Mock wallet has fresh random keys (no jigs/utxos, no localStorage
			// snapshot): hydrate explicit 0 balances so the wallet home renders
			// "0.00" immediately instead of skeletons.
			await this.hydrate_mock_wallet_zero_balances()
		}

		let start_time = Date.now()
		let run
		try {
			// retrieve owner address from privkey
			// Avoid a temporary Run instance — bsv.PrivateKey gives us the same
			// address without opening a stale run-browser-cache IDB connection.
			var owner_address = bsv.PrivateKey.fromString(privkey_owner).toAddress().toString()

			// create cache
			log("retrieving run cache at", (Date.now() - start_time), "ms")

			var run_cache = this.get_run_cache(owner_address)

			log("run cache retrieved at", (Date.now() - start_time), "ms")

			// create custom blockchain

			// the onchain cache was deprecated because it uses too much bsv for not enough usefulness for now
			// import { Wallet_History_Cache as Wallet_History_Cache_Offchain } from "./myjigs/TokenContract.js"

			// when we will give a blockchain, it will ignore network, api & apiKey so we need to add those here
			// const myblockchain = new Run.RemoteBlockchain(blockchain_options)

			let blockchain_params = {
				// only stringify-able values here
				network: defaultrunnetwork,
				api: defaultrunapi,
				// apiKey: 	API_KEY,
				timeout: RUN_TIMEOUT_MS,
			}
			let myblockchain
			if (this.state.disable_all_sync == true) {
				log("using NoFetchBlockchain")
				resetSharedWhatsOnChainConnector() // clear any previous singleton so it can be recreated
				myblockchain = new NoFetchBlockchain(blockchain_params, run_cache)
			} else {
				/* BEWARE THE NODE DOES NOT INDEXES BSV ADDRESSES SO IF YOU TRY TO RETRIEVE
				UTXOS FROM A PURSE IT WILL ANSWER AN EMPTY ARRAY */
				log("using CustomBlockchain")
				resetSharedWhatsOnChainConnector() // clear any previous singleton so it can be recreated
				myblockchain = new CustomBlockchain(blockchain_params, run_cache)
			}
			log("blockchain instance created at", (Date.now() - start_time), "ms")

			// create Run instance

			if (trustall) trustmode = '*'

			var runparams = {
				// network:      this.state.network,
				api: this.state.runapi,
				// apiKey: 		API_KEY,
				purse: privkey_purse,  // BEWARE do not print this it contains privkeys !!
				owner: privkey_owner,
				timeout: RUN_TIMEOUT_MS,
				networkTimeout: RUN_TIMEOUT_MS,
				app: app_field,
				trust: trustmode,
				blockchain: myblockchain,
			}
			if (run_cache) runparams.cache = run_cache

		log("waiting for update_run() at", (Date.now() - start_time), "ms...")
		run = await this.runContext.update_run(runparams, trustmode)
		run.trust("state") // meant to trust cache for better perfs according to RUN doc
		log("finished update_run() at", (Date.now() - start_time), "ms, to owner ", run.owner.address,
			"\n inventory.jigs.length =", this.getJigs().length)

		// tell the blockchain which script is the purse's, so the pending-spends
		// filter can record/track outpoints spent by our own unconfirmed broadcasts.
		if (run.blockchain && typeof run.blockchain.set_purse_script === "function") {
			run.blockchain.set_purse_script(run.purse.script)
		}

		// safety check
		log("run.cache === run.blockchain.cache ? ", (run.cache === run.blockchain.cache))

			await this.setStateSafe({
				privkey_owner: run.owner.privkey,
				privkey_purse: run.purse.privkey,
				address_owner: run.owner.address,
				address_purse: run.purse.address,
			})
			owner_address = run.owner.address

			// Verify wallet history cache against the definitive run.owner.address.
			// _early_init_history_caches() (called at the top of reload_wallet)
			// already created the cache from this.state.address_owner + hydrated
			// tokens_txdata from IDB. In the common case the owner address
			// matches and this is a no-op. Only if it differs (rare edge case)
			// do we recreate it.
			const new_walletHistoryCache_filekey = owner_address + "_" + this.state.tokenorigin
			if (!this.wallet_history_cache || (this.wallet_history_cache.filekey != new_walletHistoryCache_filekey)) {
				log("owner address changed, recreating wallet_history_cache for", new_walletHistoryCache_filekey)
				const devBrowserCacheIdb = new DevBrowserCacheIdb(owner_address, this.state.tokenorigin)
				await devBrowserCacheIdb.init()
				/* beware adding tokenorigin in name will break keeping the entire history in case of a contract_backup
					=> deal with that later if the case arises */
				this.wallet_history_cache = new WalletHistoryCache(owner_address, this.state.tokenorigin, devBrowserCacheIdb)
				log("this.wallet_history_cache initialized: size=", this.wallet_history_cache.size,
					"last_seen_height=", this.wallet_history_cache.last_seen_height)
			} else {
				log("wallet_history_cache already initialized for", new_walletHistoryCache_filekey)
			}

			// Verify BSV history cache against the definitive run.purse.address.
			// _early_init_history_caches() (called at the top of reload_wallet)
			// already created the cache from this.state.address_purse + hydrated
			// it from IDB/localStorage. In the common case the purse address
			// matches and this is a no-op. Only if it differs (rare edge case)
			// do we recreate + re-hydrate.
			const purse_address_for_cache = run.purse.address
			const new_bsvCache_filekey = "bsv_" + this.state.network + "_" + purse_address_for_cache
			if (!this.bsv_history_cache || (this.bsv_history_cache.cachekey != new_bsvCache_filekey)) {
				log("purse address changed, recreating bsv_history_cache for", new_bsvCache_filekey)
				this.bsv_history_cache = new BsvHistoryCache(this.state.network, purse_address_for_cache)
				await this.bsv_history_cache.init()
				log("bsv_history_cache initialized: size=", this.bsv_history_cache.size)
				await this.hydrate_bsv_history_from_storage()
			} else {
				log("bsv_history_cache already initialized for", new_bsvCache_filekey)
			}

			// disk cache that stores the token contract origin

			if (IS_IN_PRODUCTION) {
				if (!this.disksaved_tokenorigin) {
					// will return null if not in production
					this.disksaved_tokenorigin = get_store_WalletHistoryCache(owner_address + "_lastTokenContractOrigin")
				}
				log("updating last_open for", owner_address + "_lastTokenContractOrigin")
				this.disksaved_tokenorigin.set("last_open", Date.now())
				this.disksaved_tokenorigin.set("lastTokenContractOrigin", this.state.tokenorigin)
			}

			// trusting (may be obsolete now, replace by trust:'cache' ?)

			if (!trustall) {
				// trust the smartcontracts
				/* // the onchain cache was deprecated because it uses too much bsv for not enough usefulness for now
				// if(wallet_history_cache_origin) run.trust(wallet_history_cache_origin.split('_')[0]) */
				if (this.state.tokenorigin) {
					await run.trust(this.state.tokenorigin.split('_')[0])
				}
				if (trusted_refs.length > 0) trusted_refs.forEach(trusted_ref => run.trust(trusted_ref))

				// TODO see if we can optimize because this is very slow
				if (this.state.tokenorigin) {
					const myOraclesUtils = new OraclesUtils()
					log("calling await myOraclesUtils.load_trustRecursive() with tokenorigin:", this.state.tokenorigin)
					let tokenoriginjig = await myOraclesUtils.load_trustRecursive(
						run, this.state.tokenorigin, true  // with_sync=true very important here
					)
					log("tokenoriginjig:", tokenoriginjig)
					if (!tokenoriginjig) {
						console.error(function_id + " failed to load tokenoriginjig for tokenorigin="
							+ this.state.tokenorigin + " — continuing without it")
					} else {
						try {
							log("tokenoriginjig.sync()... current location:", tokenoriginjig.location)
							start_time = Date.now()
							// TODO this is quite slow, see if we can make faster, idea: cache de latest location & reuse it when app reopens?
							await tokenoriginjig.sync()
							log("finished tokenoriginjig.sync() in", (Date.now() - start_time), "ms to location:", tokenoriginjig.location)
						} catch (syncError) {
							console.error(function_id + " tokenoriginjig.sync() failed, continuing:", syncError.message || syncError)
						}
					}
				}
			}

			// increase utxos splits to limit too-long-mempool-chain error from network
			run.purse.splits = NB_SPLITS

			log("\n purse address : " + run.purse.address,
				"\n owner address : " + run.owner.address)

			return run
		}
		catch (error) {
			NB_UPDATE_RUN_FAILS += 1
			log("NB_UPDATE_RUN_FAILS=", NB_UPDATE_RUN_FAILS)
			if (NB_UPDATE_RUN_FAILS >= MAX_NB_UPDATE_RUN_FAILS) {
				this.update_disable_all_sync(true, false)
			}
			this.throwRunError(error, function_id)
			return
		}
	}


	create_new_wallet = async () => {
		var function_id = this.classname + "create_new_wallet(): " // beware changing: check create_new_wallet_ready
		const log = getLog(function_id)

		log("start")

		await this.setStateSafeAsync({
			create_new_wallet_ready: false,
		})

		// Generate mnemonic + privkeys + addresses via the shared helper
		// (single source of truth for wallet generation logic).
		var data = this.generate_new_wallet()

		await simulate_loadingtime()

		// we setup everything needed to store the wallet as an encrypted backup
		await this.setStateSafeAsync({
			network: data.network,
			mnemonic: data.mnemonic,
			privkey_owner: data.privkey_owner,
			privkey_purse: data.privkey_purse,
			address_owner: data.address_owner,
			address_purse: data.address_purse,
			isMockWallet: false,

			// important: reset previous wallet's financial/history data to defaults, same reasoning
			// as in update_from_mnemonic_noreload()
			...get_default_walletdata_state(),

			// we just created a fresh wallet with live privkeys in memory: clear
			// any pending unlock staged by componentDidMount for a *different*
			// remembered wallet, otherwise /wallet would bounce back to that
			// wallet's unlock screen. See update_from_mnemonic_noreload().
			awaiting_unlock: false,
			pending_unlock_info: null,
		})
		// drop any blob staged for unlock by componentDidMount — it belongs to
		// a different wallet than the one we just created.
		this._pending_encrypted_blob = null
		this.tokenoriginjig = null  // force-reload, it's tied to the previous wallet's run instance
		this.run_is_set = false     // force run re-init with new wallet's keys on next reload_wallet()
		// the purse address changed: drop the previous wallet's cached BSV tx
		// history (reload_wallet no longer resets it).
		this.reset_cache_history_bsv()
		this.initial_state = this.state

		// if a password was set by the caller (via setWalletPassword), persist
		// an encrypted session blob so the user stays logged in across refresh.
		// save_session_encrypted_wallet also checks password strength.
		if (this._walletPassword) {
			await this.save_session_encrypted_wallet(this._walletPassword, this._rememberDevice)
			this._walletPassword = null  // don't keep it longer than needed
		}

		log("end")
	}



	/**
	 * converts a fullkey into: [ownerkey, pursekey, network]
	 */
	split_fullkey(mykey) {
		var function_id = "split_fullkey"
		var error

		if (mykey.length === 0) {
			error = function_id + " : Veuillez d'abord entrer une clé privée ou phrase mnémotechnique"
			this.throwContextError(error);
		}

		if (mykey.length !== 104) {
			error = function_id + " : Erreur la clé a pour longueur " + mykey.length + " au lieu de 104"
			this.throwContextError(error);
		}
		// splitter clé en les 2 clés owner & purse
		const privatekey_owner = mykey.slice(0, mykey.length / 2)
		const privatekey_purse = mykey.slice(mykey.length / 2)

		// private key = 52 chars + start with 'L' or 'K' mainnet & 'c' testnet
		var errormess = ""
		if (privatekey_owner.length !== 52) {
			errormess += "\nErreur : la clé owner ne fait pas la bonne taille, " + privatekey_owner.length + " au lieu de 52"
		}
		if (privatekey_purse.length !== 52) {
			errormess += "\nErreur : la clé owner ne fait pas la bonne taille, " + privatekey_purse.length + " au lieu de 52"
		}
		const owner_1st = privatekey_owner[0]
		const purse_1st = privatekey_purse[0]
		// 5 cas valides: c c, L L, K K, L K, K L
		// test cas invalides
		if ((owner_1st === "c" && purse_1st !== "c") || (owner_1st !== "c" && purse_1st === "c")) {
			errormess += "\nErreur : l'une des clés est testnet mais pas l'autre: '" + owner_1st + "' vs '" + purse_1st + "'"
		}
		if (!(owner_1st === "L" || owner_1st === "K" || owner_1st === "c")) {
			errormess += "\nErreur : la clé owner est invalide, début par '" + owner_1st + "'"
		}
		if (!(purse_1st === "L" || purse_1st === "K" || purse_1st === "c")) {
			errormess += "\nErreur : la clé purse est invalide, début par '" + purse_1st + "'"
		}
		if (errormess.length > 0) {
			this.throwContextError(errormess, function_id + " : ");
			return
		}

		var network = ""
		if (owner_1st === "c") network = "test"
		else network = "main"

		return [privatekey_owner, privatekey_purse, network]
	}



	// TODO make a generic React visual component to use it, where we should only need to say if it's int, float, str...
	/** (tip: call with callWithNamedArgs() for easier params!)
	 * This is a first attempt at making a generic function to call contracts with basic functions
	 * It should work well with useTxSender() to make it as generic as possible to update contracts
	 *
	 * taking as parameters:
	 *		- tokenActionID
	 *		- (optional) confirmMess
	 *		- (optional) confirmAction
	 *		- Contract
	 *		- update_func, function name to call
	 *		- func_params, params to pass to the function
	 *		- (optional) specific_state, the specific state to init txStateContext
	 *		- (optional) callback, function to refresh what needs to be on success/failure
	 * and it will:
	 *		- ask the user for manual confirmation
	 * 		- perform the asked update on the blockchain
	 *		- update the txState accordingly
	 */
	update_contract_generic = async (
		tokenActionID, confirmMess = null, confirmAction = null,
		Contract, update_func, func_params,
		callback = null, specific_state = {}
	) => {
		const [function_id, log] = getLogArray(this.classname + "update_contract_generic(" + tokenActionID + "):")
		/* if I want it to work with callWithNamedArgs(), it need an arrow function
			in which case the 'arguments' keyword doesn't work anymore */
		// const args_dict = func_and_args_to_obj(f, arguments)
		// // get all 3 in a single call
		// // const [function_id, log, args_dict] = getLogArray(this.classname+"update_contract_generic():", f, arguments)
		// log("args_dict=",args_dict)

		// default values
		const default_callback = () => { }
		confirmMess = confirmMess || "Êtes-vous sûr ?"
		confirmAction = confirmAction || "Envoyer"
		callback = callback || default_callback

		// make sure run has loaded
		var run = await this.runContext.get_run_asyncf()

		var confirmed = await confirmPopup(confirmMess, confirmAction)
		if (!confirmed) {
			log("aborted from popup")
			return // very important to return here!
		} else log("confirmed from popup")

		try {
			// -------------------------------------------------------

			// TODO reactivate these intermediary status updates to display to the user
			// do like updateTxState()
			// this.setState({ send_status_mess: "Synchronisation du contrat..." })

			await this.txStateContext.init_action(function_id, tokenActionID, specific_state)

			log("doing run.sync()...")
			run.activate()
			await run.sync()

			// // we assume Contract is already loaded, but we might need to also add the possibility
			// // to pass a location in the future
			// log("doing requestJig.sync()...")
			// var requestJig = await run.load(request_location)
			// await requestJig.sync()
			// log("called: requestJig=",requestJig)

			// this.setState({ send_status_mess: "Envoi en cours..." })
			Contract[update_func](...func_params)
			await Contract.sync()
			await run.sync()

			log("success: updated Contract=", Contract)
			// this.setState({ send_status_mess: "Envoi réussi" })

			this.txStateContext.sendtx_deal_with_success(
				function_id, tokenActionID,
				Contract.location, null,
				null, async () => {
					callback()
				}
			)
		}
		catch (error) {
			return this.txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur: le wallet n'a pas réussi à synchroniser.",
				null, async () => {
					callback()
				}
			)
		}
	}



	update_bsv_price = async () => {
		var function_id = this.classname + "update_bsv_price(): "
		const log = getLog(function_id)

		// var bsveur = 49.11  // default from 01.11.2022
		var bsveur = 15.47  // default from 28.12.2025

		try {
			log("awaiting get_cached_BSVEUR_price()...")
			bsveur = await get_cached_BSVEUR_price()
			log("new bsveur=", bsveur)
		}
		catch (e) {
			console.error(function_id + " error: " + e)
			// no need to throw, we will just use the default value
		}

		this.setState({ bsvprice: bsveur })
		this.cache_balances({ bsvprice: bsveur })
	}




	change_network_noreload = async (new_network) => {
		var function_id = this.classname + "change_network_noreload(): "
		console.log(function_id + " from " + this.state.network + " to " + new_network)
		await this.setStateSafe({
			network: new_network
		})
		// network changed (mainnet<->testnet): the cached BSV tx history belongs
		// to the other chain, so drop it (reload_wallet no longer resets it).
		this.reset_cache_history_bsv()
	}
	change_network_andreload = async (new_network) => {
		var function_id = this.classname + "change_network_andreload(): "
		console.log(function_id + " from " + this.state.network + " to " + new_network)
		await this.change_network_noreload(new_network)
		try {
			await this.reload_wallet()
		} catch (error) {
			this.throwContextError(error)
		}
	}


	_load_reloaded_tokenorigin = async (myrun, reloaded_tokenorigin) => {
		const function_id = this.classname + ""
		const log = getLog(function_id)
		//
		log(" trusting (1) reloaded_tokenorigin = " + reloaded_tokenorigin)

		// myrun.trust(reloaded_tokenorigin.split('_')[0]) // needed to be able to load it
		// var reloadedtokenoriginjig = await myrun.load(reloaded_tokenorigin)
		const myOraclesUtils = new OraclesUtils()
		myrun.activate()
		var reloadedtokenoriginjig = await myOraclesUtils.load_trustRecursive(myrun, reloaded_tokenorigin)
		log("reloadedtokenoriginjig.sync()...")
		await reloadedtokenoriginjig.sync()

		var hardcoded_is_in_reloaded_conversions = false

		if (reloadedtokenoriginjig.accepted_conversions && reloadedtokenoriginjig.accepted_conversions.length > 0) {
			const reloaded_accepted_conversions = reloadedtokenoriginjig.accepted_conversions
			for (var i = 0; i < reloaded_accepted_conversions.length; i++) {
				var reloaded_prev_origin = reloaded_accepted_conversions[i][0]
				if (this.state.tokenorigin === reloaded_prev_origin) {
					hardcoded_is_in_reloaded_conversions = true
				}
			}
		}
		log(" hardcoded_is_in_reloaded_conversions = " + hardcoded_is_in_reloaded_conversions)

		if (hardcoded_is_in_reloaded_conversions) {
			await this.setStateSafeAsync({ tokenorigin: reloaded_tokenorigin }) // soft update => keep one from disk, we will update later in get_tokenoriginjig
		}
		else {
			log(" trusting (2) this.state.tokenorigin = " + this.state.tokenorigin)
			myrun.trust(this.state.tokenorigin.split('_')[0])

			if (IS_IN_PRODUCTION) {
				this.disksaved_tokenorigin.set("lastTokenContractOrigin", this.state.tokenorigin) // hard update => override
				this.disksaved_tokenorigin.set("last_set", Date.now())
			}
		}
	}


	update_balance_bsv = async () => {
		var function_id = this.classname + "update_balance_bsv(): "
		const log = getLog(function_id)
		log("start")

		const run = await this.runContext.get_run_asyncf()
		// await run.sync() // useless now ?

		/* log("\n run.purse.address =",run.purse.address,
			"\n run.purse # of utxos =",(await run.purse.utxos()).length,
			"\n run balance=",await run.purse.balance(),
			"\n ---",
			"\n run.purse.address =",run.purse.address,
			"\n run.purse # of utxos =",(await run.purse.utxos()).length,
			"\n run balance=",await run.purse.balance(),
			"\n\n this.is_inventory_syncing=",this.is_inventory_syncing,
		) */

		/* to make sure we calculate from the utxos and then we
		compare with the value from: await run.purse.balance() */
		let utxos = await run.purse.utxos()
		let utxos_val = utxos.map(u => u.satoshis)
		let utxos_sum = utxos_val.reduce((a, b) => a + b, 0)
		log("run.purse: ", utxos.length, "utxos",  // TODO fix problem here returning 0 utxos on first load
			"\n utxos_sum=", utxos_sum,
			"\n utxos_val=", utxos_val,
			"\n utxos =", utxos,
		)

		/* // 17.12.2022 deprecating this because it seems too weird ?
		if (utxos && utxos[0] && utxos[0].amount) {
			// I don't know why yet but this case means the purse utxos are WRONG
			// for more info check the file : 
			// D:\Documents\Bitcoin\Delphe\interface\delpheclient\archives\2022\logs bugs\log_run_bug_purse_balance_20220216.yml
			// PROBLEM IS WE CANNOT DETECT IT WHEN THERE IS 0 UTXO !
			console.warn(function_id, "DETECTED WRONG UTXOS CAUSING WRONG PURSE BALANCE: aborting",
				"\n utxos_sum=", utxos_sum, utxos_val,
				"\n balance_bsv=", await run.purse.balance(),
				"\n get_purse_utxos=", await this.get_purse_utxos())
			return
		}
		*/

		if (utxos && utxos.length === 0) {
			// TODO we still end up here when we should have >0
			console.warn(function_id, "detected 0 utxos, is this right ?",
				"\n utxos_sum=", utxos_sum, "from", utxos_val,
				"\n balance_bsv (run.purse.balance())=", await run.purse.balance(),
				"\n await run.purse.utxos()=", await run.purse.utxos(),
				"\n address", run.purse.address,
			)
		}

		const balance_bsv = await run.purse.balance()
		if (balance_bsv !== utxos_sum) {
			console.warn(function_id, "detected invalid balance:",
				"\n balance_bsv=", balance_bsv,
				"\n utxos_sum=", utxos_sum, utxos_val,
			)
		}

		log("balance_bsv=", balance_bsv, "VS utxos_sum=", utxos_sum,
			", this.is_inventory_syncing=", this.is_inventory_syncing)

		this.setState({ balance_bsv: balance_bsv })
		this.cache_balances({ balance_bsv: balance_bsv })
	}



	/**
	 * Early BSV history cache creation + hydration, called at the very start
	 * of reload_wallet (before the slow init_run_and_caches_from_privkeys).
	 * Creates the BsvHistoryCache for (this.state.network + this.state.address_purse)
	 * and hydrates the in-memory caches from IDB + localStorage in milliseconds.
	 *
	 * init_run_and_caches_from_privkeys() will later verify the cache against
	 * the definitive run.purse.address and recreate it only if the address
	 * changed (rare edge case) — in the common case it's a no-op there.
	 */
	/**
	 * Early history cache creation + hydration, called at the very start of
	 * reload_wallet (before the slow init_run_and_caches_from_privkeys).
	 * Creates both the BsvHistoryCache and WalletHistoryCache from
	 * this.state (already flushed by update_from_mnemonic_noreload's
	 * setStateSafeAsync) and hydrates the in-memory caches from IDB +
	 * localStorage in milliseconds, so wallet pages that mount while
	 * reload_wallet is still running see the cached data on their first
	 * render instead of showing "chargement en cours...".
	 *
	 * init_run_and_caches_from_privkeys() will later verify both caches
	 * against the definitive run.owner.address / run.purse.address and
	 * recreate them only if the address changed (rare edge case).
	 */
	_early_init_history_caches = async () => {
		const function_id = this.classname + "_early_init_history_caches(): "
		const log = getLog(function_id)

		const network = this.state && this.state.network
		const purse = this.state && this.state.address_purse
		const owner = this.state && this.state.address_owner
		const tokenorigin = this.state && this.state.tokenorigin

		// --- BSV history cache (keyed per network + purse) ---
		if (network && purse) {
			const bsv_filekey = "bsv_" + network + "_" + purse
			if (!this.bsv_history_cache || this.bsv_history_cache.cachekey !== bsv_filekey) {
				log("creating bsv_history_cache for", bsv_filekey)
				this.bsv_history_cache = new BsvHistoryCache(network, purse)
				await this.bsv_history_cache.init()
				log("bsv_history_cache initialized: size=", this.bsv_history_cache.size)
			} else {
				log("bsv_history_cache already exists for", bsv_filekey)
			}
			await this.hydrate_bsv_history_from_storage()
			await this.hydrate_balances_from_storage()
			// hydrate mintuples for the currently selected coin so the
			// Mintuples page renders instantly on cold start. get_multlist() /
			// get_multlist_timestamps() (fired later in reload_wallet) will
			// overwrite these with fresh on-chain data (stale-while-revalidate).
			await this.hydrate_mintuples_from_storage(this.state.selected_coin)
		} else {
			log("network or purse not available yet, skipping BSV early init")
		}

		// --- Token history cache (keyed per owner + tokenorigin) ---
		// WalletHistoryCache holds the enriched per-tx token history entries
		// (loaded from IDB in its constructor). Hydrate this.state.tokens_txdata
		// from it so the Tokens history page renders instantly on cold start.
		if (owner && tokenorigin) {
			const token_filekey = owner + "_" + tokenorigin
			if (!this.wallet_history_cache || this.wallet_history_cache.filekey !== token_filekey) {
				log("creating wallet_history_cache for", token_filekey)
				const devBrowserCacheIdb = new DevBrowserCacheIdb(owner, tokenorigin)
				await devBrowserCacheIdb.init()
				this.wallet_history_cache = new WalletHistoryCache(owner, tokenorigin, devBrowserCacheIdb)
				log("wallet_history_cache initialized: size=", this.wallet_history_cache.size,
					"last_seen_height=", this.wallet_history_cache.last_seen_height)
			} else {
				log("wallet_history_cache already exists for", token_filekey)
			}

			// hydrate tokens_txdata from the cache so the Tokens history page
			// shows cached txs immediately (get_tx_history(), called at the end
			// of reload_wallet, will refresh + append new txs in the background).
			// Only fill when tokens_txdata is empty to avoid clobbering live state.
			if ((!this.state.tokens_txdata || this.state.tokens_txdata.length === 0)
				&& this.wallet_history_cache.size > 0) {
				let cached = this.wallet_history_cache.get_cache_array()
				if (cached && cached.length > 0) {
					// same ordering as get_tx_history_old(): sort by timestamp ascending
					cached = cached.slice()
					cached.sort(function(a, b) { return a.timestamp - b.timestamp })
					log("hydrating tokens_txdata from cache, count=", cached.length)
					await this.setStateSafeAsync({ tokens_txdata: cached })
				}
			}
		} else {
			log("owner or tokenorigin not available yet, skipping token early init")
		}
	}

	reload_wallet = async (force_update_run = false) => {
		var function_id = this.classname + "reload_wallet(): "
		const log = getLog(function_id)

		await this.setStateSafeAsync({ isloading: true })
		log("start, this.run_is_set=", this.run_is_set)

		// Early history cache hydration: create both the BsvHistoryCache (IDB)
		// and WalletHistoryCache (IDB) and hydrate the in-memory caches from
		// IDB + localStorage BEFORE the slow init_run_and_caches_from_privkeys()
		// runs (which takes seconds to create the Run instance). This way, if
		// the user navigates to a history page while reload_wallet is still
		// running, the component sees the hydrated cache on its very first
		// render instead of showing "chargement en cours..." for several seconds.
		// Uses this.state (network, address_purse, address_owner, tokenorigin),
		// which were set (and flushed) by update_from_mnemonic_noreload via
		// setStateSafeAsync.
		await this._early_init_history_caches()

		var run = null
		try {
			if (this.run_is_set) {

				run = await this.runContext.get_run_asyncf()
				log("this.state.balance_bsv =", this.state.balance_bsv, ", run =", run)

				if (run) {
					log("run.blockchain=", run.blockchain,
						", balance_bsv=", await run.purse.balance(), "for", run.purse.address,
						", this.is_inventory_syncing=", this.is_inventory_syncing)

					// NOTE: we intentionally do NOT call run.sync() or update_balance_bsv()
					// here anymore. Both are redundant with what happens below:
					//  - run.sync() is called inside sync_inventory_and_update_bsv_jigs_codes()
					//    (line ~3301) and inside get_token_balance() (line ~2057).
					//  - update_balance_bsv() is in the parallel fan-out block below
					//    (line ~3351). Calling it here too just doubled the purse.balance()
					//    fetch on every non-first reload.
					// Keeping this branch a pure log + get_run_asyncf() saves 2 network
					// round-trips off the critical path.
				}
			}

			if (!(this.state.privkey_owner.length > 0 && this.state.privkey_purse.length > 0)) {
				log("keys appear to be empty")
			}
			this.history_nbloaded = 0

			// we need to NOT call init_run_and_caches_from_privkeys() on reload !
			// otherwise we get some run "Contract not found in tx" errors, which bans some txs
			// and make inventory lack a TON of utxos, decreasing the token balance
			// this might be due to the cache & load_trustRecursive() ?
		// const balance_delphe = this.state.balance_delphe
		/*
		const balance_delphe = this.state.tokens_balance[this.get_selected_coin_props().tokenid]
		log("balance_delphe=", balance_delphe)
		*/
			if (force_update_run) this.run_is_set = false

			if (!this.run_is_set) {
				log("calling init_run_and_caches_from_privkeys()")
				let start_time = Date.now()
				run = await this.init_run_and_caches_from_privkeys(this.state.privkey_owner, this.state.privkey_purse)
				log("finished init_run_and_caches_from_privkeys() in", (Date.now() - start_time), "ms, run=", run)
				this.run_is_set = true

				this.forceReRender() // force re-render of all sub-components that consume context
				log("finished init_run_and_caches_from_privkeys(), run.owner.address=", run.owner.address)
			}
			else log("no new call to init_run_and_caches_from_privkeys() bc run_is_set=true")


			const sync_inventory_and_update_bsv_jigs_codes = async () => {
				// log("balance_bsv 2 (before inventory_sync) =", await run.purse.balance(), run.purse.address,
				// 	", this.is_inventory_syncing=", this.is_inventory_syncing)

				// let's start inventory sync asap because it's often the slowest part
				try {
					await this.inventory_sync()
				} catch (e) {
					console.error("inventory_sync() failed, continuing:", e.message || e)
				}
				// since this is not a new empty wallet we need to sync it
				try {
					await run.sync()
				} catch (e) {
					console.error("run.sync() failed after inventory_sync, continuing:", e.message || e)
				}

				// log("balance_bsv 2 (after inventory_sync) =", await run.purse.balance(), run.purse.address,
				// 	", this.is_inventory_syncing=", this.is_inventory_syncing)

				let jigs = this.getJigs()
				log("nbjigs  =", jigs.length)
				// "nbcodes =",run.inventory.code.length,)
				this.setState({
					nbjigs: jigs.length,
					// nbcodes: 	run.inventory.code.length,
				})

				/* // this was for debug but seems useless now ? 19.12.2022
				let utxos = await run.purse.utxos()
				let utxos_val = utxos.map(u => u.satoshis)
				let utxos_sum = utxos_val.reduce((a, b) => a + b, 0)

				log("run.purse: ", utxos.length, "utxos",
					"\n utxos_sum (balance_bsv)=", utxos_sum,
					"\n utxos_val=", utxos_val,
					"\n utxos =", utxos)

				log("balance_bsv 2 (after run.sync)=", await run.purse.balance(),
					run.purse.address, ", this.is_inventory_syncing=", this.is_inventory_syncing)
				*/

				/* // useless now ?
				setTimeout(async () => {
					log("balance_bsv 2 (but 2s later)=", await run.purse.balance(),
						run.purse.address, ", this.is_inventory_syncing=", this.is_inventory_syncing)
				}, 2000) */
			}

			// Kick off inventory_sync + run.sync + nbjigs setState WITHOUT awaiting it
			// first. The 6 follow-up calls below (get_token_balance, get_multlist,
			// reload_all_contracts, get_blacklist2d, update_bsv_price, update_balance_bsv)
			// only need run/get_tokenoriginjig, not a fully synced inventory — they have
			// their own single-flight mutexes. Running them concurrently with the slowest
			// part (inventory_sync) saves the inventory's full duration off the critical path.
			// NOTE: inventory_sync() has its own mutex + single-flight, so concurrent
			// dispatch from the follow-ups is safe — they'll all join the same in-flight
			// promise instead of re-running it.
			log("kicking off sync_inventory_and_update_bsv_jigs_codes() in parallel with the update fan-out")
			const inventory_promise = sync_inventory_and_update_bsv_jigs_codes()

// those are async but no need to await sequentially so we can call them in parallel
		// this is now very efficient and takes less than 2 secs to load
		//
		// Mock ("example") wallet: skip the two balance-fetch round-trips
		// (get_token_balance + update_balance_bsv). The mock wallet uses fresh
		// random keys with no jigs/utxos, so both would just return 0 — already
		// set by hydrate_mock_wallet_zero_balances(). Skipping them avoids two
		// pointless network calls on the mock-load path.
		const _isMock = !!(this.state && this.state.isMockWallet === true)
		var all_promises = [
			_isMock ? Promise.resolve() : this.get_token_balance(),
			this.get_multlist(),
			this.reload_all_contracts(),  // slower than others // will also check if conversion needed for backup/revoke
			this.get_blacklist2d(),
			this.update_bsv_price(),
			_isMock ? Promise.resolve() : this.update_balance_bsv(),
		]

			// NOTE: the BSV tx-history cache (data_cache_history_bsv /
			// data_cache_history_bsv_raw) is intentionally NOT reset here.
			// reload_wallet() is also triggered by Display_Wallet's first-load
			// effect (display_wallet.js) which re-fires whenever the wallet
			// layout remounts (e.g. navigating between "/" / "/home" and
			// "/wallet/*"). Resetting the cache here wiped the history every
			// time the user navigated away and back, forcing a full refetch +
			// loader. The cache is instead invalidated only where the purse
			// address / network actually changes (update_from_mnemonic_noreload,
			// create_new_wallet, change_network_noreload) and after a send
			// (Slide_Send_BSV), so navigating back shows cached txs instantly.

			log("awaiting updates (in parallel with inventory_sync)...", all_promises)
			await Promise.allSettled([inventory_promise, ...all_promises])
			let start_time = Date.now()
			log("finished awaiting updates in", (Date.now() - start_time), "ms")

			/* // useless now ?
			// seems like updating balance after all the rest has less issues than doing it before ?
			log("balance_bsv 4 =", await run.purse.balance(), run.purse.address,
				", this.is_inventory_syncing=", this.is_inventory_syncing) */

			// (simulate_loadingtime is intentionally NOT awaited on the hot path —
			// it's currently 0ms but kept as a debug knob. Awaiting it just adds a
			// microtask + the risk of someone bumping the constant back up.)
			simulate_loadingtime().catch(() => {})
			await this.setStateSafeAsync({ isloading: false })

			// these ones we start but do not await in this function.
			// Fire them immediately — the 200ms setTimeout they used to wait for
			// was just deferring already-cheap follow-ups that re-use cached data.
			this.get_multlist_timestamps()
			this.ownerIsAdmin()
			this.get_tx_history()
			this.getTokenSupply()  // slower than others

			log("end")
			this.forceReRender()  // this will force re-render of all sub-components that consume context
		}
		catch (e) {
			console.error(function_id + e)
			await this.setStateSafeAsync({ isloading: false })
		}
	}




	syncWallet_nForceRerender = async () => {
		var function_id = this.classname + "syncWallet_nForceRerender"
		console.log(function_id + " : start")

		// we sync the wallet to its latest state
		try {
			var myrun = await this.runContext.get_run_asyncf()
			myrun.activate()
			await myrun.sync()
			await this.inventory_sync()
		}
		catch (e) {
			this.throwContextError(e, function_id + " : ");
			return
		}
		await simulate_loadingtime()

		console.log(function_id + " : end")

		// this should force re-render of all sub-components that consume context => TODO broken doesn't seem to work
		this.forceReRender()
	}


	update_wallet_name = async (newwalletname) => {
		const function_id = "update_wallet_name(): "
		let log = getLog(function_id)

		log("newwalletname=", newwalletname)

		await this.setStateSafeAsync({ walletname: newwalletname })
		return true
	}


	reset_wallet = async () => {
		const function_id = this.classname + "reset_wallet(): "
		const log = getLog(function_id)

		log("start")
		await this.setStateSafeAsync({
			privkey_owner: "",
			privkey_purse: "",
			mnemonic: "",
			address_owner: "",
			address_purse: "",
			isMockWallet: false,
			weak_password_warning: null,
		})
		// NOTE: walletname is intentionally NOT cleared here — the mock wallet
		// initialization (init_run_and_caches_from_privkeys) sets it to
		// "example wallet". Clearing it to "" would cause display_wallet.js
		// to rename it to "unnamed wallet" before the mock init completes.
		// also clear the encrypted wallet blobs so we don't auto-redirect to unlock
		this.clear_session_encrypted_wallet()
		// force run re-init on next reload_wallet() — otherwise the old Run
		// instance (with the old wallet's keys) would be reused and the mock
		// wallet would never be initialized when the user goes back to /wallet.
		this.run_is_set = false
		this.tokenoriginjig = null
		log("end")
	}


	// --- Pending wallet staging area ---
	//
	// During the create/restore flow, wallet data (mnemonic, walletname,
	// network) is stored in pending_wallet WITHOUT touching the real
	// wallet fields (mnemonic, privkey_owner, etc.). This prevents partial
	// wallet states. Only commit_wallet() at the end of the flow atomically
	// injects everything into the real wallet fields via
	// update_from_mnemonic_noreload.

	set_pending_wallet = async (data) => {
		const log = getLog("UserContext: set_pending_wallet:")
		log("data=", data ? { ...data, mnemonic: "..." } : null)
		await this.setStateSafeAsync({ pending_wallet: data })
	}

	clear_pending_wallet = async () => {
		const log = getLog("UserContext: clear_pending_wallet:")
		log("clearing pending_wallet")
		await this.setStateSafeAsync({ pending_wallet: null })
	}

	/**
	 * Generates mnemonic + privkeys + addresses WITHOUT injecting into
	 * state. Extracted from create_new_wallet() so the create flow page
	 * can store the result in pending_wallet instead of touching real
	 * wallet fields. Returns { mnemonic, privkey_owner, privkey_purse,
	 * address_owner, address_purse, network }.
	 */
	generate_new_wallet = () => {
		const function_id = this.classname + "generate_new_wallet(): "
		const log = getLog(function_id)
		log("start")

		var bsvnetwork
		if (this.state.network === "test") {
			bsvnetwork = bsv.Networks.testnet
		} else {
			bsvnetwork = bsv.Networks.mainnet
		}

		var mnemonic = Mnemonic(Mnemonic.Words.FRENCH)

		let prefix_word = appConfig.name.toLowerCase()
		if (prefix_word == "tokkenr") prefix_word = "tokkenR"

		var string_mnemonic = prefix_word + " " + mnemonic.toString()

		var hdPrivateKey = bsv.HDPrivateKey.fromSeed(mnemonic.toSeed(), bsvnetwork)
		var privkey_purse = hdPrivateKey.privateKey.toString()

		// generate a second one for owner from the seed + offset
		var hashed_seed = bsv.crypto.Hash.sha256(Buffer.from(mnemonic.toSeed() + offset_ownerprivkey))

		var hdPrivateKey2 = bsv.HDPrivateKey.fromSeed(hashed_seed, bsvnetwork)
		var privkey_owner = hdPrivateKey2.privateKey.toString()

		var owner_key = bsv.PrivateKey.fromString(privkey_owner)
		var purse_key = bsv.PrivateKey.fromString(privkey_purse)

		log("generated new wallet, owner address=", owner_key.toAddress().toString())

		return {
			mnemonic: string_mnemonic,
			privkey_owner: privkey_owner,
			privkey_purse: privkey_purse,
			address_owner: owner_key.toAddress().toString(),
			address_purse: purse_key.toAddress().toString(),
			network: defaultrunnetwork,
		}
	}

	/**
	 * Final step of the create/restore flow: reads pending_wallet,
	 * atomically injects the wallet into state via
	 * update_from_mnemonic_noreload (mnemonic + privkeys + addresses in
	 * a single setStateSafeAsync), saves the encrypted session blob,
	 * then clears pending_wallet.
	 *
	 * Called from wallet_password.js handleBackupComplete.
	 */
	commit_wallet = async (password, rememberDevice) => {
		const function_id = this.classname + "commit_wallet(): "
		const log = getLog(function_id)
		log("start")

		const pending = this.state.pending_wallet
		if (!pending || !pending.mnemonic) {
			log("no pending_wallet to commit — aborting")
			return false
		}

		// set the wallet name before injecting (update_from_mnemonic_noreload
		// doesn't set walletname)
		if (pending.walletname) {
			await this.update_wallet_name(pending.walletname)
		}

		// stash password so update_from_mnemonic_noreload can save the
		// session blob
		this.setWalletPassword(password, rememberDevice)

		// atomically inject mnemonic + privkeys + addresses
		await this.update_from_mnemonic_noreload(pending.mnemonic, pending.network || this.state.network)

		// clear the staging area
		await this.setStateSafeAsync({ pending_wallet: null })

		log("wallet committed successfully")
		return true
	}


	// --- Encrypted wallet session storage (replaces raw privkey sessionStorage) ---
	//
	// The mnemonic is encrypted with the user's password using the same CryptoJS AES
	// scheme as generateBackupFile. The encrypted blob is stored in sessionStorage
	// (default, cleared on tab close) and optionally in localStorage (opt-in
	// "remember on this device", persists across browser restart).
	// Raw privkeys are NEVER persisted — they live only in this.state (in-memory)
	// for the duration of the session.

	/**
	 * Stashes the password (and remember-device flag) for use by the next
	 * save_session_encrypted_wallet() call. The password is kept in an instance
	 * var (NOT in this.state) so it doesn't trigger re-renders and isn't picked
	 * up by saveStateToSessionStorage.
	 */
	setWalletPassword(password, rememberDevice = false) {
		this._walletPassword = password
		this._rememberDevice = rememberDevice
	}

	/**
	 * Reads, validates and returns an encrypted wallet blob from the given storage.
	 * Returns null if missing, expired, or malformed.
	 */
	_read_encrypted_blob(storageKey, ttlMs) {
		try {
			const raw = (storageKey === REMEMBERED_WALLET_KEY)
				? localStorage.getItem(storageKey)
				: sessionStorage.getItem(storageKey)
			if (!raw) return null
			const blob = JSON.parse(raw)
			if (!blob || !blob.encrypted_mnemonic) return null
			// TTL check (blobs without ts are treated as expired)
			const ts = blob.ts || blob.filecreationtimestamp || 0
			if (ttlMs && ts && (Date.now() - ts > ttlMs)) {
				// expired — clean up
				if (storageKey === REMEMBERED_WALLET_KEY) localStorage.removeItem(storageKey)
				else sessionStorage.removeItem(storageKey)
				return null
			}
			return blob
		} catch (e) {
			return null
		}
	}

	/**
	 * Encrypts the current wallet's mnemonic with the given password and stores
	 * the encrypted blob in sessionStorage. If rememberDevice is true, also
	 * stores a copy in localStorage so the user doesn't need to re-import their
	 * seed on next browser restart.
	 *
	 * Uses the exact same AES encryption as generateBackupFile() so the stored
	 * blob format is identical to the backup file format.
	 */
	save_session_encrypted_wallet = async (password, rememberDevice = false) => {
		const function_id = this.classname + "save_session_encrypted_wallet(): "
		const log = getLog(function_id)

		if (!password) {
			log("no password provided, aborting")
			return
		}
		if (!this.state.mnemonic) {
			log("no mnemonic in state, aborting")
			return
		}

		// check password strength — if weak (score <= 1), set the
		// weak_password_warning flag so display_wallet can show a
		// dismissible banner nudging the user to change it. If strong,
		// clear any previous warning. This is the single choke point —
		// every path that saves a session blob (unlock, file-restore,
		// create-wallet, change-password) goes through here.
		// Done BEFORE generateBackupFile (which is slow due to Argon2id)
		// so the state is set before any redirect/render can happen.
		const strength = checkPasswordStrength(password)
		if (strength.score <= 1) {
			log("password is weak (score=" + strength.score + ", label=" + strength.label + ") — setting weak_password_warning")
			this.setState({ weak_password_warning: { score: strength.score, label: strength.label, tips: strength.tips } })
		} else {
			log("password is strong (score=" + strength.score + ") — clearing weak_password_warning")
			this.setState({ weak_password_warning: null })
		}

		// reuse generateBackupFile to get the encrypted blob in the standard format
		const blob = await this.generateBackupFile(password)
		blob.ts = Date.now()
		blob.owner_address = this.state.address_owner

		const blobStr = JSON.stringify(blob)
		sessionStorage.setItem(SESSION_WALLET_KEY, blobStr)
		log("saved encrypted wallet blob to sessionStorage, walletname=", blob.walletname)

		if (rememberDevice) {
			localStorage.setItem(REMEMBERED_WALLET_KEY, blobStr)
			log("saved encrypted wallet blob to localStorage (remember device)")
		} else {
			// if we're not remembering, make sure we don't leave an old remembered blob
			localStorage.removeItem(REMEMBERED_WALLET_KEY)
		}
	}

	/**
	 * Decrypts the pending encrypted blob (found by componentDidMount) with the
	 * given password, then loads the wallet via update_from_mnemonic_noreload.
	 * Also saves a fresh session blob (refreshing its TTL).
	 *
	 * Returns true on success, false on wrong password / failure.
	 */
	unlock_wallet_from_password = async (password) => {
		const function_id = this.classname + "unlock_wallet_from_password(): "
		const log = getLog(function_id)

		if (!this._pending_encrypted_blob) {
			log("no pending encrypted blob to unlock")
			return false
		}

		const blob = this._pending_encrypted_blob

		try {
			// Branch on the crypto-format discriminator. Old blobs (no `kdf`
			// field) fall through to the legacy CryptoJS path unchanged.
			var mnemonic = null
			if (isArgon2Blob(blob)) {
				mnemonic = await decryptMnemonic(blob, password)
				if (!mnemonic) {
					log("wrong password (argon2id decrypt failed / GCM tag mismatch)")
					return false
				}
			} else {
				var bytes = CryptoJS.AES.decrypt(blob.encrypted_mnemonic, password)
				mnemonic = bytes.toString(CryptoJS.enc.Utf8)
				if (!mnemonic || mnemonic.length === 0) {
					log("wrong password (empty legacy decrypt)")
					return false
				}
			}

			// stash password so update_from_mnemonic_noreload can re-save the session blob
			this.setWalletPassword(password, this._has_remembered_wallet())

			// clear the awaiting_unlock flag BEFORE loading (so reload_wallet can fire)
			await this.setStateSafeAsync({ awaiting_unlock: false, pending_unlock_info: null })

			// load the wallet from the decrypted mnemonic
			await this.update_from_mnemonic_noreload(mnemonic, blob.network || this.state.network)

			// save a fresh session blob (refreshes TTL) — also checks
			// password strength and sets weak_password_warning if needed
			await this.save_session_encrypted_wallet(password, this._has_remembered_wallet())

			// clear the stashed password — no longer needed
			this._walletPassword = null

			log("wallet unlocked successfully")
			return true
		} catch (err) {
			log("unlock failed:", err)
			// re-set awaiting_unlock since we cleared it
			await this.setStateSafeAsync({ awaiting_unlock: true })
			return false
		}
	}

	/**
	 * Removes the encrypted wallet blob from sessionStorage.
	 * Called by reset_wallet() and on explicit "lock" / "forget session" actions.
	 */
	clear_session_encrypted_wallet() {
		sessionStorage.removeItem(SESSION_WALLET_KEY)
		this._pending_encrypted_blob = null
	}

	/**
	 * Returns true if an encrypted wallet blob exists in sessionStorage
	 * or localStorage (remembered device). Used as a safety-net check by
	 * Display_Wallet's abandonment guard: a real, secured wallet always
	 * has a blob; a half-created wallet (abandoned mid-flow) does not.
	 *
	 * Arrow function so `this` (the instance) is captured lexically when
	 * the method is destructured into the context value (this.state).
	 */
	has_session_encrypted_wallet = () => {
		return !!(
			this._read_encrypted_blob(SESSION_WALLET_KEY, SESSION_WALLET_TTL_MS)
			|| this._read_encrypted_blob(REMEMBERED_WALLET_KEY, REMEMBERED_WALLET_TTL_MS)
		)
	}

	/**
	 * Removes the encrypted wallet blob from localStorage ("forget this device").
	 */
	clear_remembered_encrypted_wallet() {
		localStorage.removeItem(REMEMBERED_WALLET_KEY)
	}

	/**
	 * Returns true if a remembered wallet blob exists in localStorage.
	 */
	has_remembered_wallet() {
		return !!this._read_encrypted_blob(REMEMBERED_WALLET_KEY, REMEMBERED_WALLET_TTL_MS)
	}

	_has_remembered_wallet() {
		return !!localStorage.getItem(REMEMBERED_WALLET_KEY)
	}

	/**
	 * Returns the pending unlock info (walletname, address_owner, network)
	 * for the unlock screen to display, or null if not awaiting unlock.
	 */
	get_pending_unlock_info() {
		return this.state.pending_unlock_info
	}

	/**
	 * Reads the remembered wallet blob from localStorage and returns its
	 * display info ({ walletname, network, address_owner }) WITHOUT mutating
	 * any state. Used by Select_Wallet to show a "reopen last wallet" card.
	 * Returns null if no valid (non-expired) blob exists.
	 *
	 * Arrow function so `this` is captured lexically when destructured into
	 * the context value (this.state), like has_session_encrypted_wallet.
	 */
	get_remembered_wallet_info = () => {
		const blob = this._read_encrypted_blob(REMEMBERED_WALLET_KEY, REMEMBERED_WALLET_TTL_MS)
		if (!blob) return null
		return {
			walletname: blob.walletname || "",
			network: blob.network || null,
			address_owner: blob.address_owner || blob.owner_address || "",
		}
	}

	/**
	 * Re-detects an encrypted wallet blob in storage (session first, then
	 * remembered/localStorage), stashes it into _pending_encrypted_blob and
	 * sets awaiting_unlock so the app routes to the unlock screen.
	 *
	 * This is the same detection logic as componentDidMount step 2, extracted
	 * into a reusable method so Select_Wallet's "Open saved wallet" card can
	 * re-trigger it after reset_wallet() cleared the in-memory blob on mount.
	 *
	 * Returns true if a blob was found and unlock was prepared, false otherwise.
	 */
	prepare_unlock_from_storage = async () => {
		const log = getLog("UserContext: prepare_unlock_from_storage:")
		const sessionBlob = this._read_encrypted_blob(SESSION_WALLET_KEY, SESSION_WALLET_TTL_MS)
		const rememberedBlob = (!sessionBlob)
			? this._read_encrypted_blob(REMEMBERED_WALLET_KEY, REMEMBERED_WALLET_TTL_MS)
			: null
		const blob = sessionBlob || rememberedBlob
		if (!blob) {
			log("no encrypted blob found in storage")
			return false
		}
		log("found encrypted blob, walletname=", blob.walletname)
		this._pending_encrypted_blob = blob
		await this.setStateSafeAsync({
			awaiting_unlock: true,
			pending_unlock_info: {
				walletname: blob.walletname,
				address_owner: blob.address_owner || blob.owner_address,
				network: blob.network,
			},
			walletname: blob.walletname || "",
			network: blob.network || this.state.network,
			address_owner: blob.address_owner || blob.owner_address || "",
		})
		return true
	}


	/**
	 * Verifies that the given password decrypts the currently stored encrypted
	 * wallet blob (session first, then remembered/localStorage). Used by the
	 * settings "Export backup file", "Change password" and "Show seed phrase"
	 * flows to re-confirm the user knows the password before performing a
	 * sensitive action — without keeping the plaintext password in memory.
	 *
	 * Returns true on success, false on wrong password / no blob / failure.
	 * Never throws.
	 */
	verifyWalletPassword = async (password) => {
		const function_id = this.classname + "verifyWalletPassword(): "
		const log = getLog(function_id)

		if (!password) {
			log("no password provided")
			return false
		}

		// read the current blob (session first, then remembered) — same priority
		// as componentDidMount so we verify against the wallet the user is
		// actually using right now.
		const blob = this._read_encrypted_blob(SESSION_WALLET_KEY, SESSION_WALLET_TTL_MS)
			|| this._read_encrypted_blob(REMEMBERED_WALLET_KEY, REMEMBERED_WALLET_TTL_MS)
		if (!blob) {
			log("no encrypted blob found to verify against")
			return false
		}

		try {
			if (isArgon2Blob(blob)) {
				const mnemonic = await decryptMnemonic(blob, password)
				if (mnemonic && mnemonic.length > 0) {
					return true
				}
				log("argon2id decrypt failed (wrong password / tamper)")
				return false
			} else {
				// legacy CryptoJS path
				var bytes = CryptoJS.AES.decrypt(blob.encrypted_mnemonic, password)
				var mnemonic = bytes.toString(CryptoJS.enc.Utf8)
				if (mnemonic && mnemonic.length > 0) {
					return true
				}
				log("legacy decrypt failed (wrong password)")
				return false
			}
		} catch (err) {
			log("verifyWalletPassword error:", err)
			return false
		}
	}


	/**
	 * Changes the wallet password: re-encrypts the mnemonic (which is in
	 * this.state.mnemonic in memory) with the new password and overwrites the
	 * stored session/localStorage blob. No old-password verification is done
	 * here — callers MUST call verifyWalletPassword(oldPassword) first if they
	 * want to confirm the old password (the settings UI does this).
	 *
	 * The mnemonic is never read back from the blob: we re-encrypt from the
	 * in-memory plaintext, which is the same source generateBackupFile uses.
	 * This means the new blob is always in the current (Argon2id) format,
	 * regardless of the old blob's format — so changing the password also
	 * upgrades any legacy-format session/remembered blob in place.
	 *
	 * Returns true on success, false on failure.
	 */
	change_wallet_password = async (newPassword) => {
		const function_id = this.classname + "change_wallet_password(): "
		const log = getLog(function_id)

		if (!newPassword) {
			log("no new password provided")
			return false
		}
		if (!this.state.mnemonic) {
			log("no mnemonic in state — wallet must be unlocked first")
			return false
		}

		try {
			// preserve the current remember-device setting
			const rememberDevice = this._has_remembered_wallet()
			await this.save_session_encrypted_wallet(newPassword, rememberDevice)
			log("wallet password changed, session blob re-encrypted")
			// save_session_encrypted_wallet also clears/updates weak_password_warning
			return true
		} catch (err) {
			log("change_wallet_password failed:", err)
			return false
		}
	}

	/**
	 * Dismisses the weak-password warning banner for the current session.
	 * The warning will reappear on next unlock/load if the password is
	 * still weak — dismissing is per-session, not permanent.
	 */
	dismiss_weak_password_warning() {
		const function_id = this.classname + "dismiss_weak_password_warning(): "
		const log = getLog(function_id)
		log("dismissing weak_password_warning")
		this.setStateSafeAsync({ weak_password_warning: null })
	}


	generateBackupFile = async (encryptingpassword, overrideMnemonic) => {
		// const function_id = this.classname+"generateBackupFile(): "
		// const log=useLog(function_id)  // beware about logging mnemonics !

		if (!encryptingpassword) {
			throw new Error("A password is required to encrypt the backup file.")
		}

		// use overrideMnemonic if provided (e.g. from the password page which
		// captured it in componentDidMount), otherwise fall back to this.state.mnemonic.
		// This is needed because mnemonic is NOT in SESSION_STATE_ALLOWLIST — a
		// provider remount (e.g. webpack hot-reload) would lose it from state.
		const mnemonicToEncrypt = overrideMnemonic || this.state.mnemonic
		if (!mnemonicToEncrypt) {
			throw new Error("No mnemonic available to encrypt. Make sure your wallet is loaded before creating a backup.")
		}

		// encrypt the mnemonic with the password using Argon2id + AES-GCM
		// (replaces the old CryptoJS.AES.encrypt EVP_BytesToKey/MD5 scheme).
		// The legacy path is preserved on decrypt via the `kdf` discriminator.
		const enc = await encryptMnemonic(mnemonicToEncrypt, encryptingpassword)

		// add some useful metadata
		var currentdate = Date.now().toString()
		var currentdatestr = (new Date(Date.now())).toLocaleString("fr-FR")
		var data = {
			network: this.state.network,
			encrypted_mnemonic: enc.encrypted_mnemonic,
			kdf: enc.kdf,                          // NEW: "argon2id" discriminator
			salt: enc.salt,                        // NEW: base64 16-byte salt
			argon2_params: enc.argon2_params,      // NEW: {m,t,p,type}
			walletname: this.state.walletname,
			filecreationdate: currentdatestr,
			filecreationtimestamp: currentdate,
			wallet_version: WALLET_VERSION,  // for future key-derivation migration (unchanged: tracks offset_ownerprivkey)
			app_version: Constants.APP_VERSION,
		}

		return data
	}


	/*
		the part below is one of the most complex piece of code in this application
		
		for each tx we will create an object with these properties:
					finaltxdata.txhash
					finaltxdata.timestamp  // timestamp and date are either the one specified by the user or the one from the block (see TIMESTAMP_NBMINS_MARGIN)
					finaltxdata.date
					finaltxdata.action
					finaltxdata.sender
					finaltxdata.receiver
					finaltxdata.decimalsDisplay
					finaltxdata.decimals
					finaltxdata.action 
					finaltxdata.amount
					finaltxdata.premult_val 
					finaltxdata.txtime_val
					finaltxdata.postmult_val
					finaltxdata.effect_amount
					finaltxdata.action_count
					finaltxdata.blockheight  // this should never be 0 or -1 (unconfirmed) but always a correct value, if it's unconfirmed don't add it to the cache yet
		
		WALLET HISTORY CACHE JIG:
		
		these objects once loaded are pushed to a Wallet_History_Cache jig that acts as a cache
			if no jig of this type is found in the wallet then we create one that is empty
		it contains an object of object[txhash]->tx_object (which is like a hashmap)
			because this acts like a hashmap we can search if a txhash exist in the cache in O(1)
		
		this jig will also contain a "last_seen_height" and will only recheck tx that have a height equal to or above to this variable
		
		if the tx is in the cache (check with hashmap in O(1)) then we simply load the object from it
		if the tx is not in the cache we go through the whole process of generating the object, and once we have all the tx to add we add them all (so we do only 1 onchain tx to add all of them)
		
		--- 
		
		TODO in the future save on the user's disk a cached state of that jig to not have to sync it back to the origin to make loading RUN faster 
		
		TODO in case we cannot retrieve the history list from the API, or if becomes too big and the API requires pages, then we will start also saving an ordered list of the txhashes
			this will allow us to easily retrieve only the missing txhash from the API or create the ordered history even without the API (if it can't be reached for example)
			=> cache_jig.cache_ordered_location_history
		
	*/
	get_timestamp_from_blockheight = async (blockheight) => {
		const function_id = this.classname + "get_timestamp_from_blockheight(): "

		var blockheight_timestamp = null

		try {
			const wocConnector = await waitForSharedWhatsOnChainConnector()
			var blockdata = await wocConnector.fetchBlockByHeight(blockheight)
			blockheight_timestamp = timestamp_to_ms(blockdata.time)
			console.log(function_id + " blockheight_timestamp for block " + blockheight + " = " + blockheight_timestamp)
		}
		catch (error) {
			throw new Error(function_id + "Error getting timestamp from block " + blockheight + "\n" + error)
		}
		return timestamp_to_ms(blockheight_timestamp)
	}


	/**
	 * gets the current chain blockheight from the blockchain
	 */
	get_latest_height_from_blockchain = async () => {
		const function_id = this.classname + "get_latest_height_from_blockchain(): "

		var chain_blockheight = null

		try {
			const wocConnector = await waitForSharedWhatsOnChainConnector()
			var currblockdata = await wocConnector.fetchChainInfo()
			chain_blockheight = currblockdata.blocks
			console.log(function_id + " chain_blockheight = " + chain_blockheight)
		}
		catch (error) {
			throw (function_id + " : query for chain_blockheight failed\n", error)
		}
		return chain_blockheight
	}


	/**
	 * the blockheight is used to know if a transaction has been confirmed in a block
	 * 
	 * this function checks that the manual_timestamp is coherent (like not too far in the past or future)
	 * 
	 * @param {} myrun 
	 * @param {*} txhash 
	 * @param {*} manual_timestamp 
	 * @returns 
	 */
	get_final_timestamp_and_blockheight = async (myrun, txhash, manual_timestamp) => {
		const function_id = this.classname + "get_final_timestamp_and_blockheight(): "
		const log = getLog(function_id)

		var final_timestamp = null, tx = null, current_timestamp

		try {
			const wocConnector = await waitForSharedWhatsOnChainConnector()
			tx = await wocConnector.fetchTxInfo(txhash)

			// maintenant on doit vérifier que le timestamp manuel indiqué est crédible:
			// on recup le timestamp du block, et celui du block précédent
			// on a une variable de marge TIMESTAMP_NBMINS_MARGIN = 30 mins par exemple
			// si le timestamp indiqué est dans [prevblock_timestamp-TIMESTAMP_NBMINS_MARGIN, currentblock_timestamp] => alors ok.
			// sinon on prends à la place le timestamp du block actuel

			var isunconfirmed = false
			if (!tx.blockheight) isunconfirmed = true // previously if(!tx.confirmations && !tx.blockheight) || tx.confirmations == 0 || tx.blockheight <= 0)

			if (isunconfirmed) {  // unconfirmed tx (mempool) 
				// we will check that the user_timestamp is AFTER the chain_blockheight
				var chain_height = await this.get_latest_height_from_blockchain()
				var chainheight_timestamp = timestamp_to_ms(await this.get_timestamp_from_blockheight(chain_height))

				final_timestamp = manual_timestamp  // default is the manual_timestamp but we will check if it's correct

				/*
				PROBLEME on ne peut essayer de tricher sur le timestamp que lors d'un envoi d'une transaction (et pas lors d'une réception qu'on ne controle pas)
					on peut essayer de tricher en mettant un timestamp dans le futur ou dans le passé
					on ne peut tricher que par rapport au timestamp de la publication d'un multiplicateur
					mettre un timestamp dans le passé n'a aucun intérêt car on ne peut pas avoir PLUS de multiplicateurs ainsi
					par contre mettre un timestamp dans le futur donne un peu plus de chance d'avoir envoyé plus que prévu
					(au yeux du receveur et seulement si la tx de send() et le mintuple finissent dans le même block)
					mais tant que la tx est unconfirmed on ne connait pas le timestamp du block dans lequel elle sera minée
					on peut vérifier que le timestamp est entre le timestamp actuel et celui du dernier block - marge
					(pour le cas de plusieurs blocks minés à la suite très vite)
				TODO une meilleure solution en terme de fiabilité serait de considérer que toute transaction qui est dans le même
					block qu'un mintuple se voit appliqué ce mintuple de toute façon.
					ça éviterait d'avoir à jouer avec des timestamps qui sont moins fiables
				MAIS de toute façon dès que l'app à connaissance d'un nouveau mintuple elle l'applique à tout
					donc au final ce n'est même pas un problème !
				PAR CONTRE it probably was a smartcontract mistake to not allow a send with a manual_timestamp that is before the previous one
					because of this, we need to check if coins received have a manual_timestamp not too far into the future
					before showing them in the wallet
				*/

				current_timestamp = Date.now()

				if (manual_timestamp > current_timestamp) {  // si timestamp dans le futur
					final_timestamp = current_timestamp  // on le ramène au présent
					console.error(function_id + " found timestamp " + manual_timestamp + " in the future for tx " + txhash + "\n setting it at present timestamp of " + current_timestamp)
				}
				else if (manual_timestamp < chainheight_timestamp - TIMESTAMP_NBMINS_MARGIN * 60 * 1000) {  // inférieur au block precedent (avant tx) - marge
					final_timestamp = chainheight_timestamp + 1  // timestamp du dernier block + 1 pour signifier qu'elle n'est pas dans ce block car toujours unconfirmed 
					console.error(function_id + " found timestamp " + manual_timestamp + " in the past beyond margin for tx " + txhash + "\n setting it at prev_block timestamp+1 = " + chainheight_timestamp + 1)
				}
			}
			else {  // confirmed transaction
				var tx_blockheight = tx.blockheight
				var txblock_timestamp = await this.get_timestamp_from_blockheight(tx_blockheight)

				// transaction is in a block
				var previous_blockheight = tx_blockheight - 1
				final_timestamp = txblock_timestamp // default => the timestamp of the block
				// autre approche serait de dire que par défaut on fait confiance au manual_timestamp?

				// BEWARE in bitcoin the timestamp of block doesn't always increase !! it just has to be within a 2h margin
				// but block.mediantime does always increase = median of past 11 block timestamps
				// une solution pourrait être donc de verifier que: mediantime <= manualtime <= blocktime
				// avantage: c'est parfaitement fiable & pas besoin de requete en plus, mais ça fait vérifier en moyenne jusqu'à 5.5 blocs en arrière qui est un peu beaucoup peut-être ?
				// mais normalement en vérifiant juste entre 2 blocks, si les timestamps sont inversés (rare) c'est que les 2 blocks sont proches donc ça pose pas de probleme

				var fetchurl = "block/height/" + previous_blockheight
				log("fetchurl=", fetchurl)
				try {
					var blockdata = await wocConnector.fetchBlockByHeight(previous_blockheight)
					var prevblock_timestamp = timestamp_to_ms(blockdata.time)

					// on va vérifier si le manual_timestamp est logique selon le block d'avant et d'après ce timestamp, avec une marge
					// avec TIMESTAMP_NBMINS_MARGIN=0 => reviens à trier par blocs, puis au sein d'un bloc par manual_timestamps
					// normalement le manual_timestamp sera inférieur au txblock_timestamp, le temps qu'un nouveau block soit trouvé après l'envoi de la tx
					if (manual_timestamp <= txblock_timestamp + TIMESTAMP_NBMINS_MARGIN * 60 * 1000    // plus petit que le block miné (après tx) + marge
						&& manual_timestamp >= prevblock_timestamp - TIMESTAMP_NBMINS_MARGIN * 60 * 1000) { // plus grand que le block precedent (avant tx) - marge
						final_timestamp = manual_timestamp
					}
					else {
						var offbymins = -1
						if (manual_timestamp > txblock_timestamp) offbymins = manual_timestamp - txblock_timestamp
						if (manual_timestamp < prevblock_timestamp) offbymins = prevblock_timestamp - manual_timestamp
						offbymins = offbymins / 60 / 1000

						console.error(function_id
							+ " found timestamp " + manual_timestamp + " that is beyond margins for txhash "
							+ txhash + "\n setting it at txblock_timestamp = " + txblock_timestamp
							+ "\n\t tx_blockheight       = " + tx_blockheight
							+ "\n\t previous_blockheight = " + previous_blockheight
							+ "\n\t txblock_timestamp    = " + txblock_timestamp
							+ "\n\t prevblock_timestamp  = " + prevblock_timestamp
							+ "\n\t manual_timestamp     = " + manual_timestamp
							+ "\n\t off by minutes       = " + offbymins
						)
					}
				} catch (error) {
					console.error(function_id + "Error with tx " + txhash + " : " + error)
					console.error(function_id + "query for block.time failed, will assume final_timestamp = txblock_timestamp\n" + fetchurl)
				}
			}
		} catch (error) {
			// in order to not show errors if only whatsonchain doesn't reply:
			// instead of throwing here we just return the manual timestamp and let the tx as unconfirmed by providing a null blockheight
			console.error(function_id, error)

			// we just check that it is not in the future
			final_timestamp = manual_timestamp
			current_timestamp = Date.now()

			if (manual_timestamp > current_timestamp) {  // si timestamp dans le futur

				final_timestamp = current_timestamp  // on le ramène au présent

				console.error(function_id + " Catch Error: found timestamp " + manual_timestamp + " in the future for tx "
					+ txhash + "\n setting it at present timestamp of " + current_timestamp)
			}

			return [timestamp_to_ms(final_timestamp), null]
		}

		return [timestamp_to_ms(final_timestamp), tx.blockheight]
	}





	/**
	 * get all token-jigs for the current state.tokenorigin
	 * @return a list of jigs
	 */
	get_all_tokenJigs = async () => {
		const function_id = "get_all_tokenJigs(): "
		let log = getLog(function_id)
		log("called")

		var run = await this.runContext.get_run_asyncf()
		await run.sync()
		log("run synced, now syncing inventory...")
		await this.inventory_sync()
		log("inventory synced.")

		let jigs = this.getJigs(run)

		var token_alljigs = jigs.filter((jig) => {
			try {
				log("\n jig.location=", jig.location)

				// retry after syncing the jig, we had errors due to that
				// => no they were actually due to the prepopulated_cache banning txs that were needed to sync (swapbot contracts)
				// await jig.sync()

				log("\n jig.location=", jig.location, // this log might fail due to constuctor.origin so we keep multiple ones
					"\n jig.constructor.origin=", jig.constructor.origin,
				)
				return (
					jig.constructor.origin === this.state.tokenorigin
					&& jig.amount && jig.amount > 0
				)
			} catch (error) {
				// receiving such errors:
				// Error: Cannot read location. Hint: Sync the jig to assign it in a transaction Error: Cannot read location
				console.error(function_id + "caught error: " + error)
				return false
			}
		})

		// this is really necessary (!) example I had a bug when sending token through swapbot without it
		log("syncing jigs...")
		var promises_all = []
		async function _sync_jig(jig) {
			await jig.sync()
		}
		for (let i = 0; i < token_alljigs.length; i++) {
			promises_all.push(_sync_jig(token_alljigs[i]))
		}
		await Promise.all(promises_all)
		log("synced successfully.")

		return token_alljigs
	}


	/**
	 * retrieves amount for post-mult nbtokens passed as arg
	 * (meaning this function will calculate with mults automatically)
	 * @param {*} nbtokens 
	 * @param {?Array} prefetched_alljigs optional: if the caller already fetched the
	 *  full list of token jigs (via get_all_tokenJigs()), pass it here to avoid
	 *  re-fetching (and re-triggering a full inventory_sync()) a 2nd time uselessly.
	 * @return amount_nbtokens
	 */
	nbtokens_to_amount = async (nbtokens, prefetched_alljigs = null) => {
		var function_id = this.classname + "nbtokens_to_amount(): "
		const log = getLog(function_id)

		/* we had nbtokens= 100.0000000186879 giving NotEnoughTokensError because of :
				> Number of UTXOs of this token: 1 	 totalamount= 6972707306
				nbtokens= 100.0000000186879 VS recalculated_nbtokens= 100
				amount_nbtokens= 6972707308  / totalamount= 6972707306 => amount_left= -2 => tokens_left= -2.8683263362652975e-8
		*/
		nbtokens = toFixedDown(nbtokens, 2)

		var delphe_nbsend = nbtokens

		// shouldn't be needed to sync here as it's done in lower functions
		// var run = await this.get_run()
		// await run.sync()

		var totalmultiplicators = await this.get_total_mult()

		// get all tokens from the correct origin (reuse prefetched list if the caller already has one)
		var tokenstosend_alljigs = prefetched_alljigs || await this.get_all_tokenJigs()

		var totalamount = 0
		tokenstosend_alljigs.forEach((token) => { // beware don't return values in forEach!
			totalamount += token.amount
		})

		var MyToken = await this.get_tokenoriginjig()
		var decimals = MyToken.decimals

		log("> Number of UTXOs of this token:", tokenstosend_alljigs.length,
			"\t totalamount=", totalamount)

		var amount_nbtokens = delphe_nbsend / totalmultiplicators * Math.pow(10, decimals)
		amount_nbtokens = parseInt(Math.abs(amount_nbtokens)) //safety checks

		// avoid the errors with sending or burning 99.99 instead of 100 (due to mintuples)
		var recalculated_nbtokens = parseFloat(amount_nbtokens * totalmultiplicators * Math.pow(10, -1 * decimals))
		recalculated_nbtokens = toFixedDown(recalculated_nbtokens, 2)
		log("nbtokens=", nbtokens, "VS recalculated_nbtokens=", recalculated_nbtokens, "for amount_nbtokens=", amount_nbtokens)
		if (recalculated_nbtokens < nbtokens) {
			amount_nbtokens = amount_nbtokens + 1
		}

		// if the amount left is below 0.01 tokens, then send everything
		var amount_left = totalamount - amount_nbtokens
		// note: if amount_left<0, then we will have tokens_left<0 too
		var tokens_left = amount_left * totalmultiplicators * Math.pow(10, -1 * decimals)

		log(" amount_nbtokens=", amount_nbtokens, " / totalamount=", totalamount,
			"=> amount_left=", amount_left, "=> tokens_left=", tokens_left)

		// sometimes the diff in amount_left is so small like -1 or -2 that we should ignore it, because the nbtokens is still right to the 2nd decimal
		if (recalculated_nbtokens === nbtokens && amount_left < 0) {
			log("ignoring amount_left < 0 (amount_left=", amount_left, ") because recalculated_nbtokens===nbtokens (", recalculated_nbtokens, "===", nbtokens, ")")
			amount_left = 0
			tokens_left = 0
		}

		if (tokens_left < 0 || amount_left < 0) {
			throw new NotEnoughTokensError(amount_nbtokens, totalamount, totalmultiplicators)
		}
		else if (tokens_left > 0 && tokens_left < 0.01) {
			log("tokens_left < 0.01 => sending all utxos")
			amount_nbtokens = totalamount // will force taking all utxos
		}

		return amount_nbtokens
	}



	/**
	 * retrieves utxo for post-mult nbtokens passed as arg
	 * (meaning this function will calculate with mults automatically)
	 * @param {*} nbtokens
	 * @param {boolean} skip_sync if true, assumes the wallet inventory is already synced
	 *  (from startup) and reads jigs directly from this.getJigs() instead of calling
	 *  get_all_tokenJigs() (which would sync ALL ~30 jigs individually, taking several
	 *  seconds). after selecting the jigs to send, only THOSE are synced.
	 *  the blockchain will throw a UTXO error if the inputs are already spent, so this
	 *  is safe. used by sendtx_Token/mint_tokens/burn_tokens for speed.
	 * @return [tokenstosend_jigstocombine, amount_to_send]
	 */
	get_utxos_for_nbtokens = async (nbtokens, skip_sync = false) => {
		var function_id = this.classname + "get_utxos_for_nbtokens(): "
		const log = getLog(function_id)

		var MyToken
		try {
			MyToken = await this.get_tokenoriginjig()
		} catch (error) {
			this.throwContextError(error, function_id + ".1")
		}

		try {
			// since this function is called before sending tokens it is a good place to sync the blacklist
			if (MyToken.blacklist) {
				var blacklist = MyToken.blacklist
				await blacklist.sync({ inner: SYNC_INNER })
				//console.log(function_id+": synced blacklist = "+blacklist.list)
			}
		} catch (error) {
			this.throwContextError(error, function_id + ".2")
		}

		var tokenstosend_alljigs
		try {
			if (skip_sync) {
				// assume wallet inventory is already synced from startup/reload — read jigs
				// directly instead of calling get_all_tokenJigs() (which syncs ALL ~30 jigs
				// individually, taking several seconds). we'll sync only the SELECTED jigs
				// below after picking which ones we need.
				log("skip_sync=true => reading jigs directly from inventory (no full jig sync)")
				let jigs = this.getJigs()
				tokenstosend_alljigs = jigs.filter((jig) => {
					try {
						return (
							jig.constructor.origin === this.state.tokenorigin
							&& jig.amount && jig.amount > 0
						)
					} catch (error) {
						console.error(function_id + "caught error filtering jigs: " + error)
						return false
					}
				})
				log("found", tokenstosend_alljigs.length, "token jigs in inventory (skip_sync)")
			} else {
				tokenstosend_alljigs = await this.get_all_tokenJigs()
			}
		} catch (error) {
			this.throwContextError(error, function_id + ".3")
		}

		try {
			// pass the already-fetched tokenstosend_alljigs so nbtokens_to_amount() doesn't
			// call get_all_tokenJigs() (=> inventory_sync()) a 2nd time for nothing
			const amount_to_send = await this.nbtokens_to_amount(nbtokens, tokenstosend_alljigs)

			log("sending", nbtokens, "tokens => amount_to_send=", amount_to_send,
				"\n tokenstosend_alljigs.length=", tokenstosend_alljigs.length)

			// crée array des utxos à combiner pour l'envoi: tokenstosend_jigstocombine

			// sort from smallest to biggest amount
			// we want to do that to combine only smallest necessary UTXOs
			// => maximizes privacy by not combining all,
			// AND maximizes future load speed by reducing amount of UTXOs in wallet
			tokenstosend_alljigs.sort(function(a, b) {
				if (a.amount < b.amount) return -1
				else if (a.amount > b.amount) return +1
				else return 0
			})
			var tokenstosend_alljigs_sorted = tokenstosend_alljigs

			// --------------------------------------
			/* NOTE WE DONT WANT TO CHECK IF WE ARE SENDING MORE THAN THE WALLET HAS
				THIS IS BECAUSE THE WALLET ROUNDS DISPLAY TO 2 DECIMALS
				AND WE WANT TO STILL ALLOW SENDING ALL WITHOUT LEAVING SOME DUST TOKENS
				THIS IS ACHIEVED BY ENTERING A HIGHER VALUE THAN THE DISPLAYED ONE AVAILABLE
				THIS IS A FEATURE AND NOT A BUG
			*/
			// var totalmultiplicators = await this.get_total_mult()
			// // calculate total amount (before multipliers!) of all the token utxos owned
			// var totalamount = 0
			// var list_jigamount = []
			// for(var i = 0; i < tokenstosend_alljigs_sorted.length; i+=1) {
			// 	var jig = tokenstosend_alljigs_sorted[i]
			// 	totalamount += parseInt(jig.amount)
			// 	list_jigamount.push(jig.amount)
			// }
			// DO_NOT_DO_THIS	if(amount_to_send > totalamount ){
			// DO_NOT_DO_THIS		throw new NotEnoughTokensError(amount_to_send, totalamount, totalmultiplicators)
			// DO_NOT_DO_THIS	}
			// --------------------------------------

			// find utxos to combine
			var tokenstosend_jigstocombine = [] // goal
			var current_amount = 0 // compare to amount_to_send
			var nb_utxos = 0
			for (let i = 0; i < tokenstosend_alljigs_sorted.length && current_amount < amount_to_send; i += 1) {
				let amount_to_add = tokenstosend_alljigs_sorted[i].amount

				if (amount_to_add && amount_to_add > 0) {
					tokenstosend_jigstocombine.push(tokenstosend_alljigs_sorted[i])
					log("> utxo tokens:", tokenstosend_alljigs_sorted[i].amount)

					current_amount += tokenstosend_alljigs_sorted[i].amount
					nb_utxos += 1
				}
			}
			if (!current_amount || isNaN(current_amount)) {
				throw new Error("Error: current_amount is not a valid number:" + String(current_amount))
			}
			log("reached", current_amount, "with", nb_utxos, "utxos which is enough for", amount_to_send)

			// when skip_sync=true, we read jigs from inventory without syncing them.
			// now sync ONLY the jigs we'll actually use (1 for no-combine, a few for combine)
			// instead of all 30 — saves several seconds of network calls.
			if (skip_sync && tokenstosend_jigstocombine.length > 0) {
				log("syncing only the", tokenstosend_jigstocombine.length, "selected jigs (skip_sync)")
				await Promise.all(tokenstosend_jigstocombine.map(jig => jig.sync()))
				log("selected jigs synced successfully")
			}

			return [tokenstosend_jigstocombine, amount_to_send]

		} catch (error) {
			this.throwContextError(error, function_id + ".4")
		}
	}



	// version with blacklist as a separate class
	blacklist_address = async (address_toblacklist) => {
		const function_id = this.classname + "blacklist_address(): "
		const log = getLog(function_id)

		const tokenID = this.get_selected_coin_props().tokenid
		const tokenActionID = tokenID + "_blacklist"

		log("address_toblacklist=", address_toblacklist)

		address_toblacklist = unprefix_address(address_toblacklist)

		log("address_toblacklist (without prefix)=", address_toblacklist)

		var MyToken, blacklist;
		try {
			// it's better to get the same jig than reload it to limit tx-mempool-conflict
			MyToken = await this.get_tokenoriginjig()
			blacklist = MyToken.blacklist
			if (!blacklist) {
				// will be catched by sendtx_deal_with_error() below
				throw new Error("Error no blacklist specified in the token contract")
			}
			await blacklist.sync()
		}
		catch (error) {
			// this.throwContextError(error, function_id+".1 ")
			return this.txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur lors de la construction de la transaction: ",
				{}, () => { this.syncWallet_nForceRerender() }
			)
		}
		console.log(function_id + ": blacklist.list before = ", blacklist.list)
		try {
			blacklist.blacklist(address_toblacklist, Date.now())
			await blacklist.sync()
		}
		catch (error) {
			return this.txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur lors de l'envoi de la transaction: ",
				{}, () => { this.syncWallet_nForceRerender() }
			)
		}

		this.txStateContext.sendtx_deal_with_success(
			function_id, tokenActionID,
			blacklist.location, null,
			{}, () => {
				// reload what has been impacted
				this.get_blacklist2d()
				this.syncWallet_nForceRerender()
			}
		)


		console.log(function_id + ": blacklist.list after = ", blacklist.list)
	}


	/**
	 * updates blacklist2d in state + returns a 2d array of format:
	 * [[timestamp1, address1, action_count1], [t2, a2, ac2], ...]
	 */
	get_blacklist2d = async () => {
		const function_id = this.classname + "get_blacklist2d(): "
		let log = getLog(function_id)
		var MyToken, blacklist
		try {
			log("getting tokenoriginjig...")
			// it's better to get the same jig than reload it to limit tx-mempool-conflict
			MyToken = await this.get_tokenoriginjig()
			blacklist = MyToken.blacklist

			if (!blacklist) throw new Error(function_id + ": no blacklist specified in the token contract")
			await blacklist.sync({ inner: SYNC_INNER })
		} catch (error) {
			this.throwContextError(error, function_id + ".1")
		}

		try {
			log("blacklist loaded from origin:", blacklist.origin)
			// console.log(function_id+" synced blacklist = ",blacklist) // don't log jigs in prod !!
			log("synced blacklist.list=", blacklist.list)
		} catch (error) {
			this.throwContextError(error, function_id + ".2")
		}

		var blacklist2d = []
		for (var i = 0; i < blacklist.list.length; i++) {
			var new_entry = [
				(new Date(blacklist.timestamps[i])).toLocaleString("fr-FR"),
				blacklist.list[i],
				blacklist.list_action_numbers[i]
			]
			blacklist2d.push(new_entry)
		}
		// we need to reverse the array before returning
		blacklist2d = blacklist2d.reverse()

		this.setState({ blacklist2d: blacklist2d })

		return blacklist2d
	}



	revokerContract_freeze = async () => {
		var function_id = this.classname + "revokerContract_freeze(): "
		const log = getLog(function_id)

		const tokenID = this.get_selected_coin_props().tokenid
		const tokenActionID = tokenID + "_freeze" // or "mint_delphe" ?

		log("BUILDING TX to freeze, tokenActionID=", tokenActionID)

		var MyToken, revokercontract

		try {
			// it's better to get the same jig than reload it to limit tx-mempool-conflict
			MyToken = await this.get_tokenoriginjig()
			revokercontract = MyToken.revokercontract
			if (!revokercontract) throw new Error(function_id + ": no revokercontract found in the token contract")
			await revokercontract.sync({ inner: SYNC_INNER })
		}
		catch (error) {
			return this.txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur lors de la construction de la transaction: ",
				{}, () => { this.syncWallet_nForceRerender() }
			)
		}
		console.log(function_id + ": revokercontract before freeze = ", deepcopy(revokercontract))

		try {
			revokercontract.freeze(Date.now())
			await revokercontract.sync({ inner: SYNC_INNER })
		}
		catch (error) {
			return this.txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur lors de l'envoi de la transaction: ",
				{}, () => { this.syncWallet_nForceRerender() }
			)
		}
		console.log(function_id + ": revokercontract after freeze = ", deepcopy(revokercontract))
		this.txStateContext.sendtx_deal_with_success(
			function_id, tokenActionID,
			revokercontract.location, null,
			{}, () => {
				// refresh what has been impacted
				this.reload_wallet()
				this.syncWallet_nForceRerender()
			}
		)

	}



	revokerContract_backup = async (new_token_contract_origin) => {
		var function_id = this.classname + "revokerContract_backup(): "
		const log = getLog(function_id)

		if (!new_token_contract_origin || new_token_contract_origin.length === 0)
			throw new Error(function_id + "new_token_contract_origin cannot be empty")

		console.log(function_id + " start, new_token_contract_origin= " + new_token_contract_origin)

		const tokenID = this.get_selected_coin_props().tokenid
		const tokenActionID = tokenID + "_backup" // or "mint_delphe" ?

		// var currtx_state = await this.txStateContext.init_action(
		// 	function_id, tokenActionID
		// )
		log("BUILDING TX to backup, tokenActionID=", tokenActionID)

		// start by loading & syncing useful contracts
		let tokenoriginjig, revokercontract, run, new_token_contract

		try {
			run = await this.runContext.get_run_asyncf()
			tokenoriginjig = await this.get_tokenoriginjig()
			await tokenoriginjig.sync({ inner: true })

			revokercontract = tokenoriginjig.revokercontract
			if (!revokercontract) throw new Error(function_id + ": no revokercontract found in the current token contract")
			await revokercontract.sync({ inner: true })

			run.trust(new_token_contract_origin.split('_')[0])

			await run.cache.set("ban://" + new_token_contract_origin, false)  // make sure we can load it

			new_token_contract = await run.load(new_token_contract_origin)
			await new_token_contract.sync({ inner: true })  // inner:true because we want to sync the multlist & blacklist inside it !
		}
		catch (error) {
			return this.txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur lors de la construction de la transaction: ",
				{}, () => { this.syncWallet_nForceRerender() }
			)
		}

		/*
		// BEWARE I TRIED TO CALL DIRECTLY AT THE END OF BACKUP() AND REVOKE() IN THE SMARTCONTRACT: new_token_contract.allow_convert_from_previous_contract(this.admincounter)
		//    BUT SINCE THIS FUNCTION CHECKS THE REVOKERCONTRACT ITSELF IT CREATED AN INFINITE CHECKING LOOP IN THE SAME TX, MADE ALL WALLETS CREATED DISPLAY ON CONVERSION:
		// StateError: [jig RevokerContract] not found in the transaction txid: ...
		// or : 
		//  Error: Cannot read location Hint: Sync the jig to assign it in a transaction
		//
		// now we link to allow converting old tokens into new ones
		// BEWARE IMPORTANT TO DO THIS BEFORE BACKUP()
		try {
			console.log(function_id+"\n\ttokenoriginjig.location = "+tokenoriginjig.location+"\n\tnew_token_contract.location = "+new_token_contract.location)
			console.log(function_id+" backup by linking previous contract in new one...")
			Run.util.unify(new_token_contract, tokenoriginjig) // for safety
			new_token_contract.allow_convert_from_previous_contract(tokenoriginjig) // should not need to await
			await new_token_contract.sync()
			console.log(function_id+" backup & linking for conversion => success \n new_token_contract.location = "+new_token_contract.location)
		} catch (error){
			this.throwContextError(error, function_id+".3")
		}
		*/

		// now we backup in revokercontract
		try {
			Run.util.unify(new_token_contract, revokercontract)  // for safety
			revokercontract.backup(new_token_contract, Date.now())
			await revokercontract.sync({ inner: true })
		}
		catch (error) {
			return this.txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur lors de l'envoi de la transaction: ",
				{}, () => { this.syncWallet_nForceRerender() }
			)
		}

		this.txStateContext.sendtx_deal_with_success(
			function_id, tokenActionID,
			revokercontract.location, null,
			{}, () => {
				// refresh what has been impacted
				this.reload_wallet()
				this.syncWallet_nForceRerender()
			}
		)
	}



	revokerContract_revoke = async (revoke_count, new_token_contract_origin) => {
		var function_id = this.classname + "revokerContract_revoke(): "
		const log = getLog(function_id)

		if (!revoke_count || !Number.isInteger(revoke_count) || revoke_count <= 0)
			throw new Error(function_id + "invalid revoke_count, must be positive integer")

		if (!new_token_contract_origin || new_token_contract_origin.length === 0)
			throw new Error(function_id + "new_token_contract_origin cannot be empty")

		console.log(function_id + " start\n\trevoke_count= " + revoke_count + "\n\tnew_token_contract_origin= " + new_token_contract_origin)

		const tokenID = this.get_selected_coin_props().tokenid
		const tokenActionID = tokenID + "_revoke" // or "mint_delphe" ?

		log("BUILDING TX to revoke, tokenActionID=", tokenActionID)

		// start by loading & syncing useful contracts
		let tokenoriginjig, revokercontract, run, new_token_contract

		try {
			run = await this.runContext.get_run_asyncf()
			tokenoriginjig = await this.get_tokenoriginjig()
			await tokenoriginjig.sync({ inner: true })

			revokercontract = tokenoriginjig.revokercontract
			if (!revokercontract) throw new Error(function_id + ": no revokercontract found in the current token contract")
			await revokercontract.sync({ inner: true })

			run.trust(new_token_contract_origin.split('_')[0])

			await run.cache.set("ban://" + new_token_contract_origin, false)  // make sure we can load it

			new_token_contract = await run.load(new_token_contract_origin)
			// inner: true needed because we need to have multlist & blacklist with admincounter linked
			await new_token_contract.sync({ inner: true })
		}
		catch (error) {
			return this.txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur lors de la construction de la transaction: ",
				{}, () => { this.syncWallet_nForceRerender() }
			)
		}

		/*
		// BEWARE I TRIED TO CALL DIRECTLY AT THE END OF BACKUP() AND REVOKE() IN THE SMARTCONTRACT: new_token_contract.allow_convert_from_previous_contract(this.admincounter)
		//    BUT SINCE THIS FUNCTION CHECKS THE REVOKERCONTRACT ITSELF IT CREATED AN INFINITE CHECKING LOOP IN THE SAME TX, MADE ALL WALLETS CREATED DISPLAY ON CONVERSION:
		// StateError: [jig RevokerContract] not found in the transaction txid: ...
		// or : 
		//  Error: Cannot read location Hint: Sync the jig to assign it in a transaction
		//
		// now we link to allow converting old tokens into new ones
		// important to do before the backup!
		try {
			console.log(function_id+"\n\ttokenoriginjig.location = "+tokenoriginjig.location+"\n\tnew_token_contract.location = "+new_token_contract.location)
			console.log(function_id+" revoke by linking previous contract in new one...")
			Run.util.unify(new_token_contract, tokenoriginjig) // for safety
			new_token_contract.allow_convert_from_previous_contract(tokenoriginjig, revoke_count)
			await new_token_contract.sync({inner: true})
			console.log(function_id+" revoke & linking for conversion => success")
		} catch (error){
			this.throwContextError(error, function_id+".3")
		}
		*/

		// now we backup in revokercontract
		try {
			Run.util.unify(new_token_contract, revokercontract) // for safety
			revokercontract.revoke(revoke_count, new_token_contract, Date.now())
			await revokercontract.sync({ inner: true })
		}
		catch (error) {
			return this.txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur lors de l'envoi de la transaction: ",
				{}, () => { this.syncWallet_nForceRerender() }
			)
		}

		this.txStateContext.sendtx_deal_with_success(
			function_id, tokenActionID,
			revokercontract.location, null,
			{}, () => {
				// refresh what has been impacted
				this.reload_wallet()
				this.syncWallet_nForceRerender()
			}
		)
	}


	setState_update_token_balance = async (tokenID, new_token_balance) => {

		const function_id = this.classname + "setState_update_token_balance(): "
		const log = getLog(function_id)

		const tokens_balance = this.state.tokens_balance
		if (tokens_balance && tokenID in tokens_balance && isEqual(tokens_balance[tokenID], new_token_balance)) {
			log("aborting: already correct token balance for", tokenID, "of", new_token_balance)
			return
		}

		var new_tokens_balance = {
			...tokens_balance,
			[tokenID]: new_token_balance
		}
		log("\n old tokens_balance =", tokens_balance, "\n new tokens_balance =", new_tokens_balance)
		await this.setStateSafeAsync({
			tokens_balance: new_tokens_balance
		})
		this.cache_balances({ tokens_balance: new_tokens_balance })
	}



	create_contract = async (token_name, token_decimales) => {
		const function_id = this.classname + "create_contract(): "
		const log = getLog(function_id)

		if (!token_name) return
		if (this.sendtx_broadcast_lock) {
			this.throwContextError("Another transaction is already sending (sendtx_broadcast_lock taken)", function_id)
		}

		const tokenID = "" // "delphe"
		const tokenActionID = tokenID + "_createContract"  // or "mint_delphe" ?

		token_decimales = parseInt(token_decimales)

		const specific_state = {
			"token_name": token_name,
			"token_decimales": token_decimales,
		}
		var currtx_state = await this.txStateContext.init_action(
			function_id, tokenActionID, specific_state
		)

		log("BUILDING TX tokenActionID=", tokenActionID,
			", token_name=", token_name,
			", token_decimales=", token_decimales)

		var MyToken

		try {
			var run = await this.runContext.get_run_asyncf()

			var bsv_balance_before = await run.purse.balance()

			const update_tx_state = (new_state) => {
				currtx_state = {
					...currtx_state,
					...new_state,
				}
				this.txStateContext.setTxState(tokenActionID, currtx_state)
				this.syncWallet_nForceRerender()
			}

			const update_status_detail_jsx = (string_to_add) => {
				string_to_add = String(string_to_add)
				log("update_status_detail_jsx(): ", string_to_add)
				// we need to create a new object for context to update the ref & propagates
				if (!currtx_state) currtx_state = {}
				var prev_status_detail_jsx = null
				if (currtx_state["status_detail_jsx"]) {
					prev_status_detail_jsx = currtx_state["status_detail_jsx"]
				}
				update_tx_state({
					"status_detail_jsx": <Fragment>
						{prev_status_detail_jsx}<br />
						{string_to_add}
					</Fragment>
				})
			}

			update_status_detail_jsx("") // new line
			MyToken = await RunTools.deploy_new_extended_jig(
				run, token_decimales, token_name, update_status_detail_jsx, true
			) //, myTokenContract, multlist, blacklist, revokercontract, token_decimales, token_name)

			update_status_detail_jsx("") // new line
			update_status_detail_jsx("> deployed main contract at origin:" + MyToken.origin
				+ "\n linking sub contracts to main contract...")

			await MyToken.sync()

			var multlist = MyToken.multlist
			var blacklist = MyToken.blacklist
			var revokercontract = MyToken.revokercontract

			// LINK MAIN CONTRACT TO SUB CONTRACTS

			await multlist.sync()
			await MyToken.sync()
			multlist.linkAdminCounter(MyToken)
			await multlist.sync()
			update_status_detail_jsx("> multlist at location:" + multlist.location)

			await blacklist.sync()
			await MyToken.sync()
			blacklist.linkAdminCounter(MyToken)
			await blacklist.sync()
			update_status_detail_jsx("> blacklist at location:" + multlist.location)

			await revokercontract.sync()
			await MyToken.sync()
			revokercontract.linkAdminCounter(MyToken)
			await revokercontract.sync()
			update_status_detail_jsx("> revoker contract at location:" + multlist.location)

			// specific field for display
			update_tx_state({ "contractOrigin": MyToken.origin })

			// calculate total bsv fee paid
			var bsv_balance_after = await run.purse.balance()
			const bsvfee_total = bsv_balance_before - bsv_balance_after

			this.txStateContext.sendtx_deal_with_success(
				function_id, tokenActionID,
				MyToken.location, bsvfee_total,
				{}, () => { this.syncWallet_nForceRerender() }
			)
		}
		catch (error) {
			return this.txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur lors de la construction de la transaction: ",
				{}, () => { this.syncWallet_nForceRerender() }
			)
		}
	}



	mint_tokens = async (nb_to_mint) => {
		const function_id = this.classname + "mint_tokens(): "
		const log = getLog(function_id)

		if (nb_to_mint <= 0) return
		if (this.sendtx_broadcast_lock) {
			this.throwContextError("Another transaction is already sending (sendtx_broadcast_lock taken)", function_id)
		}

		const tokenID = this.get_selected_coin_props().tokenid
		const tokenActionID = tokenID + "_mint"  // or "mint_delphe" ?

		nb_to_mint = parseFloat(nb_to_mint)  // for "1.00" or similar

		const specific_state = {
			"nbtokens": nb_to_mint,
		}
		await this.txStateContext.init_action(
			function_id, tokenActionID, specific_state
		)
		log("BUILDING TX to mint", nb_to_mint, " tokenActionID=", tokenActionID)

		try {
			var myrun = await this.runContext.get_run_asyncf()
			this.clear_run_caches(myrun) // force fresh fetch/spends lookups for this critical tx
			var MyToken = await this.get_tokenoriginjig()

			// sync only the token contract — NOT the full wallet inventory.
			// the wallet is already synced from startup/reload.
			this.txStateContext.setTxState(tokenActionID, { step: "syncing_contract" })
			await MyToken.sync()

			const totalmults = await this.get_total_mult()

			var pre_mult_tomint = nb_to_mint / totalmults * Math.pow(10, MyToken.decimals)
			pre_mult_tomint = parseInt(pre_mult_tomint)  // MUST PARSE TO INT TO MINT = amount!!

			pre_mult_tomint = pre_mult_tomint + 1  // to avoid minting 999.99 instead of 1000.00

			log("nb_to_mint =", nb_to_mint)
			log("totalmultiplicators =", totalmults)
			log("decimals display =", MyToken.decimalsDisplay)
			log("actual decimals =", MyToken.decimals)
			log("pre_mult_tomint =", pre_mult_tomint)

			this.txStateContext.setTxState(tokenActionID, { step: "broadcasting" })
			log("MyToken.sync()...")
			await MyToken.sync()  // sync supply and nonce because mint will use them

			log("MyToken.mint(...) ...")
			const mintedCoins = MyToken.mint(pre_mult_tomint, Date.now())  // for run 0.6

			this.txStateContext.setTxState(tokenActionID, { step: "checking_success" })
			log("minted, now syncing...")
			await mintedCoins.sync()  // update them to the wallet

			log("mint success, mintedCoins.location=", mintedCoins.location)

			this.txStateContext.setTxState(tokenActionID, { step: "done" })
			this.txStateContext.sendtx_deal_with_success(
				function_id, tokenActionID,  // currtx_state,
				mintedCoins.location, 0, // bsvfee=0 → skip blocking fee calc
				{}, () => {
					// background (non-blocking): calculate fee + refresh balance/history
					(async () => {
						try {
							const txhash = mintedCoins.location.split("_")[0]
							const real_bsvfee = await this.txStateContext._calculate_fees_for_onchain_runtx
								? this.txStateContext._calculate_fees_for_onchain_runtx(txhash)
								: null
							if (real_bsvfee != null) {
								this.txStateContext.setTxState(tokenActionID, { bsvfee: real_bsvfee })
							}
						} catch (e) {
							console.error(function_id + "background fee calculation failed (non-critical): " + e)
						}
						try { await this.get_token_balance() } catch (e) { /* non-critical */ }
						try { await this.get_tx_history() } catch (e) { /* non-critical */ }
					})()
				}
			)
		}
		catch (error) {
			return this.txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID,
				error, "Erreur lors de la construction de la transaction: ",
				{}, () => { this.syncWallet_nForceRerender() }
			)
		}
	}


	sendtx_BSV = async (sendto_address, nbsatoshis, test_txfailtoload = false, test_broadcastfails = false, send_all = false) => {
		const function_id = this.classname + "sendtx_BSV(): "
		const log = getLog(function_id)

		if (nbsatoshis <= 0 && !send_all) return
		if (this.sendtx_broadcast_lock) {
			this.throwContextError("Another transaction is already sending (sendtx_broadcast_lock taken)", function_id)
		}

		const tokenID = "bsv"
		const tokenActionID = tokenID + "_send"  // or "send_bsv" ?

		const sendsatoshis = parseInt(nbsatoshis)

		const specific_state = {
			"nbsatoshis": send_all ? 0 : sendsatoshis,
			"sendto_address": sendto_address,
			"send_all": send_all,
		}
		this.txStateContext.init_action(
			function_id, tokenActionID, specific_state
		)

		log("BUILDING BSV_TX to send", send_all ? "ALL" : nbsatoshis, "satoshis to", sendto_address)

		// remove the prefix if needed
		if (sendto_address.split(":").length > 1) {
			sendto_address = sendto_address.split(":")[1]
		}

		var bsvfee = null
		try {
			if (test_txfailtoload) {
				this.sendtx_broadcast_lock = false
				throw new Error("test_txfailtoload")
			}
			var myrun = await this.runContext.get_run_asyncf()
			await myrun.sync()

			const purse_balance = await myrun.purse.balance()
			log("\n sendto_address=", sendto_address,
				"\n sendsatoshis=", send_all ? "ALL" : sendsatoshis,
				"\n myrun.purse.address=", myrun.purse.address,
				"\n myrun.purse.balance=", purse_balance)

			// check balance
			const balancebsv = this.state.balance_bsv
			if (balancebsv == null || balancebsv <= 0) {
				var error_bal = new NotEnoughBSVError(send_all ? purse_balance : sendsatoshis, balancebsv || 0)
				this.throwContextError(error_bal, function_id)
			}

			// determine the output amount
			var outputSatoshis
			if (send_all) {
				// estimate the fee by building a throwaway draft tx funded with all UTXOs
				const draftUtxos = await myrun.purse.utxos()
				const drafttx = new bsv.Transaction()
					.from(draftUtxos)
					.to(sendto_address, purse_balance)
					.change(myrun.purse.address)
					.sign(myrun.purse.privkey)
				bsvfee = drafttx.getFee()
				outputSatoshis = parseInt(purse_balance - bsvfee)
				log("send_all: purse_balance=", purse_balance, "estimatedFee=", bsvfee, "outputSatoshis=", outputSatoshis)
				if (outputSatoshis <= 0) {
					let error_small = new BSVTooSmallSendAmountError(purse_balance, bsvfee)
					this.throwContextError(error_small, function_id)
				}
			} else {
				outputSatoshis = sendsatoshis
				if (balancebsv < sendsatoshis) {
					var error_notenough = new NotEnoughBSVError(sendsatoshis, balancebsv)
					this.throwContextError(error_notenough, function_id)
				}
				// estimate fee for display (draft tx, never broadcast)
				const draftUtxos = await myrun.purse.utxos()
				const drafttx = new bsv.Transaction()
					.from(draftUtxos)
					.to(sendto_address, sendsatoshis)
					.change(myrun.purse.address)
					.sign(myrun.purse.privkey)
				bsvfee = drafttx.getFee()
			}

			this.txStateContext.setTxState(tokenActionID, { "bsvfee": bsvfee })

			try {
				if (test_broadcastfails) {
					this.sendtx_broadcast_lock = false
					throw new Error("test_broadcastfails")
				}

				// build the tx with only the output — purse.pay() will fund it
				// (select UTXOs, add change, sign) and keep the purse's internal
				// UTXO cache consistent. This avoids the txn-mempool-conflict bug
				// where the purse reused UTXOs already spent by an unconfirmed tx.
				var bsvtx = new bsv.Transaction().to(sendto_address, outputSatoshis)
				log("paying & broadcasting BSV TX (pre-pay hash=", bsvtx.hash, ")")

				const paidRawTx = await myrun.purse.pay(bsvtx.toString('hex'))
				const txid = await myrun.purse.broadcast(paidRawTx)

				// purse.broadcast() returns undefined (Run SDK LocalPurse.broadcast has no return
				// value), so compute the txid from the paid rawtx ourselves.
				const final_txid = (txid || new bsv.Transaction(paidRawTx).hash)
				log("broadcast success", final_txid)
				this.sendtx_broadcast_lock = false

				// update status
				this.txStateContext.setTxState(tokenActionID, {
					"bsvfee": bsvfee,
					"hash": final_txid,
					"status": sendtx_status.sentsuccess,
					"nbsatoshis": outputSatoshis,
				})

				// inject the just-broadcast tx into the BSV history cache so it
				// shows up immediately, even before WoC indexes it in the address
				// history (which can lag for unconfirmed txs). When WoC eventually
				// indexes it, processOneTxData will enrich it properly and the
				// dedup-by-tx_hash in cache_history_bsv prevents duplicates.
				// prepend=true puts it at the front so it appears in the display
				// window (which slices from the beginning). We also inject into
				// the raw list so the tx count stays consistent.
				const is_self_send_bsv = (sendto_address === myrun.purse.address)
				this.cache_history_bsv([{
					tx_hash: final_txid,
					time: Date.now(),
					action: is_self_send_bsv ? "send_to_yourself" : "send",
					value_bsv: parseFloat((outputSatoshis / 1e8).toFixed(8)),
					...(is_self_send_bsv ? {} : { receiver: sendto_address }),
				}], true)  // prepend=true

				// also inject into the raw list so nbloaded stays consistent
				if (this.data_cache_history_bsv_raw) {
					this.data_cache_history_bsv_raw = [{
						tx_hash: final_txid,
						height: 0,  // unconfirmed
					}].concat(this.data_cache_history_bsv_raw)
				}

				this.syncWallet_nForceRerender()
			}
			catch (error) {
				return this.txStateContext.deal_with_error_RETURN(
					function_id, tokenActionID,
					error, "Erreur lors de l'envoi de la transaction: ",
					{}, () => { this.syncWallet_nForceRerender() }
				)
			}
		} catch (error) {
			return this.txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur lors de la construction de la transaction: ",
				{}, () => { this.syncWallet_nForceRerender() }
			)
		}
	}



	sendtx_Token = async (send_tokenAddress, send_nbtokens, test_txfailtoload = false, test_broadcastfails = false) => {
		const function_id = this.classname + "sendtx_Token(): "
		const log = getLog(function_id)

		// TODO make mult-micontract by passing & using tokenID, token_contract_origin, etc...
		const tokenID = this.get_selected_coin_props().tokenid
		const tokenActionID = tokenID + "_send"  // or "send_delphe" ?

		if (send_nbtokens <= 0) return
		if (this.sendtx_broadcast_lock) {
			this.throwContextError("Another transaction is already sending (sendtx_broadcast_lock taken)", function_id)
		}

		const specific_state = {
			"nbtokens": send_nbtokens,
			"sendto_address": send_tokenAddress,
		}
		this.txStateContext.init_action(
			function_id, tokenActionID, specific_state
		)
		log("BUILDING TOKEN_TX to send", send_nbtokens,
			"tokens (tokenActionID=", tokenActionID, ") to", send_tokenAddress)

		// remove the prefix if needed
		if (send_tokenAddress.split(":").length > 1) {
			send_tokenAddress = send_tokenAddress.split(":")[1]
		}

		try {
			if (test_txfailtoload) {
				this.sendtx_broadcast_lock = false
				throw new Error("test_txfailtoload")
			}

			var myrun = await this.runContext.get_run_asyncf()
			this.clear_run_caches(myrun) // force fresh fetch/spends lookups for this critical tx
			var MyToken = await this.get_tokenoriginjig()

			// sync only the token contract — NOT the full wallet inventory.
			// the wallet is already synced from startup/reload, and the blockchain will
			// throw a UTXO error if the inputs are already spent. removing inventory_sync()
			// and myrun.sync() here saves several seconds per send.
			// MyToken.sync() is needed to access .blacklist in get_utxos_for_nbtokens().
			this.txStateContext.setTxState(tokenActionID, { step: "syncing_contract" })
			await MyToken.sync()

			// calculate the amount from the nbtokens (value to amount)
			// reminder: we must send the right amount without mults

			this.txStateContext.setTxState(tokenActionID, { step: "finding_utxos" })
			var delphe_nbsend = send_nbtokens
			// skip_sync=true: read jigs from already-synced inventory instead of re-syncing
			// all ~30 jigs. only the selected jigs (1 for no-combine) will be synced inside.
			var get_utxos_for_nbtokens = await this.get_utxos_for_nbtokens(delphe_nbsend, true)

			//blacklist is already synced in get_utxos_for_nbtokens()
			var tokenstosend_jigstocombine = get_utxos_for_nbtokens[0]
			var amount_to_send = get_utxos_for_nbtokens[1]

			// run.transaction.begin() // wait for end() before broadcasting // TODO BEWARE YOU *MUST* ROLLBACK ON ALL ERRORS, THROW,RETURN OTHERWISE YOU GET "bad number of jigs x != y" error

			// combine tokens
			var combinedtokens = undefined
			if (tokenstosend_jigstocombine.length >= 2) {
				log("combining tokens to send...")
				Run.util.unify(MyToken, ...tokenstosend_jigstocombine)
				combinedtokens = new MyToken(Date.now(), ...tokenstosend_jigstocombine)
				// console.log(function_id+"after combine, combinedtokens = "+deepcopy(combinedtokens)) // don't log jigs for prod or bugs
			
				log("combinedtokens.sync() ...")
				await combinedtokens.sync()
				await myrun.sync()
				log("combinedtokens at " + combinedtokens.location)
			} else {
				log("no need to combine tokens to send")
				combinedtokens = tokenstosend_jigstocombine[0]
				// console.log(function_id+"no need to combine to send, send token : "+deepcopy(combinedtokens)) // don't log jigs for prod => bugs
			}

			try {
				if (test_broadcastfails) {
					this.sendtx_broadcast_lock = false
					throw new Error("test_broadcastfails")
				}

				this.txStateContext.setTxState(tokenActionID, { step: "broadcasting" })
				log("broadcasting TX to the BSV network (", this.context.network, ") to send ",
					amount_to_send, "tokens to", send_tokenAddress)

				// combinedtokens.send() broadcasts the tx via the RUN SDK internally.
				// remainingtokens.sync() confirms the tx was accepted (state loads via WoC
				// fallback if the node is down). retry a few times in case the tx takes a
				// moment to propagate.
				var remainingtokens = combinedtokens.send(
					send_tokenAddress, Date.now(), amount_to_send
				)  // corresponds to: address, timestamp, amount

				this.txStateContext.setTxState(tokenActionID, { step: "checking_success" })
				await retry(() => remainingtokens.sync(), {
					retries: 3,
					minTimeout: 500,
					maxTimeout: 2000,
					factor: 2,
				})

				log("broadcast success !",
					"\n combinedtokens  = \n", combinedtokens.location,
					"\n remainingtokens = \n", remainingtokens.location,
				)

				// show success immediately with bsvfee=0 (skip blocking fee calculation).
				// the real fee is calculated in the background below and updates the display.
				this.txStateContext.setTxState(tokenActionID, { step: "done" })
				this.txStateContext.sendtx_deal_with_success(
					function_id, tokenActionID,
					remainingtokens.location, 0, // bsvfee=0 → skip blocking _calculate_fees_for_onchain_runtx
					{}, () => {
						// make an instant update for visual feedback
						if (send_tokenAddress !== this.state.address_owner) {
							let new_token_balance = this.state.tokens_balance[tokenID] - send_nbtokens
							this.setState_update_token_balance(tokenID, new_token_balance)
						}
						// background (non-blocking): calculate the real fee and refresh balance/history.
						// these don't block the success message — they update the display a moment later.
						(async () => {
							try {
								// calculate the real fee and update the tx state so the success
								// display shows it
								const txhash = remainingtokens.location.split("_")[0]
								const real_bsvfee = await this.txStateContext._calculate_fees_for_onchain_runtx
									? this.txStateContext._calculate_fees_for_onchain_runtx(txhash)
									: null
								if (real_bsvfee != null) {
									this.txStateContext.setTxState(tokenActionID, { bsvfee: real_bsvfee })
								}
							} catch (e) {
								console.error(function_id + "background fee calculation failed (non-critical): " + e)
							}
							// refresh balance and history in the background
							try { await this.get_token_balance() } catch (e) { /* non-critical */ }
							try { await this.get_tx_history() } catch (e) { /* non-critical */ }
						})()
					}
				)
			}
			catch (error) {
				console.error(error)
				return this.txStateContext.deal_with_error_RETURN(
					function_id, tokenActionID, error,
					"Erreur lors de l'envoi de la transaction: ",
					{}, () => { this.syncWallet_nForceRerender() }
				)
			}
		}
		catch (error) {
			console.error(error)
			return this.txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur lors de la construction de la transaction: ",
				{}, () => { this.syncWallet_nForceRerender() }
			)
		}
	}



	ownerIsAdmin = async () => {
		var function_id = this.classname + "ownerIsAdmin(): "
		const log = getLog(function_id)

		var run = await this.runContext.get_run_asyncf()
		// it's better to get the same jig than reload it to limit tx-mempool-conflict
		var MyToken = await this.get_tokenoriginjig()

		const ownerIsAdmin = (run.owner.address === MyToken.owner)
		log("ownerIsAdmin=", ownerIsAdmin)

		this.setState({ ownerIsAdmin: ownerIsAdmin })
		return ownerIsAdmin
	}



	get_history_loading_progress = () => {
		const function_id = this.classname + "get_history_loading_progress(): "
		const log = getLog(function_id)

		log("\n wallet history: nbloaded = " + this.history_nbloaded + " / " + this.history_size)

		if (this.history_size == null || this.history_nbloaded == null) {
			return { nbloaded: null, size: null }
		}

		return {
			nbloaded: this.history_nbloaded,
			size: this.history_size
		}
	}


	/**
	 * Burns all tokens
	 */
	burn_tokens_all = async () => {
		// const function_id = this.classname+"burn_tokens_all(): "
		// const log=(...args)=>{console.log(function_id,...args)}
		var res = await this.burn_tokens()
		return res
	}


	/**
	 * Burns all remaining tokens and returns the number of tokens burnt
	 * @param nbtoburn ex: 0.000001 (not limited to 2 decimals which is right for this function !)
	 */
	burn_tokens = async (nbtoburn = false) => {
		const function_id = this.classname + "burn_tokens(): "
		const log = getLog(function_id)

		const tokenID = this.get_selected_coin_props().tokenid
		const tokenActionID = tokenID + "_burn"

		var ownerIsAdmin = await this.ownerIsAdmin()
		if (!ownerIsAdmin) {
			// throw new ContextError(function_id, "Error: only the administrator can use this function")
			this.throwContextError("Error: only the administrator can use this function", function_id)
		}

		const specific_state = {
			"nbtoburn": nbtoburn,
		}
		this.txStateContext.init_action(
			function_id, tokenActionID, specific_state
		)

		var burned_nbtokens = nbtoburn
		var combined_amount, totalmultiplicators, decimals, combined_nbtokens
		try {
			var MyToken = await this.get_tokenoriginjig()
			this.txStateContext.setTxState(tokenActionID, { step: "syncing_contract" })
			await MyToken.sync()
			decimals = MyToken.decimals

			var run = await this.runContext.get_run_asyncf()
			this.clear_run_caches(run) // force fresh fetch/spends lookups for this critical tx

			totalmultiplicators = await this.get_total_mult()

			// assume wallet inventory is already synced from startup — read jigs directly
			// instead of calling inventory_sync() + get_all_tokenJigs() (which syncs all jigs).
			let jigs = this.getJigs(run)
			var tokenstoburn_alljigs = jigs.filter(jig =>
				jig.constructor.origin === this.state.tokenorigin && jig.amount > 0
			)

			log("tokenstoburn_alljigs = ", tokenstoburn_alljigs)

			if (tokenstoburn_alljigs.length === 0) {
				// throw on purpose to catch below
				throw new Error("0 tokens trouvés sur ce portefeuille.")
			}
		}
		catch (error) {
			return this.txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur lors de la construction de la transaction: ",
				{}, () => { this.syncWallet_nForceRerender() }
			)
		}

		try {
			this.txStateContext.setTxState(tokenActionID, { step: "broadcasting" })
			var combinedtoken = undefined
			if (tokenstoburn_alljigs.length >= 2) {
				log("combining tokens to burn")

				// TODO instad of combining all we must combine only what's needed

				combinedtoken = new MyToken(Date.now(), ...tokenstoburn_alljigs)  // for run 0.6 
			} else {
				log("no need to combine tokens to burn")
				combinedtoken = tokenstoburn_alljigs[0]
			}

			log("combinedtoken.sync() ...")
			await combinedtoken.sync()

			combined_amount = combinedtoken.amount

			// don't reduce to 2 decimals in this specific case!
			combined_nbtokens = combined_amount * totalmultiplicators * Math.pow(10, -1 * decimals)

			log("> Number of UTXOs of tokens to burn=", tokenstoburn_alljigs.length,
				"combined_nbtokens=", combined_nbtokens,
				"combined_amount=", combined_amount,
				"reminder: nbtoburn=", nbtoburn)

			Run.util.unify(MyToken, combinedtoken)

			if (nbtoburn) {
				const amount_nbtoburn = await this.nbtokens_to_amount(nbtoburn)
				log("burning partially, amount_nbtoburn=", amount_nbtoburn, " for combined_nbtokens=", combined_nbtokens)
				MyToken.burn(Date.now(), combinedtoken, amount_nbtoburn)
			}
			else {  // burn all
				burned_nbtokens = combined_nbtokens
				log("burning all utxos, combined_nbtokens=", combined_nbtokens)
				MyToken.burn(Date.now(), combinedtoken)  // no amount given => burn all (full amount)
			}

			this.txStateContext.setTxState(tokenActionID, { step: "checking_success" })
			await combinedtoken.sync()

			log("burning success ! with nbtoburn=", nbtoburn)
		}
		catch (error) {
			return this.txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur lors de l'envoi de la transaction: ",
				{}, () => { this.syncWallet_nForceRerender() }
			)
		}

		this.txStateContext.setTxState(tokenActionID, { step: "done" })
		this.txStateContext.sendtx_deal_with_success(
			function_id, tokenActionID,
			combinedtoken.location, 0, // bsvfee=0 → skip blocking fee calc
			{},
			() => {
				// background (non-blocking): calculate fee + refresh supply/balance/history
				(async () => {
					try {
						const txhash = combinedtoken.location.split("_")[0]
						const real_bsvfee = await this.txStateContext._calculate_fees_for_onchain_runtx
							? this.txStateContext._calculate_fees_for_onchain_runtx(txhash)
							: null
						if (real_bsvfee != null) {
							this.txStateContext.setTxState(tokenActionID, { bsvfee: real_bsvfee })
						}
					} catch (e) {
						console.error(function_id + "background fee calculation failed (non-critical): " + e)
					}
					try { await this.getTokenSupply() } catch (e) { /* non-critical */ }
					try { await this.get_token_balance() } catch (e) { /* non-critical */ }
					try { await this.get_tx_history() } catch (e) { /* non-critical */ }
				})()
			}
		)

		return burned_nbtokens
	}


	getTokenSupply = async () => {
		const function_id = this.classname + "getTokenSupply(): "
		const log = getLog(function_id)

		log("starting")

		this.setState({ tokensupply: 0 })  // reset value

		// retrieve supply in amount
		// note: tokenoriginjig.supply is wrong (because some coins have/can be burned by becoming invalid)
		// so we implement a supply in the node that computes based on valid UTXOs & this is the one we should use
		let supply_amount
		try {
			// TODO this should be done in a specific class to allow handing the node(s) more freely
			const fetch_url = TOKKENR_NODE_HOST_URL + "/token/status/" + this.state.tokenorigin
			let res = await fetch(fetch_url, { timeout: 8000 })
			res = await res.json()
			supply_amount = res.supply_amount
		log("supply_amount (from node):", supply_amount, "at", fetch_url)
		}
		catch (error) {
			this.throwContextError(error, function_id + ".0.5 :")
		}

		// retrieve total mult and decimals

		let totalmult = 1.0, tokenoriginjig = null
		try {
			totalmult = await this.get_total_mult()
			log("totalmult = ", totalmult)
			// it's better to get the same jig than reload it to limit tx-mempool-conflict
			// Use freshness-aware sync: reload_all_contracts just synced with inner:true
			// a few ms ago, so this will usually skip the redundant sync().
			tokenoriginjig = await this.sync_tokenoriginjig_if_stale(5000, { inner: SYNC_INNER })
		}
		catch (error) {
			this.throwContextError(error, function_id + ".1 :")
		}
		log("totalmult:", totalmult)

		if (supply_amount === 0) {
			// call to node may have failed (=token not indexed) so we fallback
			supply_amount = tokenoriginjig.supply
			log("fallback supply from supply_amount:", supply_amount)
		}

		let decimals, decimalsDisplay
		try {
			decimals = tokenoriginjig.decimals
			decimalsDisplay = tokenoriginjig.decimalsDisplay
			if (!decimalsDisplay) {
				console.error(functison_id + ": decimalsDisplay not found in tokenoriginjig at " + tokenoriginjig.origin)
				decimalsDisplay = 2 // default
			}
		} catch (error) {
			// throw as RunError because we don't call other this.functions but only do run operations
			this.throwRunError(error, function_id + ".2 :")
			return
		}

		// now we convert from amount to delphe value

		// const supply_amount = tokenoriginjig.supply  // old version
		// var supplydelphes = parseFloat(tokenoriginjig.supply / Math.pow(10, decimals))  // old version

		let supplyTokens = parseFloat(supply_amount / Math.pow(10, decimals))  // new version from node
		supplyTokens = toFixedDown((supplyTokens * totalmult), decimalsDisplay)
		log("supplyTokens:", supplyTokens)

		if (isNaN(supplyTokens)) {
			throw new Error(function_id + " supplyTokens is NaN: " + supplyTokens)
		}

		this.setState({ tokensupply: supplyTokens })

		return supplyTokens
	}



	clearCache = async (RUNcache_filepath = "") => {
		const function_id = this.classname + "clearCache(): "

		if (!this.wallet_history_cache) {
			throw new Error(function_id + " no wallet_history_cache found")
		}
		this.wallet_history_cache.clearCache()

		// also wipe the BSV history caches so the "Erase cache" button forces a
		// full recompute of BSV history too: IndexedDB enriched-tx cache +
		// localStorage raw-list snapshot. The in-memory caches are reset
		// separately by reset_cache_history_bsv() in the button handler.
		if (this.bsv_history_cache) {
			await this.bsv_history_cache.clear()
		}

		// Wipe the unified per-wallet localStorage cache blob (balances +
		// bsvrawhistory + tokenSpecifics/mintuples). A single removeItem
		// replaces the former two separate removeItem calls.
		const cache_key = this._wallet_cache_storage_key()
		if (cache_key) {
			try { localStorage.removeItem(cache_key) } catch (e) { /* non-critical */ }
		}

		// TODO supprimer le fichier de cache sur le disque 
		if (RUNcache_filepath) {

		}
		// TODO supprimer le cache du browser RUN (même en mode production)
	}



	render() {
		return (
			<UserContext.Provider value={this.state}>
				{this.props.children}
			</UserContext.Provider>
		)
	}
}







export class NotEnoughTokensError extends Error {
	// beware before changing => this is parsed in translateErrorMessage.js
	constructor(amount_to_send, totalamount, totalmultiplicators) {
		super();
		this.name = "NotEnoughTokensError";
		this.amount_to_send = amount_to_send
		this.totalamount = totalamount
		this.totalmultiplicators = totalmultiplicators
		this.token_nbsend = toFixedDown(parseFloat(amount_to_send / 1e8 * totalmultiplicators), 2)
		this.token_totalowned = toFixedDown(parseFloat(totalamount / 1e8 * totalmultiplicators), 2)
	}
	toString() {
		// beware before changing this is parsed in translateErrorMessage.js
		return this.name + ":" + toFixedDown(parseFloat(this.token_nbsend), 2)
			+ "/" + toFixedDown(parseFloat(this.token_totalowned), 2)
			+ ": (" + this.amount_to_send + " / " + this.totalamount + ")"
	}
}




async function simulate_loadingtime() {
	//simulates a long loading & syncing time, useful
	if (simulatelongloadingtime > 0) {
		var wait = ms => new Promise((r, j) => setTimeout(r, ms))
		await wait(simulatelongloadingtime)
	}
}




/**
 * Adds the previous output information for each input to sign and verify the transaction.
 * @param {bsv.Transaction} tx Tx to modify
 * @param {Blockchain} blockchain Blockchain to fetch inputs
 *
 * this can for example be used to populate the inputAmount to get the bsv fee of a tx
 */
export async function populatePreviousOutputs(tx, blockchain) {
	const function_id = "populatePreviousOutputs(): "
	console.log(function_id + "tx = ", tx, "\n bsv = ", bsv)
	try {
		for (let i = 0; i < tx.inputs.length; i++) {
			const input = tx.inputs[i]
			if (!input.output) {
				const prevtxid = input.prevTxId.toString('hex')
				const prevraw = await blockchain.fetch(prevtxid)
				const prevtx = new bsv.Transaction(prevraw)
				// Add the output, which gives us the script and satoshis
				input.output = prevtx.outputs[input.outputIndex]
				// Set the type of the input if we can determine it.
				// Run doesn't require this to work but it may help users.
				if (input.output.script.isPublicKeyHashOut()) {
					Reflect.setPrototypeOf(input, bsv.Transaction.Input.PublicKeyHash.prototype)
				}
			}
		}
	} catch (error) {
		throw new Error("Error in populatePreviousOutputs(): " + error)
	}
}



/*
	get_store_WalletHistoryCache(owneraddress+"_walletBackup") // will return null if not in production

	filestore.get("walletname")
	filestore.get("filecreationdate")
	filestore.get("encrypted_mnemonic")

	filestore.set(key, value)

	filestore.store => get all keys & values
*/
/**
 * will save an encrypted wallet to the local app path cache for faster future opening
 */
export function save_localcache_encrypted_wallet_backup(owneraddress, encrypted_wallet_data) {
	const function_id = "save_localcache_encrypted_wallet_backup(): "

	if (!owneraddress) throw new Error(function_id + "owneraddress is empty")

	var filename = owneraddress + "_walletBackup"
	console.log(function_id, "filename = ", filename)

	if (typeof encrypted_wallet_data == "string") {
		encrypted_wallet_data = JSON.parse(encrypted_wallet_data)
	}
	encrypted_wallet_data.owner_address = owneraddress
	encrypted_wallet_data.last_saved = Date.now() // timestamp

	var filestore = get_store_WalletHistoryCache(filename)
	filestore.set("data", encrypted_wallet_data)
}



/**
*	finds the app path and list all the files in the cache that contain "_walletBackup" in their name
*/
export function get_all_wallet_backups_from_localcache() {
	const function_id = "get_all_wallet_backups_from_localcache(): "
	const log = getLog(function_id)

	const isDevMode = !isElectron()
	if (isDevMode) return devMode_fake_walletBackups

	let files = get_all_files_paths_from_cache("_walletBackup")
	log("files =", files)

	try {
		// now we open each file and extract the name, date and other info from it
		var i = 0
		files = files.map((file) => {
			// remove extension at the end
			// var filename = ""+file.split('.').slice(0,-1).join('.')
			var filename = "" + file.split('.')[0]

			var filestore = get_store_WalletHistoryCache(filename)

			log("filestore " + i + " for file: ", filename, ":\n data=", filestore.get('data'))
			i++
			var data = filestore.get('data')
			data.filename = filename
			if (!data.hasOwnProperty("last_saved")) data.last_saved = data.filecreationtimestamp || 0
			return data
		})
	}
	catch (e) {
		console.error(function_id, "error getting wallet backups ", e)
		return files
	}

	files.sort((x, y) => x.last_saved - y.last_saved)
	return files
}



/**
 * specific code to clean the 2 wrong mintuples from the delphe mistake of 01/10/2022 (where 3 instead of 1 were sent: 2x + correction)
 * this can work both for mintuples but also their timestamps
 * it basically removes index 24 & 25 (since they cancel each other)
 */
function clean_mistake_01102022(_multlist) {
	return _multlist.slice(0, 24).concat(_multlist.slice(26))
}

